"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LABEL = void 0;
// Do not edit manually!!
// When editing, edit 40_data/locales/resources.js
// It is generated automatically when you edit and save resources.js

const LABEL = exports.LABEL = {
  /** 言語設定(Language) */
  CORE_LANGUAGE_SETTING: 'label.core.language_setting',
  /** 文字サイズ変更 */
  CORE_FONT_SIZE: 'label.core.font_size',
  /** ホーム */
  CORE_HOME: 'label.core.home',
  /** ホームへ戻る */
  CORE_TO_RETURN_HOME: 'label.core.to_return_home',
  /** 検索一覧へ戻る */
  CORE_TO_RETURN_SEARCH_LIST: 'label.core.to_return_search_list',
  /** 履歴一覧へ戻る */
  CORE_TO_RETURN_HISTORY_LIST: 'label.core.to_return_history_list',
  /** OK */
  CORE_OK: 'label.core.ok',
  /** キャンセル */
  CORE_CANCEL: 'label.core.cancel',
  /** 保存 */
  CORE_SAVE: 'label.core.save',
  /** 確認 */
  CORE_CONFIRM: 'label.core.confirm',
  /** ヘルプ */
  CORE_HELP: 'label.core.help',
  /** 未登録 */
  CORE_NOT_REGISTERED: 'label.core.not_registered',
  /** 登録 */
  CORE_REGISTER: 'label.core.register',
  /** 更新 */
  CORE_UPDATE: 'label.core.update',
  /** 変更 */
  CORE_MODIFY: 'label.core.modify',
  /** 選択 */
  CORE_SELECT: 'label.core.select',
  /** 削除 */
  CORE_DELETE: 'label.core.delete',
  /** 一時保存 */
  CORE_TEMP_STORE: 'label.core.temp_store',
  /** ファイル追加 */
  CORE_ADD_FILE: 'label.core.add_file',
  /** {0}削除 */
  CORE_DELETE_ANY: 'label.core.delete_any',
  /** {0}追加 */
  CORE_ADD_ANY: 'label.core.add_any',
  /** 必須 */
  CORE_REQUIRED: 'label.core.required',
  /** 入力してください。 */
  CORE_REQUIRED_MESSAGE: 'label.core.required_message',
  /** {0}を入力してください。 */
  CORE_REQUIRED_ITEM_MESSAGE: 'label.core.required_item_message',
  /** {0}を指定してください。 */
  CORE_SPECIFY_MESSAGE: 'label.core.specify_message',
  /** 半角数字か、入力例の形式で入力してください。 */
  CORE_FLOOR_MESSAGE: 'label.core.floor_message',
  /** 該当の{0}を指定することはできません。 */
  CORE_NOT_SPECIFIED_MESSAGE: 'label.core.not_specified_message',
  /** {0}文字以内で入力してください。 */
  CORE_LENGTH_MESSAGE: 'label.core.length_message',
  /** {0}は{1}文字以内で入力してください。 */
  CORE_LENGTH_WITHIN_MESSAGE: 'label.core.length_within_message',
  /** {0}文字以上で入力してください。 */
  CORE_LENGTH_MIN_MESSAGE: 'label.core.length_min_message',
  /** {0}は{1}文字以上で入力してください。 */
  CORE_LENGTH_LEAST_MESSAGE: 'label.core.length_least_message',
  /** 文字「{0}」は使用できません。 */
  CORE_NOT_ALLOWED_CHARACTER: 'label.core.not_allowed_character',
  /** {0}に半角英数字以外の文字が含まれています。 */
  CORE_CONTAINS_NON_ALPHANUMERIC_MESSAGE: 'label.core.contains_non_alphanumeric_message',
  /** 使用することができない文字が含まれています。 */
  CORE_CANNOT_USE_CHAR_MESSAGE: 'label.core.cannot_use_char_message',
  /** 必ず英字と数字を混在させたものを指定してください。 */
  CORE_MIX_MESSAGE: 'label.core.mix_message',
  /** {0}が正しくありません。 */
  CORE_INCORRECT_MESSAGE: 'label.core.incorrect_message',
  /** {0}に不正な値が入力されています。 */
  CORE_ENTER_INVALID_MESSAGE: 'label.core.enter_invalid_message',
  /** {0}はすでに登録されています。 */
  CORE_ALREADY_REGISTERED_MESSAGE: 'label.core.already_registered_message',
  /** 入力内容を確認してください。 */
  CORE_VALIDATE_MESSAGE: 'label.core.validate_message',
  /** 以下の内容で登録しました。 */
  CORE_REGISTERED_MESSAGE: 'label.core.registered_message',
  /** 以下の内容で更新しました。 */
  CORE_UPDATED_MESSAGE: 'label.core.updated_message',
  /** 以下の内容を削除しました。 */
  CORE_DELETED_MESSAGE: 'label.core.deleted_message',
  /** 入力内容を全てクリアします。よろしいですか？ */
  CORE_CLEAR_CONFIRM_MESSAGE: 'label.core.clear_confirm_message',
  /** この内容で登録します。よろしいですか？ */
  CORE_REGISTER_CONFIRM_MESSAGE: 'label.core.register_confirm_message',
  /** CSVデータ不正により登録できなかったデータの該当行、エラー内容は以下の通りです。 */
  CORE_CSV_REGISTER_ERRINFO_MESSAGE: 'label.core.csv_register_errinfo_message',
  /** CSVデータ形式が不正です。 */
  CORE_CSV_FORMAT_ERROR_MESSAGE: 'label.core.csv_format_error_message',
  /** この内容で更新します。よろしいですか？ */
  CORE_UPDATE_CONFIRM_MESSAGE: 'label.core.update_confirm_message',
  /** この内容を削除します。よろしいですか？ */
  CORE_DELETE_CONFIRM_MESSAGE: 'label.core.delete_confirm_message',
  /** この内容で設定します。よろしいですか？ */
  CORE_SETTING_CONFIRM_MESSAGE: 'label.core.setting_confirm_message',
  /** この内容で一時保存します。よろしいですか？ */
  CORE_TEMPORARILY_SAVED_CONFIRM_MESSAGE: 'label.core.temporarily_saved_confirm_message',
  /** {0}を一時保存しました。 */
  CORE_TEMP_STORE_MESSAGE: 'label.core.temp_store_message',
  /** 検索条件に一致する情報がありません。 */
  CORE_NO_SEARCH_RESULT_MESSAGE: 'label.core.no_search_result_message',
  /** 通信に失敗しました。 */
  CORE_CONNECTION_ERROR_MESSAGE: 'label.core.connection_error_message',
  /** ファイルが見つかりません。 */
  CORE_FILE_NOT_FOUND_MESSAGE: 'label.core.file_not_found_message',
  /** ファイルが存在しないか、または空のファイルです。 */
  CORE_EMPTY_FILE_MESSAGE: 'label.core.empty_file_message',
  /** 選択してください。 */
  CORE_PLEASE_SELECT: 'label.core.please_select',
  /** {0}を選択してください。 */
  CORE_PLEASE_SELECT_REPLACE: 'label.core.please_select_replace',
  /** キーワードを入力してください。 */
  CORE_PLEASE_ENTER_KEYWORD: 'label.core.please_enter_keyword',
  /** キーワードに一致する項目がありません。 */
  CORE_NO_ITEM_MATCH: 'label.core.no_item_match',
  /** {0}と一致しません。 */
  CORE_NO_MATCH: 'label.core.no_match',
  /** 半角数字で入力してください。 */
  CORE_ENTER_HALF_NUMERIC: 'label.core.enter_half_numeric',
  /** {0}以上の数値で入力してください。 */
  CORE_VALUE_LEAST_MESSAGE: 'label.core.value_least_message',
  /** {0}～{1}の値を入力してください。 */
  CORE_ENTER_VALUE_BETWEEN: 'label.core.enter_value_between',
  /** お問い合わせ */
  CORE_CONTACT_US: 'label.core.contact_us',
  /** マニュアル */
  CORE_MANUAL: 'label.core.manual',
  /** FAQ */
  CORE_FAQ: 'label.core.faq',
  /** 設定 */
  CORE_CONFIGURATION: 'label.core.configuration',
  /** One NEC 事業継続支援システム */
  CORE_ONE_NEC: 'label.core.one_nec',
  /** 姓名 */
  CORE_FULL_NAME: 'label.core.full_name',
  /** 会社名 */
  CORE_COMPANY_NAME: 'label.core.company_name',
  /** 組織名 */
  CORE_ORGANIZATION_NAME: 'label.core.organization_name',
  /** 職位分類 */
  CORE_JOB_CLASSIFICATION: 'label.core.job_classification',
  /** 利用権限 */
  CORE_USAGE_RIGHTS: 'label.core.usage_rights',
  /** 更新対象 */
  CORE_UPDATE_TARGET: 'label.core.update_target',
  /** 会社／組織を選択してください。 */
  CORE_KAISHA_SOSHIKI_SELECT_PLACEHOLDER: 'label.core.kaisha_soshiki_select_placeholder',
  /** 組織を選択してください。 */
  CORE_SOSHIKI_SELECT_PLACEHOLDER: 'label.core.soshiki_select_placeholder',
  /** 部門Lv４以上を選択してください。 */
  CORE_PLEASE_SELECT_SOSHIKI_LV4_OR_MORE: 'label.core.please_select_soshiki_lv4_or_more',
  /** 都道府県 */
  CORE_TDFK: 'label.core.tdfk',
  /** 都道府県選択 */
  CORE_TDFK_SELECT: 'label.core.tdfk_select',
  /** 都道府県／建物 */
  CORE_TDFK_BUILDING: 'label.core.tdfk_building',
  /** 都道府県／建物選択 */
  CORE_TDFK_BUILDING_SELECT: 'label.core.tdfk_building_select',
  /** 都道府県／建物／拠点 */
  CORE_TDFK_BUILDING_SITE: 'label.core.tdfk_building_site',
  /** 都道府県／建物／拠点選択 */
  CORE_TDFK_BUILDING_SITE_SELECT: 'label.core.tdfk_building_site_select',
  /** 都道府県／拠点 */
  CORE_TDFK_SITE: 'label.core.tdfk_site',
  /** ユーザ選択 */
  CORE_USER_SELECT: 'label.core.user_select',
  /** 管理者選択 */
  CORE_ADMIN_SELECT: 'label.core.admin_select',
  /** 管理者として設定したユーザは、Biz安否確認／一斉通報でグループを利用して安否確認できます。 */
  CORE_ADMIN_SELECT_HELP: 'label.core.admin_select_help',
  /** 全て選択 */
  CORE_SELECT_ALL: 'label.core.select_all',
  /** YYYY/MM/DD HH:mm:ss */
  CORE_DATETIME_FORMAT: 'label.core.datetime_format',
  /** ログインに失敗しました。再度ログインしてください。 */
  CORE_SYSTEM_ERROR_MESSAGE: 'label.core.system_error_message',
  /** 画面が正しく表示できません。ブラウザの画面を再読み込み（リフレッシュ※PCではCtrl+F5）してください。\n同様のメッセージが繰り返し表示される場合は、ITサービスポータル(https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91)へご連絡ください。 */
  CORE_SYSTEM_ERROR_PAGE_MESSAGE: 'label.core.system_error_page_message',
  /** エラー発生日時 :{0} */
  CORE_ERROR_OCCURED_TIME: 'label.core.error_occured_time',
  /** 災害情報 */
  CORE_DISASTER_INFO: 'label.core.disaster_info',
  /** 災害名 */
  CORE_DISASTER_NAME: 'label.core.disaster_name',
  /** 災害レベル */
  CORE_DISASTER_LEVEL: 'label.core.disaster_level',
  /** 検索開始日時 */
  CORE_SEARCH_START_DATE: 'label.core.search_start_date',
  /** 詳細 */
  CORE_DETAIL: 'label.core.detail',
  /** 履歴 */
  CORE_HISTORY: 'label.core.history',
  /** 登録日時 */
  CORE_REGISTERED_DATE: 'label.core.registered_date',
  /** 更新日 */
  CORE_UPDATE_DATE: 'label.core.update_date',
  /** 個人情報取り扱い方針 */
  CORE_PERSONAL_INFORMATION_HANDLING_POLICY: 'label.core.personal_information_handling_policy',
  /** サーバ認証エラー */
  CORE_UNAUTHORIZED: 'label.core.unauthorized',
  /** 処理中です。 */
  CORE_DOUBLE_SUBMIT: 'label.core.double_submit',
  /** 直属 */
  CORE_DIRECT: 'label.core.direct',
  /** 災害情報が選択されている場合、<br/>災害情報に紐づく災害発生都道府県の災害レベルが表示されます。 */
  CORE_SELECT_TDFK_HINT: 'label.core.select_tdfk_hint',
  /** 震度６強 ～ ７ */
  CORE_DISASTER_LEVEL_3: 'label.core.disaster_level_3',
  /** 震度５強 ～ ６弱 */
  CORE_DISASTER_LEVEL_2: 'label.core.disaster_level_2',
  /** 震度４ ～ ５弱 */
  CORE_DISASTER_LEVEL_1: 'label.core.disaster_level_1',
  /** 特別警報 */
  CORE_SPECIAL_WARNING: 'label.core.special_warning',
  /** 噴火警報（居住地域） */
  CORE_VOLCANO_WARNING: 'label.core.volcano_warning',
  /** ・地震：{0} */
  CORE_DISASTER_LEVEL_MEANING: 'label.core.disaster_level_meaning',
  /** ・気象警報：{0} */
  CORE_WEATHER_WARNING_MEANING: 'label.core.weather_warning_meaning',
  /** ・噴火：{0} */
  CORE_VOLCANO_WARNING_MEANING: 'label.core.volcano_warning_meaning',
  /** 建物 */
  CORE_BUILDING: 'label.core.building',
  /** 選択した都道府県にある建物がリストに表示されます。<br/>建物は複数選択が可能です。 */
  CORE_BUILDING_HINT: 'label.core.building_hint',
  /** ホーム表示設定 */
  CORE_SETTING_INFORMATION_DISP: 'label.core.setting_information_disp',
  /** 勤務場所 */
  CORE_WORK_PLACE: 'label.core.work_place',
  /** 自宅場所 */
  CORE_HOME_PLACE: 'label.core.home_place',
  /** その他滞在場所 */
  CORE_OTHER_STAY_PLACE: 'label.core.other_stay_place',
  /** 備考 */
  CORE_NOTE: 'label.core.note',
  /** 会社／組織 */
  CORE_KAISHA_SOSHIKI: 'label.core.kaisha_soshiki',
  /** フリーワード検索をご利用できます。<br/>スペース区切りで5ワードまで指定が可能です。 */
  CORE_FREEWORD_HINT: 'label.core.freeword_hint',
  /** 対象 */
  CORE_TARGET: 'label.core.target',
  /** 対象外 */
  CORE_NON_TARGET: 'label.core.non_target',
  /** 設定が完了しました。 */
  CORE_SETUP_COMPLETE: 'label.core.setup_complete',
  /** 全て表示 */
  CORE_SHOW_ALL: 'label.core.show_all',
  /** 詳細表示 */
  CORE_SHOW_DETAIL: 'label.core.show_detail',
  /** 全て */
  CORE_ALL: 'label.core.all',
  /** 完了 */
  CORE_COMPLETE: 'label.core.complete',
  /** 未完了 */
  CORE_NOT_COMPLETE: 'label.core.not_complete',
  /** 通常表示 */
  CORE_NORMAL_DISPLAY: 'label.core.normal_display',
  /** 会社／組織選択 */
  CORE_KAISHA_SOSHIKI_SELECT: 'label.core.kaisha_soshiki_select',
  /** ユーザ数 */
  CORE_USER_NUM: 'label.core.user_num',
  /** 構内作業者を含む */
  CORE_INCLUDES_WORKER: 'label.core.includes_worker',
  /** 建物名 */
  CORE_BUILDING_NAME: 'label.core.building_name',
  /** 拠点名 */
  CORE_BASE_NAME: 'label.core.base_name',
  /** 拠点 */
  CORE_BASE: 'label.core.base',
  /** 集計条件 */
  CORE_TOTALIZE_CONDITIONS: 'label.core.totalize_conditions',
  /** 集計結果一覧 */
  CORE_TOTALIZE_RESULT: 'label.core.totalize_result',
  /** 集計 */
  CORE_TOTALIZE: 'label.core.totalize',
  /** 合計 */
  CORE_TOTAL: 'label.core.total',
  /** 人 */
  CORE_PEOPLE: 'label.core.people',
  /** 号棟 */
  CORE_GOUTOU: 'label.core.goutou',
  /** 階 */
  CORE_FLOOR: 'label.core.floor',
  /** 階 */
  CORE_HIERARCHY: 'label.core.hierarchy',
  /** フロア */
  CORE_WORKSPACE: 'label.core.workspace',
  /** 検索条件 */
  CORE_SEARCH_CONDITIONS: 'label.core.search_conditions',
  /** オプション検索条件 */
  CORE_OPTIONAL_SEARCH_CONDITIONS: 'label.core.optional_search_conditions',
  /** 検索 */
  CORE_SEARCH: 'label.core.search',
  /** 検索結果一覧 */
  CORE_SEARCH_RESULT_LIST: 'label.core.search_result_list',
  /** エラー一覧 */
  CORE_ERROR_LIST: 'label.core.error_list',
  /** エラー内容 */
  CORE_ERROR_CONTENTS: 'label.core.error_contents',
  /** 行 */
  CORE_LINE: 'label.core.line',
  /** グループ名 */
  CORE_GROUP_NAME: 'label.core.group_name',
  /** ユーザ */
  CORE_USER: 'label.core.user',
  /** 会社 */
  CORE_COMPANY: 'label.core.company',
  /** 組織 */
  CORE_ORGANIZATION: 'label.core.organization',
  /** {0}件表示 */
  CORE_VIEW_NUM_LIST: 'label.core.view_num_list',
  /** 全{0}件： */
  CORE_LIST_COUNT_DISP_ALL: 'label.core.list_count_disp_all',
  /** {0} - {1}件を表示 */
  CORE_LIST_COUNT_DISP_DETAIL: 'label.core.list_count_disp_detail',
  /** 登録者 */
  CORE_REGISTERED_PERSON: 'label.core.registered_person',
  /** その他 */
  CORE_OTHER: 'label.core.other',
  /** 年 */
  CORE_YEAR: 'label.core.year',
  /** 月 */
  CORE_MONTH: 'label.core.month',
  /** 日 */
  CORE_DAY: 'label.core.day',
  /** 時 */
  CORE_HOUR: 'label.core.hour',
  /** 分 */
  CORE_MINUTE: 'label.core.minute',
  /** 災害情報を選択すると、災害情報に紐づく災害発生日時が検索開始日時に設定されます。 */
  CORE_DISASTER_INFO_HINT: 'label.core.disaster_info_hint',
  /** 内容 */
  CORE_CONTENT: 'label.core.content',
  /** 正しい日付を選択してください。 */
  CORE_INVALID_DATE_MESSAGE: 'label.core.invalid_date_message',
  /** 正しい日時を選択してください。 */
  CORE_INVALID_DATETIME_MESSAGE: 'label.core.invalid_datetime_message',
  /** 表示設定 */
  CORE_SETTING_DISPLAY: 'label.core.setting_display',
  /** 開始日時は終了日時より古い日時を指定してください。 */
  CORE_SRH_START_DT_TIME_CHECK_MSG: 'label.core.srh_start_dt_time_check_msg',
  /** 開始日は終了日より古い日付を指定してください。 */
  CORE_SRH_START_DT_CHECK_MSG: 'label.core.srh_start_dt_check_msg',
  /** 掲載先 */
  CORE_POST: 'label.core.post',
  /** 掲載先選択 */
  CORE_SELECT_POST: 'label.core.select_post',
  /** 掲載先設定 */
  CORE_SET_POST: 'label.core.set_post',
  /** 変更した内容が破棄されます。よろしいですか？<br/>OKを押すと情報を変更せずに画面が移ります。キャンセルを押すと元の画面に戻ります。 */
  CORE_CONFIRM_BEFORE_MOVE: 'label.core.confirm_before_move',
  /** 該当する情報がありません。すでに削除されている可能性があります。 */
  CORE_ALREADY_BEEN_DELETED: 'label.core.already_been_deleted',
  /** 表示対象データがありません。 */
  CORE_NO_DATA_TO_DISPLAY: 'label.core.no_data_to_display',
  /** ユーザＩＤ */
  CORE_USER_ID: 'label.core.user_id',
  /** 履歴一覧 */
  CORE_HISTORY_LIST: 'label.core.history_list',
  /** 登録内容に誤りがある場合は、更新画面より修正を行ってください。 */
  CORE_REGISTER_RESULT_SUPPLEMENT: 'label.core.register_result_supplement',
  /** 閉じる */
  CORE_CLOSE: 'label.core.close',
  /** BCP対象事業選択 */
  CORE_SELECT_BCP_TGT_JIGYO: 'label.core.select_bcp_tgt_jigyo',
  /** BCP対象事業参照 */
  CORE_REFER_BCP_TGT_JIGYO: 'label.core.refer_bcp_tgt_jigyo',
  /** BCP対象事業コード */
  CORE_BCP_TGT_JIGYO_CD: 'label.core.bcp_tgt_jigyo_cd',
  /** BCP対象事業名 */
  CORE_BCP_TGT_JIGYO_NAME: 'label.core.bcp_tgt_jigyo_name',
  /** 該当データが存在しません。 */
  CORE_DATA_NOT_FOUND_MESSAGE: 'label.core.data_not_found_message',
  /** 実行 */
  CORE_RUN: 'label.core.run',
  /** ドキュメントアップロード／削除 */
  CORE_DOCUMENT_UPLOAD_DELETE: 'label.core.document_upload_delete',
  /** ドキュメントアップロード／削除完了 */
  CORE_DOCUMENT_UPLOAD_DELETE_COMPLETE: 'label.core.document_upload_delete_complete',
  /** アップロード対象 */
  CORE_UPLOAD_TARGET: 'label.core.upload_target',
  /** 削除対象 */
  CORE_DELETE_TARGET: 'label.core.delete_target',
  /** 削除対象 */
  CORE_DELETE_TARGET_MESSAGE: 'label.core.delete_target_message',
  /** 訓練名 */
  CORE_TRAINING_NAME: 'label.core.training_name',
  /** 実施時期 */
  CORE_IMPLEMENTATION_PERIOD: 'label.core.implementation_period',
  /** BCP対象事業 */
  CORE_BCP_TGT_JIGYO: 'label.core.bcp_tgt_jigyo',
  /** 対象ドキュメント */
  CORE_TARGET_DOCUMENT: 'label.core.target_document',
  /** アップロード済みファイル情報 */
  CORE_UPLOADED_FILE_INFORMATION: 'label.core.uploaded_file_information',
  /** 削除ファイル情報 */
  CORE_DELETED_FILE_INFORMATION: 'label.core.deleted_file_information',
  /** ファイル名 */
  CORE_FILE_NAME: 'label.core.file_name',
  /** 説明書き */
  CORE_DESCRIPTION: 'label.core.description',
  /** 前回アップロード日時 */
  CORE_LAST_UPLOAD_DATE: 'label.core.last_upload_date',
  /** アップロード日時 */
  CORE_UPLOAD_DATETIME: 'label.core.upload_datetime',
  /** アップロード／削除 */
  CORE_UPLOAD_DELETE: 'label.core.upload_delete',
  /** アップロード */
  CORE_UPLOAD: 'label.core.upload',
  /** アップロードファイル */
  CORE_UPLOAD_FILE: 'label.core.upload_file',
  /** 版数 */
  CORE_EDITION_NUMBER: 'label.core.edition_number',
  /** BCP推進者問合せ先更新 */
  CORE_CONTACT_INFORMATION_UPDATE: 'label.core.contact_information_update',
  /** 各部門BCP推進者お問い合わせ先 */
  CORE_CONTACT_INFORMATION: 'label.core.contact_information',
  /** ファイルのアップロードが完了しました。 */
  CORE_FILE_UPLOAD_COMPLETE: 'label.core.file_upload_complete',
  /** ファイルのアップロードが失敗しました。 */
  CORE_FILE_UPLOAD_FAILED: 'label.core.file_upload_failed',
  /** ファイルの削除が完了しました。 */
  CORE_FILE_DELETE_COMPLETE: 'label.core.file_delete_complete',
  /** ファイル選択 */
  CORE_FILE_SELECTION: 'label.core.file_selection',
  /** 半角数字３桁で入力してください。 */
  CORE_DOCUMENT_EDITION_NUMBER_MESSAGE: 'label.core.document_edition_number_message',
  /** ファイルのサイズが大きすぎます。 */
  CORE_FILE_SIZE_LARGE_MESSAGE: 'label.core.file_size_large_message',
  /** 未来日は選択できません。 */
  CORE_UNABLE_ENTER_FUTURE_DATE: 'label.core.unable_enter_future_date',
  /** {0}以上{1}以下の半角数字で入力してください。 */
  CORE_INCORRECT_RANGE_MESSAGE: 'label.core.incorrect_range_message',
  /** 災害情報を選択すると、災害情報に紐づく災害発生日時が絞込日時に設定されます。 */
  CORE_FILTER_DT_DISASTER_HINT: 'label.core.filter_dt_disaster_hint',
  /** 所在地 */
  CORE_LOCATION: 'label.core.location',
  /** 建物選択 */
  CORE_SELECT_BUILDING: 'label.core.select_building',
  /** 拠点選択 */
  CORE_SELECT_SITE: 'label.core.select_site',
  /** 並べ替え */
  CORE_SORT_UPDATE: 'label.core.sort_update',
  /** 一番上へ */
  CORE_SORT_TOP: 'label.core.sort_top',
  /** 一つ上へ */
  CORE_SORT_UP: 'label.core.sort_up',
  /** 一つ下へ */
  CORE_SORT_DOWN: 'label.core.sort_down',
  /** 一番下へ */
  CORE_SORT_TAIL: 'label.core.sort_tail',
  /** メールアドレス */
  CORE_MAIL_ADDRESS: 'label.core.mail_address',
  /** 詳細へ戻る */
  CORE_TO_RETURN_DETAIL: 'label.core.to_return_detail',
  /** 添付ファイル */
  CORE_ATTACHED_FILE: 'label.core.attached_file',
  /** 最終更新者 */
  CORE_LAST_UPD_USER: 'label.core.last_upd_user',
  /** クリア */
  CORE_CLEAR: 'label.core.clear',
  /** 47都道府県全てを選択 */
  CORE_SELECT_TDFK_ALL: 'label.core.select_tdfk_all',
  /** 火山 */
  CORE_VOLCANO: 'label.core.volcano',
  /** 並び順を更新します。よろしいですか？ */
  CORE_SORT_UPDATE_CONFIRM_MSG: 'label.core.sort_update_confirm_msg',
  /** 最終更新日時 */
  CORE_LAST_UPDATED_DATE: 'label.core.last_updated_date',
  /** 情報取得中... */
  CORE_LOADING_MESSAGE: 'label.core.loading_message',
  /** <b>注意・閲覧制限事項</b>\n    <ul>\n      <li>ブラウザは「Microsoft Edge」で動作確認を行っています。 その他ブラウザでは正常に表示されない場合があります。</li>\n      <li>ブラウザの「戻る」ボタン等は正常に動作しない可能性がありますので利用しないでください。画面内のボタンを利用してください。</li>\n    </ul>\n    <b>システム提供機能について</b>\n    <ul>\n      <li>\n        各社間、各NEC関係部門間で地域被災状況や部門情報の共有ができます。<br/>\n        また各社、各NEC関係部門から自社、自部門の勤務者向けに指示事項を掲示できます。\n      </li>\n      <li>事業継続業務の内部監査ができます。</li>\n      <li>事業継続に関する各種資料が閲覧できます。</li>\n    </ul>\n     */
  COMMON_DISASTER_GUIDELIN: 'label.common.disaster_guidelin',
  /** 注意事項・制限事項等 */
  COMMON_PRECAUTIONS: 'label.common.precautions',
  /** 新着 */
  COMMON_NEW_INFO: 'label.common.new_info',
  /** 過去{0}日の情報はありません。 */
  COMMON_NO_INFO: 'label.common.no_info',
  /** ログインIDが正しくありません。 */
  COMMON_SYSLOGIN_INPUT_ERROR: 'label.common.syslogin_input_error',
  /** One NEC 事業継続支援システム */
  COMMON_SYSLOGIN_SYSTEM_TITLE: 'label.common.syslogin_system_title',
  /** ログイン */
  COMMON_SYSLOGIN_TITLE: 'label.common.syslogin_title',
  /** ログインID */
  COMMON_SYSLOGIN_ID: 'label.common.syslogin_id',
  /** ログイン */
  COMMON_SYSLOGIN_LOGIN: 'label.common.syslogin_login',
  /** このシステムについて */
  COMMON_SYSLOGIN_ABOUT_SYSTEM: 'label.common.syslogin_about_system',
  /** 個人情報取り扱い方針 */
  COMMON_SYSLOGIN_PRIVACY_POLICY: 'label.common.syslogin_privacy_policy',
  /** ただいま{0}にログイン中です。<br/>そのまましばらくお待ちください。 */
  COMMON_SYSTEM_LOGIN_MESSAGE: 'label.common.system_login_message',
  /** <div style='font-weight:bold'>ログインＩＤについて</div>\n    <small>\n      NEC-Gアカウント(for クラウド)を入力し、ログインしてください。\n    </small> */
  COMMON_SYSLOGIN_HINT: 'label.common.syslogin_hint',
  /** 所属している会社は現在システムを利用できない状態となっています。お手数ですが、システムの管理者へご連絡ください。 */
  COMMON_SYSLOGIN_SYSTEM_UNAVAILABLE: 'label.common.syslogin_system_unavailable',
  /** 個人情報取り扱い方針に同意いただけない場合はご利用できません。 */
  COMMON_SYSLOGIN_PRIVACY_POLICY_NOT_AGREE: 'label.common.syslogin_privacy_policy_not_agree',
  /** 業務 */
  COMMON_SITEMAP_BUSINESS: 'label.common.sitemap_business',
  /** 説明 */
  COMMON_SITEMAP_DESCRIPTION: 'label.common.sitemap_description',
  /** 分類から探す */
  COMMON_FAQ_SEARCH_BY_CATEGORY: 'label.common.faq_search_by_category',
  /** 分類 */
  COMMON_FAQ_CATEGORY: 'label.common.faq_category',
  /** 閲覧数の多い質問から探す */
  COMMON_FAQ_SEARCH_BY_ACCESS: 'label.common.faq_search_by_access',
  /** 全{0}件 */
  COMMON_FAQ_DISPLAYING_ALL: 'label.common.faq_displaying_all',
  /** 画像を表示 */
  COMMON_FAQ_VIEW_IMAGE: 'label.common.faq_view_image',
  /** 閲覧数の多い質問[{0}] */
  COMMON_FAQ_FREQUENTLY_ACCESSED: 'label.common.faq_frequently_accessed',
  /** 画像を非表示 */
  COMMON_FAQ_HIDE_IMAGE: 'label.common.faq_hide_image',
  /** {0}で検索した結果 */
  COMMON_FAQ_SEARCH_WITH_WORDS: 'label.common.faq_search_with_words',
  /** 該当するFAQが見つかりません。 */
  COMMON_FAQ_NOT_FOUND: 'label.common.faq_not_found',
  /** 「{0}」 */
  COMMON_FAQ_SEARCH_WORD: 'label.common.faq_search_word',
  /** マニュアル一覧 */
  COMMON_MANUAL_LIST: 'label.common.manual_list',
  /** Manual list（English Version） */
  COMMON_MANUAL_LIST_EN: 'label.common.manual_list_en',
  /** NECグループ被災情報機能操作マニュアル */
  COMMON_MANUAL_GROUPHISAI: 'label.common.manual_grouphisai',
  /** Group Damage Info Operation Manual */
  COMMON_MANUAL_GROUPHISAI_EN: 'label.common.manual_grouphisai_en',
  /** 拠点・建物・地域情報機能操作マニュアル */
  COMMON_MANUAL_SITEBUILDINGAREA: 'label.common.manual_sitebuildingarea',
  /** 個人情報設定機能操作マニュアル */
  COMMON_MANUAL_PERSONAL: 'label.common.manual_personal',
  /** Setting Personal Information Operation Manual */
  COMMON_MANUAL_PERSONAL_EN: 'label.common.manual_personal_en',
  /** 安否確認対象外設定機能操作マニュアル */
  COMMON_MANUAL_BIZEXCSETTING: 'label.common.manual_bizexcsetting',
  /** Safety Confirmation Excluded Setting Operation Manual */
  COMMON_MANUAL_BIZEXCSETTING_EN: 'label.common.manual_bizexcsetting_en',
  /** 安否登録・安否確認について */
  COMMON_SAFETY_TITLE: 'label.common.safety_title',
  /** 個人情報設定 */
  COMMON_SAFETY_SETTING_PERSONAL: 'label.common.safety_setting_personal',
  /** （未設定） */
  COMMON_SAFETY_NOT_SETTING: 'label.common.safety_not_setting',
  /** 安否登録基準<br/>（PDFファイル） */
  COMMON_SAFETY_REGISTER_CRITERIA_PDF: 'label.common.safety_register_criteria_pdf',
  /** Biz安否確認／一斉通報<br/>（外部リンク） */
  COMMON_SAFETY_CONFIRMATION_EXTERNAL_LINK: 'label.common.safety_confirmation_external_link',
  /** ■安否登録／確認、お知らせの機能は、Biz安否確認／一斉通報サービスをご利用ください。<br/>\n        Biz安否確認／一斉通報サービスをご利用前または勤務場所等が変更となった場合、<br/>\n        個人情報設定の内容をご確認いただき、内容に変更ある場合は設定変更をお願いいたします。<br/>\n        個人情報設定の設定がされていない場合、Biz安否確認／一斉通報サービスの一部機能がご利用できません。<br/>\n        ・災害発生時などのアプリまたはメールでの通知<br/>\n        ・パスワードを忘れた場合のパスワードリセット<br/>\n        等 */
  COMMON_SAFETY_OVERVIEW: 'label.common.safety_overview',
  /** ■Biz安否確認／一斉通報サービスからの通知は「anpi@mob-connect.com」から届きます。<br/>\n        このメールアドレスはNECグループのドメインとは異なりますが、不審なメールではありません。 */
  COMMON_BIZ_MAIL_INFO: 'label.common.biz_mail_info',
  /** ■Biz安否確認／一斉通報サービスのアプリインストールはこちらから */
  COMMON_SAFETY_APP_INSTALL: 'label.common.safety_app_install',
  /** ・iPhoneをご利用の方はこちら */
  COMMON_SAFETY_IPHONE_MESSAGE: 'label.common.safety_iphone_message',
  /** ・Androidをご利用の方はこちら */
  COMMON_SAFETY_ANDROID_MESSAGE: 'label.common.safety_android_message',
  /** ログアウトに失敗しました。再度ログアウトしてください。 */
  COMMON_LOGOUT_FAILD: 'label.common.logout_faild',
  /** 災害情報登録 */
  MASTERDATA_DISASTER_REGISTER: 'label.masterdata.disaster_register',
  /** 災害情報更新 */
  MASTERDATA_DISASTER_UPDATE: 'label.masterdata.disaster_update',
  /** 災害情報削除 */
  MASTERDATA_DISASTER_DELETE: 'label.masterdata.disaster_delete',
  /** 災害情報登録結果 */
  MASTERDATA_DISASTER_REGISTER_RESULT: 'label.masterdata.disaster_register_result',
  /** 災害情報更新結果 */
  MASTERDATA_DISASTER_UPDATE_RESULT: 'label.masterdata.disaster_update_result',
  /** 災害情報削除結果 */
  MASTERDATA_DISASTER_DELETE_RESULT: 'label.masterdata.disaster_delete_result',
  /** 災害情報詳細 */
  MASTERDATA_DISASTER_DETAIL: 'label.masterdata.disaster_detail',
  /** 災害／訓練 */
  MASTERDATA_DISASTER_TRAINING: 'label.masterdata.disaster_training',
  /** 災害 */
  MASTERDATA_DISASTER: 'label.masterdata.disaster',
  /** 訓練 */
  MASTERDATA_TRAINING: 'label.masterdata.training',
  /** 災害名 */
  MASTERDATA_DISASTER_NAME: 'label.masterdata.disaster_name',
  /** 災害発生日時 */
  MASTERDATA_DISASTER_DATETIME: 'label.masterdata.disaster_datetime',
  /** 災害レベル毎都道府県 */
  MASTERDATA_DISASTER_LEVEL_TDFK: 'label.masterdata.disaster_level_tdfk',
  /** 災害レベル */
  MASTERDATA_DISASTER_LEVEL: 'label.masterdata.disaster_level',
  /** レベル１ */
  MASTERDATA_DISASTER_LV1: 'label.masterdata.disaster_lv1',
  /** レベル２ */
  MASTERDATA_DISASTER_LV2: 'label.masterdata.disaster_lv2',
  /** レベル３ */
  MASTERDATA_DISASTER_LV3: 'label.masterdata.disaster_lv3',
  /** 本画面はOneNECとしての災害情報を登録する画面です。<br/>\n    Biz安否確認／一斉通報サービスでの災害情報はBiz安否確認／一斉通報サービスで登録する必要があります。 */
  MASTERDATA_DISASTER_REGISTER_HELP: 'label.masterdata.disaster_register_help',
  /** <div style='width:350px'>災害名称を設定します。<br/>\n    災害／訓練で「訓練」を選択した場合は、登録時の災害名称に自動的に【訓練】が付与されます。<br/>\n    例）【訓練】20190510_パブリック品質推進本部</div> */
  MASTERDATA_DISASTER_REGISTER_NAME_HINT: 'label.masterdata.disaster_register_name_hint',
  /** 災害発生都道府県ごとの災害レベルを設定します。\n      <div style='padding-top: 8px; width: 100%; display: flex; flex-wrap: wrap;'>\n        <div style='font-weight: bold;'>災害レベル</div>\n        <div style='margin-left: 2px; text-align: center; height: auto; width:20px; background-color: #FF4B00; border-radius: 4px;'>\n          <span style='color: black; font-weight: bold'>3</span>\n        </div>\n      </div>\n      <div style='margin: 0 0 8px 0'>・地震：震度６強 ～ ７</div>\n      <div style='margin: 0 0 8px 0'>・津波：大津波警報</div>\n      <div style='padding-top: 8px; width: 100%; display: flex; flex-wrap: wrap;'>\n        <div style='font-weight: bold;'>災害レベル</div>\n        <div style='margin-left: 2px; text-align: center; height: auto; width:20px; background-color: #FFF100; border-radius: 4px;'>\n          <span style='color: black; font-weight: bold'>2</span>\n        </div>\n      </div>\n      <div style='margin: 0 0 8px 0'>・地震：震度５強 ～ ６弱</div>\n      <div style='margin: 0 0 8px 0'>・気象警報：特別警報</div>\n      <div style='margin: 0 0 8px 0'>・噴火：噴火警報（居住地域）</div>\n      <div style='padding-top: 8px; width: 100%; display: flex; flex-wrap: wrap;'>\n        <div style='font-weight: bold;'>災害レベル</div>\n        <div style='margin-left: 2px; text-align: center; height: auto; width:20px; background-color: #4DC4FF; border-radius: 4px;'>\n          <span style='color: black; font-weight: bold'>1</span>\n        </div>\n      </div>\n      <div style='margin: 0 0 8px 0'>・地震：震度４ ～ ５弱</div> */
  MASTERDATA_DISASTER_REGISTER_TDFK_HINT: 'label.masterdata.disaster_register_tdfk_hint',
  /** 災害情報検索 */
  MASTERDATA_DISASTER_SEARCH: 'label.masterdata.disaster_search',
  /** 入力した名前の災害は既に存在します。 */
  MASTERDATA_DISASTER_NAME_ALREADY_EXISTS_MESSAGE: 'label.masterdata.disaster_name_already_exists_message',
  /** 利用権限設定 */
  MASTERDATA_RIGHTUSAGE_SETTING: 'label.masterdata.rightusage_setting',
  /** 訓練情報を含む */
  MASTERDATA_TRAINING_INCLUDED_OR_NONINCLUDED: 'label.masterdata.training_included_or_nonincluded',
  /** 都道府県が重複しています。 */
  MASTERDATA_DISASTER_TDFK_DUPLICATE_MESSAGE: 'label.masterdata.disaster_tdfk_duplicate_message',
  /** CSVファイル */
  MASTERDATA_CSV_FILE: 'label.masterdata.csv_file',
  /** CSVファイル選択 */
  MASTERDATA_CSV_SELECT: 'label.masterdata.csv_select',
  /** グループ名 */
  MASTERDATA_USER_UNIT_GROUP_NAME: 'label.masterdata.user_unit_group_name',
  /** ３６文字以内 */
  MASTERDATA_USER_UNIT_GROUP_NAME_HELP: 'label.masterdata.user_unit_group_name_help',
  /** ユーザID */
  MASTERDATA_USER_ID: 'label.masterdata.user_id',
  /** 会社コード＋社員ID */
  MASTERDATA_USER_ID_HELP: 'label.masterdata.user_id_help',
  /** グループの役割 */
  MASTERDATA_USER_UNIT_GROUP_ROLE: 'label.masterdata.user_unit_group_role',
  /** 管理者：1 管理者／メンバ：2 メンバ：3 */
  MASTERDATA_USER_UNIT_GROUP_ROLE_HELP: 'label.masterdata.user_unit_group_role_help',
  /** 項目名 */
  MASTERDATA_MASTER_REGISTER_ITEM_NAME_HELP: 'label.masterdata.master_register_item_name_help',
  /** 説明 */
  MASTERDATA_MASTER_REGISTER_DESCRIPTION_HELP: 'label.masterdata.master_register_description_help',
  /** グループデータ */
  MASTERDATA_GROUP_REGISTER_DATA_HELP: 'label.masterdata.group_register_data_help',
  /** ・グループデータテンプレートファイル */
  MASTERDATA_GROUP_REGISTER_TEMPLATE_HELP: 'label.masterdata.group_register_template_help',
  /** 登録結果へ戻る */
  MASTERDATA_RETURN_REGISTER_RESULT: 'label.masterdata.return_register_result',
  /** グループ登録 */
  MASTERDATA_GROUP_REGISTRATION: 'label.masterdata.group_registration',
  /** グループ更新 */
  MASTERDATA_GROUP_UPDATE: 'label.masterdata.group_update',
  /** グループ削除 */
  MASTERDATA_GROUP_DELETE: 'label.masterdata.group_delete',
  /** グループ登録結果 */
  MASTERDATA_GROUP_REGISTRATION_RESULT: 'label.masterdata.group_registration_result',
  /** グループ更新結果 */
  MASTERDATA_GROUP_UPDATE_RESULT: 'label.masterdata.group_update_result',
  /** グループ削除結果 */
  MASTERDATA_GROUP_DELETE_RESULT: 'label.masterdata.group_delete_result',
  /** 作成者 */
  MASTERDATA_GROUP_CREATOR: 'label.masterdata.group_creator',
  /** 作成者の会社名 */
  MASTERDATA_GROUP_CREATOR_COMPANY: 'label.masterdata.group_creator_company',
  /** 作成者の組織名 */
  MASTERDATA_GROUP_CREATOR_ORGANIZATION: 'label.masterdata.group_creator_organization',
  /** 選択したユーザをグループから削除します。よろしいですか？ */
  MASTERDATA_GROUP_USER_DELETE_CONFIRM_MESSAGE: 'label.masterdata.group_user_delete_confirm_message',
  /** 登録データが0件でした。 */
  MASTERDATA_GROUP_CSV_FAILED_REGISTER_MESSAGE: 'label.masterdata.group_csv_failed_register_message',
  /** ユーザが追加されていません。 */
  MASTERDATA_GROUP_MEMBER_NO_ADDED_MESSAGE: 'label.masterdata.group_member_no_added_message',
  /** ユーザ一覧 */
  MASTERDATA_USER_LIST: 'label.masterdata.user_list',
  /** 管理者一覧 */
  MASTERDATA_ADMIN_LIST: 'label.masterdata.admin_list',
  /** 入力したグループ名のグループは既に存在します。 */
  MASTERDATA_GROUP_NAME_ALREADY_EXISTS_MESSAGE: 'label.masterdata.group_name_already_exists_message',
  /** グループメンバを選択してください。 */
  MASTERDATA_GROUP_MEMBER_NO_SELECTED: 'label.masterdata.group_member_no_selected',
  /** グループ管理者を選択してください。 */
  MASTERDATA_GROUP_ADMIN_NO_SELECTED: 'label.masterdata.group_admin_no_selected',
  /** 初期値はON（構内作業者を検索に含む）となっています。<br/>\n         検索対象に構内作業者を含めない場合はスイッチをOFF（左）にしてください。 */
  MASTERDATA_GROUP_KONAI_ON_HINT: 'label.masterdata.group_konai_on_hint',
  /** CSVファイル登録 */
  MASTERDATA_CSV_FILE_REGISTRATION: 'label.masterdata.csv_file_registration',
  /** グループCSV登録 */
  MASTERDATA_GROUP_REGISTRATION_CSV: 'label.masterdata.group_registration_csv',
  /** グループ登録へ戻る */
  MASTERDATA_RETURN_GROUP_REGISTRATION: 'label.masterdata.return_group_registration',
  /** グループCSV登録結果 */
  MASTERDATA_GROUP_CSV_REGISTRATION_RESULT: 'label.masterdata.group_csv_registration_result',
  /** CSVファイルフォーマット<br/>１：ユーザグループ名（必須）（３０文字以内）<br/>２：ユーザID（必須）（会社コード＋社員ID）\n    <p>登録例：NEC情報連携グループ,0000010123456</p>\n    ・ファイルはCSV形式（半角カンマ区切り）のテキストファイルです。<br/>\n    ・文字コードはShift-JISです。<br/>\n    ・改行コードは0x0D0A（CR + LF）です。<br/>\n    ・CSVファイル中に登録できない行が存在した場合には、次の行に処理が移ります。<br/>\n    ・既に登録されているユーザグループ名は使用できません。<br/>\n    ・既に登録されているグループに対して、メンバの追加や削除をしたい場合は、グループ検索機能から実施してください。<br/>\n    ・１ファイルにつき、１つのユーザグループのみ登録できます。<br/>\n    ・ログイン者は自動的にユーザグループにメンバとして登録されます。 */
  MASTERDATA_GROUP_CSV_HELP: 'label.masterdata.group_csv_help',
  /** グループ登録用CSVファイルのテンプレートファイルをダウンロードし、ヘッダ情報を参考にしてファイルを作成してください。<br/>テンプレートファイルには、1行目に項目名、2行目にデータの補足情報が記述されています。<br/>最初の2行を削除せずに3行目からデータを記述し、そのままアップロードしてください。 */
  MASTERDATA_GROUP_CSV_REGISTER_OUTLINE_HELP: 'label.masterdata.group_csv_register_outline_help',
  /** ※ファイルはCSV形式（半角カンマ区切り）のテキストファイルです。<br/>\n         ※文字コードはShift-JISです。<br/>\n         ※改行コードは0x0D0A（CR + LF）です。<br/>\n         ※CSVファイル中に登録できない行が存在した場合には、次の行に処理が移ります。 */
  MASTERDATA_GROUP_CSV_REGISTER_COMMENT_HELP: 'label.masterdata.group_csv_register_comment_help',
  /** ※既に登録されているグループ名は使用できません。<br/>\n         ※既に登録されているグループに対して、メンバの追加や削除をしたい場合は、グループ検索機能から実施してください。<br/>\n         ※１ファイルにつき、１つのグループのみ登録できます。<br/>\n         ※管理者はBiz安否確認／一斉通報でこのグループを利用して安否確認を行うことが出来ます。<br/>\n         ※メンバはグループを利用して安否確認を行う時の対象者になります。 */
  MASTERDATA_GROUP_REGISTER_COMMENT_HELP: 'label.masterdata.group_register_comment_help',
  /** 権限を変更する方を選択してください。 */
  MASTERDATA_RIGHTUSAGE_TARGET_MISSING: 'label.masterdata.rightusage_target_missing',
  /** 拠点情報登録 */
  MASTERDATA_SITE_REGISTER_TITLE: 'label.masterdata.site_register_title',
  /** 拠点情報登録結果 */
  MASTERDATA_SITE_REGISTER_RESULT_TITLE: 'label.masterdata.site_register_result_title',
  /** 建物情報登録 */
  MASTERDATA_BUILDING_REGISTER_TITLE: 'label.masterdata.building_register_title',
  /** 建物情報登録結果 */
  MASTERDATA_BUILDING_REGISTER_RESULT_TITLE: 'label.masterdata.building_register_result_title',
  /** 建物情報検索 */
  MASTERDATA_BUILDING_SEARCH_TITLE: 'label.masterdata.building_search_title',
  /** 建物情報詳細 */
  MASTERDATA_BUILDING_DETAIL_TITLE: 'label.masterdata.building_detail_title',
  /** 建物情報更新 */
  MASTERDATA_BUILDING_UPDATE_TITLE: 'label.masterdata.building_update_title',
  /** 建物情報更新結果 */
  MASTERDATA_BUILDING_UPDATE_RESULT_TITLE: 'label.masterdata.building_update_result_title',
  /** 建物情報削除 */
  MASTERDATA_BUILDING_DELETE_TITLE: 'label.masterdata.building_delete_title',
  /** 建物情報削除結果 */
  MASTERDATA_BUILDING_DELETE_RESULT_TITLE: 'label.masterdata.building_delete_result_title',
  /** 拠点情報検索 */
  MASTERDATA_SITE_SEARCH_TITLE: 'label.masterdata.site_search_title',
  /** 拠点情報更新 */
  MASTERDATA_SITE_UPDATE_TITLE: 'label.masterdata.site_update_title',
  /** 拠点情報更新結果 */
  MASTERDATA_SITE_UPDATE_RESULT_TITLE: 'label.masterdata.site_update_result_title',
  /** 拠点情報詳細 */
  MASTERDATA_SITE_DETAIL_TITLE: 'label.masterdata.site_detail_title',
  /** 拠点情報削除 */
  MASTERDATA_SITE_DELETE_TITLE: 'label.masterdata.site_delete_title',
  /** 拠点情報削除結果 */
  MASTERDATA_SITE_DELETE_RESULT_TITLE: 'label.masterdata.site_delete_result_title',
  /** 拠点表示順設定 */
  MASTERDATA_SITE_ORDERING_TITLE: 'label.masterdata.site_ordering_title',
  /** 拠点表示順詳細 */
  MASTERDATA_SITE_ORDERING_DETAIL_TITLE: 'label.masterdata.site_ordering_detail_title',
  /** 建物通称 */
  MASTERDATA_BUILDING_COMMON_NAME: 'label.masterdata.building_common_name',
  /** 建物正式名称 */
  MASTERDATA_BUILDING_OFFICIAL_NAME: 'label.masterdata.building_official_name',
  /** 機能 */
  MASTERDATA_FUNCTION: 'label.masterdata.function',
  /** 地域 */
  MASTERDATA_AREA: 'label.masterdata.area',
  /** 拠点の種類 */
  MASTERDATA_SITE_KIND: 'label.masterdata.site_kind',
  /** 勤務者数 */
  MASTERDATA_NUMBER_OF_EMPLOYEES: 'label.masterdata.number_of_employees',
  /** 占有フロア階 */
  MASTERDATA_FLOORS: 'label.masterdata.floors',
  /** 建物総階数 */
  MASTERDATA_TOTAL_STORIES: 'label.masterdata.total_stories',
  /** 建物オーナー区分 */
  MASTERDATA_BUILDING_OWNER_KBN: 'label.masterdata.building_owner_kbn',
  /** 建物オーナー名 */
  MASTERDATA_BUILDING_OWNER_NAME: 'label.masterdata.building_owner_name',
  /** 建物オーナー連絡先 */
  MASTERDATA_BUILDING_OWNER_CONTACT: 'label.masterdata.building_owner_contact',
  /** 防災センター連絡先 */
  MASTERDATA_GUARD_CONTACT: 'label.masterdata.guard_contact',
  /** 所在地 */
  MASTERDATA_LOCATION: 'label.masterdata.location',
  /** 通信手段 */
  MASTERDATA_COMMUNICATION_MEANS: 'label.masterdata.communication_means',
  /** 備蓄食料 */
  MASTERDATA_STOCKPILE_FOOD: 'label.masterdata.stockpile_food',
  /** 備蓄飲料水 */
  MASTERDATA_STOCKPILE_DRINKING_WATER: 'label.masterdata.stockpile_drinking_water',
  /** 倉庫（保管品） */
  MASTERDATA_WAREHOUSE_STORED_GOODS: 'label.masterdata.warehouse_stored_goods',
  /** 倉庫（インタンク） */
  MASTERDATA_WAREHOUSE_IN_TANK: 'label.masterdata.warehouse_in_tank',
  /** 最終更新者 */
  MASTERDATA_LAST_UPDATED_BY: 'label.masterdata.last_updated_by',
  /** 最終更新日時 */
  MASTERDATA_LAST_UPDATED_DATE: 'label.masterdata.last_updated_date',
  /** 拠点を削除すると、当該拠点を{0}の勤務場所に設定している場合は、再設定が必要となります。処理を続けますか？ */
  MASTERDATA_DELETE_SITE_LINK_MESSAGE: 'label.masterdata.delete_site_link_message',
  /** 感染症報告 */
  MASTERDATA_PANDE_REPORT: 'label.masterdata.pande_report',
  /** ユーザ、および感染症報告 */
  MASTERDATA_USER_AND_PANDE_REPORT: 'label.masterdata.user_and_pande_report',
  /** 入居する拠点 */
  MASTERDATA_TENANT_SITES: 'label.masterdata.tenant_sites',
  /** 入居拠点無し */
  MASTERDATA_NO_SITE: 'label.masterdata.no_site',
  /** ONにした場合は、入居している拠点が存在していない建物のみ表示します。 */
  MASTERDATA_NO_SITE_HINT: 'label.masterdata.no_site_hint',
  /** 拠点数 */
  MASTERDATA_SITE_COUNT: 'label.masterdata.site_count',
  /** 建物通称、建物正式名称のいずれかでの登録が可能です。 */
  MASTERDATA_BUILDING_NAME_HINT: 'label.masterdata.building_name_hint',
  /** 都道府県を選択し、所在地を入力してください。 */
  MASTERDATA_LOCATION_HINT: 'label.masterdata.location_hint',
  /** 入居する拠点が存在するため、削除できません。先に拠点情報を削除してください。 */
  MASTERDATA_BUILDING_EXISTS_TENANT_SITES_MESSAGE: 'label.masterdata.building_exists_tenant_sites_message',
  /** リットル */
  MASTERDATA_LITER: 'label.masterdata.liter',
  /** 食分 */
  MASTERDATA_SERVING: 'label.masterdata.serving',
  /** 対象の建物は削除されている可能性があります。 */
  MASTERDATA_TARGET_BUILD_DELETED_MESSAGE: 'label.masterdata.target_build_deleted_message',
  /** 詳細へ戻る */
  MASTERDATA_RETURN_TO_DETAILS: 'label.masterdata.return_to_details',
  /** 拠点情報更新画面で修正はできません。 */
  MASTERDATA_SITE_COMPANY_HINT: 'label.masterdata.site_company_hint',
  /** 拠点の並び順を変更する会社の拠点数が変更されています。画面を更新して、再度並び替えを実施してください。 */
  MASTERDATA_SITE_COUNT_CHANGED_MESSAGE: 'label.masterdata.site_count_changed_message',
  /** 組織名に所属NEC関係部門を選択してください。 */
  MASTERDATA_MY_BU_CHECK_MESSAGE: 'label.masterdata.my_bu_check_message',
  /** 大津波警報 */
  MASTERDATA_TSUNAMI_WARN: 'label.masterdata.tsunami_warn',
  /** 地域情報登録 */
  MASTERDATA_AREA_REGISTER_TITLE: 'label.masterdata.area_register_title',
  /** 地域情報登録結果 */
  MASTERDATA_AREA_REGISTER_RESULT_TITLE: 'label.masterdata.area_register_result_title',
  /** 地域情報検索 */
  MASTERDATA_AREA_SEARCH_TITLE: 'label.masterdata.area_search_title',
  /** 地域情報更新 */
  MASTERDATA_AREA_UPDATE_TITLE: 'label.masterdata.area_update_title',
  /** 地域情報更新結果 */
  MASTERDATA_AREA_UPDATE_RESULT_TITLE: 'label.masterdata.area_update_result_title',
  /** 地域情報詳細 */
  MASTERDATA_AREA_DETAIL_TITLE: 'label.masterdata.area_detail_title',
  /** 地域情報削除 */
  MASTERDATA_AREA_DELETE_TITLE: 'label.masterdata.area_delete_title',
  /** 地域情報削除結果 */
  MASTERDATA_AREA_DELETE_RESULT_TITLE: 'label.masterdata.area_delete_result_title',
  /** 地域表示順設定 */
  MASTERDATA_AREA_ORDERING_TITLE: 'label.masterdata.area_ordering_title',
  /** 地域表示順詳細 */
  MASTERDATA_AREA_ORDERING_DETAIL_TITLE: 'label.masterdata.area_ordering_detail_title',
  /** 地域名 */
  MASTERDATA_AREA_NM: 'label.masterdata.area_nm',
  /** 地域情報の登録可能数の上限に達したため、地域情報の登録ができません。 */
  MASTERDATA_AREA_CODE_UPPER_LIMIT_MESSAGE: 'label.masterdata.area_code_upper_limit_message',
  /** 地域に紐づく拠点が存在するため、削除できません。先に拠点情報を削除してください。 */
  MASTERDATA_AREA_DELETE_ERROR_MESSAGE: 'label.masterdata.area_delete_error_message',
  /** 地域数 */
  MASTERDATA_AREA_COUNT: 'label.masterdata.area_count',
  /** 地域の並び順を変更する会社の地域数が変更されています。画面を更新して、再度並び替えを実施してください。 */
  MASTERDATA_AREA_COUNT_CHANGED_MESSAGE: 'label.masterdata.area_count_changed_message',
  /** 並び順を更新しました。 */
  MASTERDATA_SORT_UPDATE_MESSAGE: 'label.masterdata.sort_update_message',
  /** 人事拠点連携対応検索 */
  MASTERDATA_HR_LINKAGE_SEARCH: 'label.masterdata.hr_linkage_search',
  /** 人事拠点連携対応更新 */
  MASTERDATA_HR_LINKAGE_UPDATE: 'label.masterdata.hr_linkage_update',
  /** 人事拠点連携対応更新結果 */
  MASTERDATA_HR_LINKAGE_UPDATE_RESULT: 'label.masterdata.hr_linkage_update_result',
  /** 紐づけ状況 */
  MASTERDATA_LINKAGE_STATUS: 'label.masterdata.linkage_status',
  /** 人事情報システム */
  MASTERDATA_HR_SYSTEM: 'label.masterdata.hr_system',
  /** OneNEC事業継続支援システム */
  MASTERDATA_ONENEC_SYSTEM: 'label.masterdata.onenec_system',
  /** 人事情報システムの拠点情報 */
  MASTERDATA_HR_SYSTEM_SITE: 'label.masterdata.hr_system_site',
  /** OneNEC事業継続支援システムの拠点情報 */
  MASTERDATA_ONENEC_SYSTEM_SITE: 'label.masterdata.onenec_system_site',
  /** グループの役割を指定してください。 */
  MASTERDATA_NO_GROUPROLE_MESSAGE: 'label.masterdata.no.grouprole.message',
  /** グループの役割に不正な値が入力されています。 */
  MASTERDATA_ENTER_INVALID_GROUPROLE_MESSAGE: 'label.masterdata.enter.invalid.grouprole.message',
  /** ユーザと管理者をそれぞれ１人以上設定してください。 */
  MASTERDATA_ENTER_INVALID_MEMBERS_MESSAGE: 'label.masterdata.enter.invalid.members.message',
  /** IDが重複しています。 */
  MASTERDATA_ENTER_DUPLICATION_MEMBERS_MESSAGE: 'label.masterdata.enter.duplication.members.message',
  /** 管理者 */
  MASTERDATA_ADMIN: 'label.masterdata.admin',
  /** メンバー */
  MASTERDATA_MEMBER: 'label.masterdata.member',
  /** 管理者／メンバー */
  MASTERDATA_ADMIN_MEMBER: 'label.masterdata.admin_member',
  /** 自分が管理者に設定されているグループを検索することができます。 */
  MASTERDATA_GROUP_SEARCH_HELP: 'label.masterdata.group_search_help',
  /** 拠点番号 */
  MASTERDATA_SITE_NUMBER: 'label.masterdata.site_number',
  /** 安否確認対象外設定 */
  MASTERDATA_BIZ_EXC_SETTING_TITLE: 'label.masterdata.biz_exc_setting_title',
  /** Biz安否確認／一斉通報サービスの安否確認および安否集計の対象外にしたいユーザを設定します。<br/>対象外設定を行う場合は、検索結果一覧上で対象外をONにして設定ボタンを押してください。<br/><br/>\n         ※安否対象外とする者は、例えば兼務者、構内作業者のうち災害時に別の手段（本務側で安否確認する、委託先にて安否確認をするなど）で安否確認を行うためBiz安否確認／一斉通報サービスを利用しない、または利用する必要がないようなケースを想定しています。（対象外設定されたユーザのアカウントは、Biz安否確認／一斉通報サービスから削除されます）<br/><br/>\n         休職者は原則として本システムでの安否登録対象となりますので対象外設定はしないでください。また、対象外を解除したユーザについては、再度Biz安否確認／一斉通報サービス上でパスワードの設定などの初期設定が必要になります。 */
  MASTERDATA_BIZ_EXC_SETTING_HELP: 'label.masterdata.biz_exc_setting_help',
  /** 出向元会社から見たときに、別会社へ出向している社員に関しては「出向中」と表示されます。<br/>表示がない社員に関しては「自社在籍」となります。 */
  MASTERDATA_BIZ_EXC_SECONDED_HINT: 'label.masterdata.biz_exc_seconded_hint',
  /** 安否確認対象／対象外 */
  MASTERDATA_BIZ_EXC_TARGET_NONTARGET: 'label.masterdata.biz_exc_target_nontarget',
  /** 対象 */
  MASTERDATA_BIZ_EXC_TARGET: 'label.masterdata.biz_exc_target',
  /** 対象外 */
  MASTERDATA_BIZ_EXC_NONTARGET: 'label.masterdata.biz_exc_nontarget',
  /** 出向中／自社在籍 */
  MASTERDATA_BIZ_EXC_SECONDED_NONSECONDED: 'label.masterdata.biz_exc_seconded_nonseconded',
  /** 出向中 */
  MASTERDATA_BIZ_EXC_SECONDED: 'label.masterdata.biz_exc_seconded',
  /** 自社在籍 */
  MASTERDATA_BIZ_EXC_NONSECONDED: 'label.masterdata.biz_exc_nonseconded',
  /** 更新者名 */
  MASTERDATA_UPDATER_NAME: 'label.masterdata.updater_name',
  /** 更新者組織名 */
  MASTERDATA_UPDATER_ORGANIZATION_NAME: 'label.masterdata.updater_organization_name',
  /** 対象外設定日時 */
  MASTERDATA_EXCLUDED_SETTING_DATETIME: 'label.masterdata.excluded_setting_datetime',
  /** 存在しないユーザ */
  MASTERDATA_NON_EXISTENT_USER: 'label.masterdata.non_existent_user',
  /** 対象外設定が変更されていません。 */
  MASTERDATA_BIZ_EXC_SETTING_NOT_CHANGED: 'label.masterdata.biz_exc_setting_not_changed',
  /** 設定内容は翌日にBiz安否確認／一斉通報サービスに反映されます。 */
  MASTERDATA_BIZ_EXC_CONFIRM_SUB_MESSAGE: 'label.masterdata.biz_exc_confirm_sub_message',
  /** 安否確認対象外に設定されているためグループ登録できません。 */
  MASTERDATA_GROUP_CANNOT_ENTRY_BIZ_EXC_USER: 'label.masterdata.group_cannot_entry_biz_exc_user',
  /** 安否確認対象外に設定されているためグループ検索できません。 */
  MASTERDATA_GROUP_CANNOT_SEARCH_BIZ_EXC_USER: 'label.masterdata.group_cannot_search_biz_exc_user',
  /** 利用者アップロード（CSV） */
  MASTERDATA_BIZ_USER_CSV_UPLOAD: 'label.masterdata.biz_user_csv_upload',
  /** 利用者アップロード（CSV）結果 */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_RESULT: 'label.masterdata.biz_user_csv_upload_result',
  /** 利用者更新一覧 */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_LIST: 'label.masterdata.biz_user_csv_upload_list',
  /** CSVファイルを選択してください。 */
  MASTERDATA_BIZ_USER_CSV_PLEASE_FILE_SELECT: 'label.masterdata.biz_user_csv_please_file_select',
  /** CSVファイルが存在しないか、または空のファイルです。 */
  MASTERDATA_BIZ_USER_CSV_FILE_EMPTY: 'label.masterdata.biz_user_csv_file_empty',
  /** CSVファイルがUTF-8ではありません。 */
  MASTERDATA_BIZ_USER_CSV_FILE_UTF8: 'label.masterdata.biz_user_csv_file_utf8',
  /** CSVファイルの拡張子が「.csv」ではありません。 */
  MASTERDATA_BIZ_USER_CSV_FILE_EXTENSION: 'label.masterdata.biz_user_csv_file_extension',
  /** CSVファイルの件数は{0}件以内にしてください。 */
  MASTERDATA_BIZ_USER_CSV_FILE_REC_COUNT: 'label.masterdata.biz_user_csv_file_rec_count',
  /** {0}を入力してください。 */
  MASTERDATA_BIZ_USER_PLEASE_ENTER: 'label.masterdata.biz_user_please_enter',
  /** {0}は{1}文字以内で入力してください。 */
  MASTERDATA_BIZ_USER_PLEASE_ENTER_CHAR: 'label.masterdata.biz_user_please_enter_char',
  /** {0}は半角英数字・記号（-=^_'{}'~@.）を使用してください。 */
  MASTERDATA_BIZ_USER_USE_ID_CHAR: 'label.masterdata.biz_user_use_id_char',
  /** {0}の先頭と末尾に記号（-~.）は使用できません。 */
  MASTERDATA_BIZ_USER_ID_START_END_CHAR: 'label.masterdata.biz_user_id_start_end_char',
  /** {0}にはDWPで使用されているドメインを使用できません。 */
  MASTERDATA_BIZ_USER_DOMAIN_USE: 'label.masterdata.biz_user_domain_use',
  /** 既に使用されている{0}です。 */
  MASTERDATA_BIZ_USER_USED: 'label.masterdata.biz_user_used',
  /** CSVファイル内でIDが重複しています。 */
  MASTERDATA_BIZ_USER_DUP_ID: 'label.masterdata.biz_user_dup_id',
  /** {0}は半角英数字を使用してください。 */
  MASTERDATA_BIZ_USER_CHAR_USE: 'label.masterdata.biz_user_char_use',
  /** 入力された組織コードに一致する組織が存在しません。 */
  MASTERDATA_BIZ_USER_SOSHIKI_EXIST: 'label.masterdata.biz_user_soshiki_exist',
  /** 自身が所属する会社以外の利用者登録は行えません。 */
  MASTERDATA_BIZ_USER_OWN_ORG_REGIST: 'label.masterdata.biz_user_own_org_regist',
  /** 自身が所属する会社以外の利用者削除は行えません。 */
  MASTERDATA_BIZ_USER_OWN_ORG_DELETE: 'label.masterdata.biz_user_own_org_delete',
  /** 利用者登録されていないIDです。 */
  MASTERDATA_BIZ_USER_NON_REGIST_USER: 'label.masterdata.biz_user_non_regist_user',
  /** CSVファイル内に異なる会社の情報が設定されています。 */
  MASTERDATA_BIZ_USER_CSV_DIFF_KAISHA: 'label.masterdata.biz_user_csv_diff_kaisha',
  /** 使用できない{0}が入力されています。 */
  MASTERDATA_BIZ_USER_UNUSABLE_CHAR: 'label.masterdata.biz_user_unusable_char',
  /** {0}は利用者の所属組織より下位の組織管理者を設定することはできません。 */
  MASTERDATA_BIZ_USER_NOT_SUB_ORGANIZATION: 'label.masterdata.biz_user_not_sub_organization',
  /** {0}は全角カナ・全角スペースを使用してください。 */
  MASTERDATA_BIZ_USER_USE_FW_KANA: 'label.masterdata.biz_user_use_fw_kana',
  /** 存在しない拠点番号が設定されています。 */
  MASTERDATA_BIZ_USER_NON_EXIST_BASE: 'label.masterdata.biz_user_non_exist_base',
  /** {0}が正しいメールアドレスの形式ではありません。 */
  MASTERDATA_BIZ_USER_VALID_EMAIL_ADDRESS: 'label.masterdata.biz_user_valid_email_address',
  /** {0}は{1}文字以上～{2}文字以内で入力してください。 */
  MASTERDATA_BIZ_USER_CHAR_RANGE: 'label.masterdata.biz_user_char_range',
  /** {0}は半角英数字・記号（!#$%&*+-.:;=?@^_）を使用してください。 */
  MASTERDATA_BIZ_USER_USE_PASSWORD_CHAR: 'label.masterdata.biz_user_use_password_char',
  /** {0}は半角英字大文字・半角英字小文字・半角数字が各1文字以上含まれている必要があります。 */
  MASTERDATA_BIZ_USER_PASSWORD_POLICY: 'label.masterdata.biz_user_password_policy',
  /** 入力した{0}は既に存在します。 */
  MASTERDATA_BIZ_USER_ALREADY_EXISTS: 'label.masterdata.biz_user_already_exists',
  /** 半角英数字・記号（-=^_'{}'~@.）を使用してください。 */
  MASTERDATA_BIZ_USER_REGISTER_USE_ID_CHAR: 'label.masterdata.biz_user_register_use_id_char',
  /** 先頭と末尾に記号（-~.）は使用できません。 */
  MASTERDATA_BIZ_USER_REGISTER_ID_START_END_CHAR: 'label.masterdata.biz_user_register_id_start_end_char',
  /** DWPで使用されているドメインを使用できません。 */
  MASTERDATA_BIZ_USER_REGISTER_DOMAIN_USE: 'label.masterdata.biz_user_register_domain_use',
  /** 利用者の所属組織より下位の組織管理者を設定することはできません。 */
  MASTERDATA_BIZ_USER_REGISTER_NOT_SUB_ORGANIZATION: 'label.masterdata.biz_user_register_not_sub_organization',
  /** 全角カナを使用してください。 */
  MASTERDATA_BIZ_USER_REGISTER_USE_FW_KANA: 'label.masterdata.biz_user_register_use_fw_kana',
  /** 正しいメールアドレスの形式ではありません。 */
  MASTERDATA_BIZ_USER_REGISTER_VALID_EMAIL_ADDRESS: 'label.masterdata.biz_user_register_valid_email_address',
  /** {0}文字以上～{1}文字以内で入力してください。 */
  MASTERDATA_BIZ_USER_REGISTER_CHAR_RANGE: 'label.masterdata.biz_user_register_char_range',
  /** 半角英数字・記号（!#$%&*+-.:;=?@^_）を使用してください。 */
  MASTERDATA_BIZ_USER_REGISTER_USE_PASSWORD_CHAR: 'label.masterdata.biz_user_register_use_password_char',
  /** 半角英字大文字・半角英字小文字・半角数字が各1文字以上含まれている必要があります。 */
  MASTERDATA_BIZ_USER_REGISTER_PASSWORD_POLICY: 'label.masterdata.biz_user_register_password_policy',
  /** 入力したIDは既に存在します。 */
  MASTERDATA_BIZ_USER_REGISTER_ALREADY_EXISTS: 'label.masterdata.biz_user_register_already_exists',
  /** 新規登録／差分更新を実行します。よろしいですか？ */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_DIALOG_MESSAGE: 'label.masterdata.biz_user_csv_upload_dialog_message',
  /** 削除を実行します。よろしいですか？ */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_DELETE_DIALOG_MESSAGE: 'label.masterdata.biz_user_csv_upload_delete_dialog_message',
  /** 以下の利用者を新規登録・差分更新しました。 */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_RESULT_MESSAGE: 'label.masterdata.biz_user_csv_upload_result_message',
  /** 以下の利用者を削除しました。 */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_DELETE_RESULT_MESSAGE: 'label.masterdata.biz_user_csv_upload_delete_result_message',
  /** CSVデータ不正により更新できませんでした。エラー一覧を確認し、修正したファイルを再度アップロードしてください。 */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_ERROR_RESULT_MESSAGE: 'label.masterdata.biz_user_csv_upload_error_result_message',
  /** 処理中です。画面はこのままでしばらくお待ちください。 */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_LOADING_MESSAGE: 'label.masterdata.biz_user_csv_upload_loading_message',
  /** エラー一覧 */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_ERROR_LIST: 'label.masterdata.biz_user_csv_upload_error_list',
  /** 利用者新規登録／差分更新一覧 */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_REGISTUPLOAD_LIST: 'label.masterdata.biz_user_csv_upload_registupload_list',
  /** 利用者削除一覧 */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_DELETE_LIST: 'label.masterdata.biz_user_csv_upload_delete_list',
  /** アップロード画面へ戻る */
  MASTERDATA_BIZ_USER_CSV_UPLOAD_RETURN_UPLOAD: 'label.masterdata.biz_user_csv_upload_return_upload',
  /** CSVファイル */
  MASTERDATA_BIZ_USER_CSV_FILE: 'label.masterdata.biz_user_csv_file',
  /** CSVファイル選択 */
  MASTERDATA_BIZ_USER_CSV_FILE_SELECT: 'label.masterdata.biz_user_csv_file_select',
  /** 更新方法 */
  MASTERDATA_BIZ_USER_UPDATE_METHOD: 'label.masterdata.biz_user_update_method',
  /** 行 */
  MASTERDATA_BIZ_USER_LINE: 'label.masterdata.biz_user_line',
  /** エラー内容 */
  MASTERDATA_BIZ_USER_ERROR_CONTENT: 'label.masterdata.biz_user_error_content',
  /** ID */
  MASTERDATA_BIZ_USER_ID: 'label.masterdata.biz_user_id',
  /** 会社／組織 */
  MASTERDATA_BIZ_USER_KAISHA_SOSHIKI: 'label.masterdata.biz_user_kaisha_soshiki',
  /** 会社／組織選択 */
  MASTERDATA_BIZ_USER_KAISHA_SOSHIKI_SELECT: 'label.masterdata.biz_user_kaisha_soshiki_select',
  /** 1st組織コード */
  MASTERDATA_BIZ_USER_SOSHIKI1: 'label.masterdata.biz_user_soshiki1',
  /** 2nd組織コード */
  MASTERDATA_BIZ_USER_SOSHIKI2: 'label.masterdata.biz_user_soshiki2',
  /** 3rd組織コード */
  MASTERDATA_BIZ_USER_SOSHIKI3: 'label.masterdata.biz_user_soshiki3',
  /** 4th組織コード */
  MASTERDATA_BIZ_USER_SOSHIKI4: 'label.masterdata.biz_user_soshiki4',
  /** 5th組織コード */
  MASTERDATA_BIZ_USER_SOSHIKI5: 'label.masterdata.biz_user_soshiki5',
  /** 6th組織コード */
  MASTERDATA_BIZ_USER_SOSHIKI6: 'label.masterdata.biz_user_soshiki6',
  /** 7th組織コード */
  MASTERDATA_BIZ_USER_SOSHIKI7: 'label.masterdata.biz_user_soshiki7',
  /** 8th組織コード */
  MASTERDATA_BIZ_USER_SOSHIKI8: 'label.masterdata.biz_user_soshiki8',
  /** 9th組織コード */
  MASTERDATA_BIZ_USER_SOSHIKI9: 'label.masterdata.biz_user_soshiki9',
  /** 10th組織コード */
  MASTERDATA_BIZ_USER_SOSHIKI10: 'label.masterdata.biz_user_soshiki10',
  /** 姓名 */
  MASTERDATA_BIZ_USER_SEI_MEI: 'label.masterdata.biz_user_sei_mei',
  /** アクセス権限 */
  MASTERDATA_BIZ_USER_ACCESS_AUTH: 'label.masterdata.biz_user_access_auth',
  /** カナ姓 */
  MASTERDATA_BIZ_USER_SEI_KTKN: 'label.masterdata.biz_user_sei_ktkn',
  /** カナ名 */
  MASTERDATA_BIZ_USER_MEI_KTKN: 'label.masterdata.biz_user_mei_ktkn',
  /** 姓 */
  MASTERDATA_BIZ_USER_SEI_KANJI: 'label.masterdata.biz_user_sei_kanji',
  /** 名 */
  MASTERDATA_BIZ_USER_MEI_KANJI: 'label.masterdata.biz_user_mei_kanji',
  /** ユーザ設定コード */
  MASTERDATA_BIZ_USER_CUSTOMER_CD: 'label.masterdata.biz_user_customer_cd',
  /** 拠点番号 */
  MASTERDATA_BIZ_USER_SITE_NO: 'label.masterdata.biz_user_site_no',
  /** 拠点 */
  MASTERDATA_BIZ_USER_SITE: 'label.masterdata.biz_user_site',
  /** 勤務場所都道府県コード */
  MASTERDATA_BIZ_USER_WORKPLACE_TDFK_CD: 'label.masterdata.biz_user_workplace_tdfk_cd',
  /** 自宅場所都道府県コード */
  MASTERDATA_BIZ_USER_JUSYO_TDFK_CD1: 'label.masterdata.biz_user_jusyo_tdfk_cd1',
  /** その他滞在場所都道府県コード */
  MASTERDATA_BIZ_USER_JUSYO_TDFK_CD2: 'label.masterdata.biz_user_jusyo_tdfk_cd2',
  /** 勤務場所都道府県 */
  MASTERDATA_BIZ_USER_WORKPLACE_TDFK: 'label.masterdata.biz_user_workplace_tdfk',
  /** 自宅場所都道府県 */
  MASTERDATA_BIZ_USER_JUSYO_TDFK1: 'label.masterdata.biz_user_jusyo_tdfk1',
  /** その他滞在場所都道府県 */
  MASTERDATA_BIZ_USER_JUSYO_TDFK2: 'label.masterdata.biz_user_jusyo_tdfk2',
  /** 連絡先MAIL1 */
  MASTERDATA_BIZ_USER_MAIL_ADDRESS1: 'label.masterdata.biz_user_mail_address1',
  /** 連絡先MAIL2 */
  MASTERDATA_BIZ_USER_MAIL_ADDRESS2: 'label.masterdata.biz_user_mail_address2',
  /** 連絡先MAIL3 */
  MASTERDATA_BIZ_USER_MAIL_ADDRESS3: 'label.masterdata.biz_user_mail_address3',
  /** パスワード */
  MASTERDATA_BIZ_USER_WEB_AUTH_PASSWORD: 'label.masterdata.biz_user_web_auth_password',
  /** 新しいパスワード */
  MASTERDATA_BIZ_USER_NEW_WEB_AUTH_PASSWORD: 'label.masterdata.biz_user_new_web_auth_password',
  /** パスワード生成 */
  MASTERDATA_BIZ_USER_WEB_AUTH_PASSWORD_GENERATE: 'label.masterdata.biz_user_web_auth_password_generate',
  /** 更新日時 */
  MASTERDATA_BIZ_USER_UPD_DT: 'label.masterdata.biz_user_upd_dt',
  /** 更新日時（From） */
  MASTERDATA_BIZ_USER_UPD_DT_FROM: 'label.masterdata.biz_user_upd_dt_from',
  /** 更新日時（To） */
  MASTERDATA_BIZ_USER_UPD_DT_TO: 'label.masterdata.biz_user_upd_dt_to',
  /** 社員 */
  MASTERDATA_BIZ_USER_SEARCH_SHAIN: 'label.masterdata.biz_user_search_shain',
  /** 構内作業者 */
  MASTERDATA_BIZ_USER_SEARCH_KONAI: 'label.masterdata.biz_user_search_konai',
  /** 在職中 */
  MASTERDATA_BIZ_USER_SEARCH_ZAISYOKUCHU: 'label.masterdata.biz_user_search_zaisyokuchu',
  /** 休職中 */
  MASTERDATA_BIZ_USER_SEARCH_KYUSYOKUCHU: 'label.masterdata.biz_user_search_kyusyokuchu',
  /** 利用者登録 */
  MASTERDATA_BIZ_USER_REGISTER_TITLE: 'label.masterdata.biz_user_register_title',
  /** 利用者登録結果 */
  MASTERDATA_BIZ_USER_REGISTER_RESULT_TITLE: 'label.masterdata.biz_user_register_result_title',
  /** 利用者検索 */
  MASTERDATA_BIZ_USER_SEARCH_TITLE: 'label.masterdata.biz_user_search_title',
  /** 利用者詳細 */
  MASTERDATA_BIZ_USER_SEARCH_DETAIL_TITLE: 'label.masterdata.biz_user_search_detail_title',
  /** 利用者更新 */
  MASTERDATA_BIZ_USER_SEARCH_UPDATE_TITLE: 'label.masterdata.biz_user_search_update_title',
  /** 利用者更新結果 */
  MASTERDATA_BIZ_USER_SEARCH_UPDATE_RESULT_TITLE: 'label.masterdata.biz_user_search_update_result_title',
  /** 利用者削除 */
  MASTERDATA_BIZ_USER_SEARCH_DELETE_TITLE: 'label.masterdata.biz_user_search_delete_title',
  /** 利用者削除結果 */
  MASTERDATA_BIZ_USER_SEARCH_DELETE_RESULT_TITLE: 'label.masterdata.biz_user_search_delete_result_title',
  /** 検索結果をCSVファイル形式で出力 */
  MASTERDATA_BIZ_USER_SEARCH_CSV_DOWNLOAD: 'label.masterdata.biz_user_search_csv_download',
  /** 　 */
  MASTERDATA_BIZ_USER_SEARCH_KUURAN: 'label.masterdata.biz_user_search_kuuran',
  /** 利用者登録に関する補足事項 */
  MASTERDATA_BIZ_USER_SUPPL: 'label.masterdata.biz_user_suppl',
  /** ※必ずお読みください。 */
  MASTERDATA_BIZ_USER_SUPPL_READ: 'label.masterdata.biz_user_suppl_read',
  /** ・メールアドレスを設定することを推奨しています<br />\n         ・40文字以下<br />\n         ・半角英字（大文字／小文字）・数字・記号（-=^_{}~@.）以外入力不可<br /> */
  MASTERDATA_BIZ_USER_ID_HELP: 'label.masterdata.biz_user_id_help',
  /** 全角カタカナ */
  MASTERDATA_BIZ_USER_KTKN_HELP: 'label.masterdata.biz_user_ktkn_help',
  /** ・8~32文字以下<br />\n         ・半角英字大文字・半角英字小文字・半角数字を各1文字以上含む<br />\n         ・半角英字（大文字／小文字）・数字・記号（!#$%&*+-.:;=?@^_）以外入力不可<br /> */
  MASTERDATA_BIZ_USER_PASSWORD_REGISTER_HELP: 'label.masterdata.biz_user_password_register_help',
  /** ・パスワードを変更する場合のみ入力してください<br />\n         ・8~32文字以下<br />\n         ・半角英字大文字・半角英字小文字・半角数字を各1文字以上含む<br />\n         ・半角英字（大文字／小文字）・数字・記号（!#$%&*+-.:;=?@^_）以外入力不可<br /> */
  MASTERDATA_BIZ_USER_PASSWORD_UPDATE_HELP: 'label.masterdata.biz_user_password_update_help',
  /** テンプレートファイル */
  MASTERDATA_BIZ_USER_CSV_TEMPLATE_FILE: 'label.masterdata.biz_user_csv_template_file',
  /** 利用者登録機能操作マニュアル */
  MASTERDATA_BIZ_USER_MANUAL: 'label.masterdata.biz_user_manual',
  /** ・CSVファイルのテンプレートファイルをダウンロード、または、利用者情報検索からCSVファイルをダウンロードし、アップロードするCSVファイルを作成してください。<br /> */
  MASTERDATA_BIZ_USER_CSV_FILE1_HELP: 'label.masterdata.biz_user_csv_file1_help',
  /** ・利用者アップロード（CSV）の詳細については、以下のマニュアルを参照ください。<br /> */
  MASTERDATA_BIZ_USER_CSV_FILE2_HELP: 'label.masterdata.biz_user_csv_file2_help',
  /** ・本機能で登録・更新・削除された利用者は、１日１回の夜間バッチでBiz安否確認／一斉通報サービスに連携されます。<br />\n           Biz安否確認／一斉通報サービスの利用者の登録状態を確認する場合は、翌日以降にBiz安否確認／一斉通報サービスにログインし、ご確認ください。<br /> */
  MASTERDATA_BIZ_USER_CSV_FILE3_HELP: 'label.masterdata.biz_user_csv_file3_help',
  /** ・CSV形式（半角カンマ区切り）です。<br />\n         ・文字コードはUTF-8です。<br />\n         ・改行コードは0x0D0A（CR + LF）です。<br />\n         ・ファイルの拡張子は「.csv」です。<br />\n         ・CSVファイルの１行目は項目名として認識するため登録されません。<br />\n         ・CSVファイル中に入力チェックエラーの行が存在した場合は、CSVファイル中のすべてのデータの登録・更新・削除は行われません。<br /> */
  MASTERDATA_BIZ_USER_CSV_FILE_HINT: 'label.masterdata.biz_user_csv_file_hint',
  /** <span style="font-weight:bold">新規登録／差分更新</span><br />\n         CSVファイルに存在するデータのみ上書きします。<br />\n         既に登録されている利用者は更新され、登録されていない利用者は新規登録されます。<br />\n         <br />\n         <span style="font-weight:bold">削除</span><br />\n         CSVファイルに存在する利用者を削除します。 */
  MASTERDATA_BIZ_USER_UPDATE_METHOD_HINT: 'label.masterdata.biz_user_update_method_hint',
  /** 検索条件を入力し、検索ボタンを押してください。<br />\n         OneNEC事業継続支援システム内の機能から利用者登録されたBiz安否確認／一斉通報サービス利用者を検索できます。<br />\n         検索結果はCSVとしてダウンロードすることも可能です。 */
  MASTERDATA_BIZ_USER_SEARCH_METHOD_HELP: 'label.masterdata.biz_user_search_method_help',
  /** 利用者登録の詳細については、以下のマニュアルを参照ください。<br /> */
  MASTERDATA_BIZ_USER_REGISTER_MANUAL_HELP: 'label.masterdata.biz_user_register_manual_help',
  /** 利用者検索の詳細については、以下のマニュアルを参照ください。<br /> */
  MASTERDATA_BIZ_USER_SEARCH_MANUAL_HELP: 'label.masterdata.biz_user_search_manual_help',
  /** 個人情報設定 */
  USERCUSTOM_PERSONAL_REGISTER_INPUT: 'label.usercustom.personal_register_input',
  /** 個人情報設定結果 */
  USERCUSTOM_PERSONAL_REGISTER_RESULT: 'label.usercustom.personal_register_result',
  /** 勤務場所更新日時 */
  USERCUSTOM_WORKPLACE_UPDATE_DATE: 'label.usercustom.workplace_update_date',
  /** 自宅場所更新日時 */
  USERCUSTOM_HOMEPLACE_UPDATE_DATE: 'label.usercustom.homeplace_update_date',
  /** その他滞在場所更新日時 */
  USERCUSTOM_OTHERPLACE_UPDATE_DATE: 'label.usercustom.otherplace_update_date',
  /** グループ検索 */
  USERCUSTOM_GROUP_SEARCH: 'label.usercustom.group_search',
  /** <span style='font-weight: bold'>入力例</span><br/>玉川ルネッサンスシティN棟 */
  USERCUSTOM_GOUTOU_INFO: 'label.usercustom.goutou_info',
  /** 階層を入力します。<br/><span style='font-weight: bold'>入力例</span><br/>3階：3<br/>中2階：M2<br/>地下1階：B1<br/>※中階はM、地階はBを使用します。 */
  USERCUSTOM_FLOOR_INFO: 'label.usercustom.floor_info',
  /** <span style='font-weight: bold'>入力例</span><br/>西側 */
  USERCUSTOM_WORKSPACE_INFO: 'label.usercustom.workspace_info',
  /** NECグループ被災情報 */
  USERCUSTOM_GROUP_HISAI: 'label.usercustom.group_hisai',
  /** 表示対象 */
  USERCUSTOM_DISPLAY_TARGET: 'label.usercustom.display_target',
  /** NECグループ被災情報表示対象 */
  USERCUSTOM_GROUP_DAMAGE_INFOMATION_DISPLAY_TARGET: 'label.usercustom.group_damage_infomation_display_target',
  /** リストから探す */
  USERCUSTOM_LIST_SEARCHS: 'label.usercustom.list_searchs',
  /** リストにない拠点を入力する */
  USERCUSTOM_INPUT_LIST: 'label.usercustom.input_list',
  /** <span style='font-weight: bold'>入力例</span><br/>玉川プロジェクト */
  USERCUSTOM_SITE_OTHER_NM_HINT: 'label.usercustom.site_other_nm_hint',
  /** 人事連携済み */
  USERCUSTOM_LINKAGE_PERSONAL: 'label.usercustom.linkage_personal',
  /** （人事情報連携済み） */
  USERCUSTOM_LINKAGE_PERSONAL_INFO: 'label.usercustom.linkage_personal_info',
  /** 出張などで、勤務場所・自宅場所と異なる都道府県に滞在している場合に設定してください。 */
  USERCUSTOM_OTHER_STAY_PLACE_HINT: 'label.usercustom.other_stay_place_hint',
  /** 更新日時 */
  USERCUSTOM_UPDATE_DATE: 'label.usercustom.update_date',
  /** メールアドレス更新日時 */
  USERCUSTOM_MAIL_ADDRESS_UPDATE_DATE: 'label.usercustom.mail_address_update_date',
  /** 以下の内容で設定しました。 */
  USERCUSTOM_SET_ACTION_MESSAGE: 'label.usercustom.set_action_message',
  /** マスタ情報登録済み */
  USERCUSTOM_LINKAGE_MASTER_DATA: 'label.usercustom.linkage_master_data',
  /** （マスタ情報登録済み） */
  USERCUSTOM_LINKAGE_MASTER_DATA_INFO: 'label.usercustom.linkage_master_data_info',
  /** メールアドレス１ */
  USERCUSTOM_MAIL_ADDRESS_1: 'label.usercustom.mail_address_1',
  /** メールアドレス２ */
  USERCUSTOM_MAIL_ADDRESS_2: 'label.usercustom.mail_address_2',
  /** メールアドレス３ */
  USERCUSTOM_MAIL_ADDRESS_3: 'label.usercustom.mail_address_3',
  /** 設定した個人情報はBiz安否確認／一斉通報で以下の際に利用できます。<div style='font-weight: bold'>災害発生時やお知らせのPush通知</div>・勤務場所の都道府県<br/>・自宅場所の都道府県<br/>・その他滞在場所の都道府県<br/>・メールアドレス１、メールアドレス２、メールアドレス３<div style='font-weight: bold'>Biz安否確認／一斉通報のパスワードの再設定</div>・メールアドレス１、メールアドレス２、メールアドレス３<div style='font-weight: bold'>Biz安否確認／一斉通報の安否検索の検索条件（ロケーション）</div>・勤務場所の拠点<br/><br/>※人事連携されている勤務場所・自宅場所に変更がある場合、人事情報システムで変更してください。 */
  USERCUSTOM_USERCUSTOM_HELP: 'label.usercustom.usercustom_help',
  /** 設定した勤務場所は以下の際に利用できます。<div style='font-weight: bold'>災害発生時やお知らせのPush通知</div>・都道府県<div style='font-weight: bold'>Biz安否確認／一斉通報の安否検索の検索条件（ロケーション）</div>・拠点 */
  USERCUSTOM_WORKPLACE_HELP: 'label.usercustom.workplace_help',
  /** 設定した自宅場所は以下の際に利用できます。<div style='font-weight: bold'>災害発生時やお知らせのPush通知</div>・都道府県 */
  USERCUSTOM_HOMEPLACE_HELP: 'label.usercustom.homeplace_help',
  /** 設定したその他滞在場所は以下の際に利用できます。<div style='font-weight: bold'>災害発生時やお知らせのPush通知</div>・都道府県<br/>※出張等により勤務場所・自宅場所と異なる都道府県に滞在している場合に設定してください。 */
  USERCUSTOM_OTHER_HELP: 'label.usercustom.other_help',
  /** 設定したメールアドレスは以下の場合に利用できます。<div style='font-weight: bold'>・災害発生時やお知らせのPush通知<br/>・Biz安否確認／一斉通報のパスワードの再設定</div> */
  USERCUSTOM_MAIL_ADDRESS_HELP: 'label.usercustom.mail_address_help',
  /** 感染症報告 */
  PANDE_REPORT_TITLE: 'label.pande.report_title',
  /** 感染症検索 */
  PANDE_PANDE_SEARCH: 'label.pande.pande_search',
  /** 感染症集計 */
  PANDE_PANDE_TOTALIZE: 'label.pande.pande_totalize',
  /** 報告対象指定 */
  PANDE_REPORT_TARGET_DESIGNATION: 'label.pande.report_target_designation',
  /** 管理番号 */
  PANDE_REPORT_NO: 'label.pande.report_no',
  /** （NECg） */
  PANDE_NEC_GROUP: 'label.pande.nec_group',
  /** 報告対象入力確定 */
  PANDE_REPORT_TARGET_INPUT_FIX: 'label.pande.report_target_input_fix',
  /** 管理番号で検索 */
  PANDE_SEARCH_REPORT_NO: 'label.pande.search_report_no',
  /** 一覧から選択 */
  PANDE_SELECT_FROM_LIST: 'label.pande.select_from_list',
  /** 報告対象者選択 */
  PANDE_SELECT_REPORT_TARGET: 'label.pande.select_report_target',
  /** 前回報告者 */
  PANDE_LAST_REPORTER: 'label.pande.last_reporter',
  /** 前回報告者会社／組織 */
  PANDE_LAST_REPORTER_KAISHA_SOSHIKI: 'label.pande.last_reporter_kaisha_soshiki',
  /** 前回報告日時 */
  PANDE_LAST_REPORT_DATE: 'label.pande.last_report_date',
  /** 報告対象変更 */
  PANDE_REPORT_TARGET_CHANGE: 'label.pande.report_target_change',
  /** 報告 */
  PANDE_REPORT: 'label.pande.report',
  /** 確認中 */
  PANDE_CONFIRMING: 'label.pande.confirming',
  /** 属性 */
  PANDE_ATTRIBUTE: 'label.pande.attribute',
  /** 派遣元会社名／協力会社名 */
  PANDE_COOP_KAISHA_NM: 'label.pande.coop_kaisha_nm',
  /** 報告対象者の状態 */
  PANDE_REPORT_STATUS: 'label.pande.report_status',
  /** 基礎情報 */
  PANDE_REPORT_BASE_INFO: 'label.pande.report_base_info',
  /** 担当顧客・業務 */
  PANDE_CUSTOMER_BUSINESSINCHARGE: 'label.pande.customer_businessincharge',
  /** 保健所からの濃厚接触者指定有無 */
  PANDE_CLOSECONTACT: 'label.pande.closecontact',
  /** 濃厚接触者指定有無 */
  PANDE_CLOSECONTACT_LIST: 'label.pande.closecontact_list',
  /** 濃厚接触者に指定された理由 */
  PANDE_CLOSECONTACT_REASON: 'label.pande.closecontact_reason',
  /** 関連管理番号（necg） */
  PANDE_RELATION_REPORT_NO: 'label.pande.relation_report_no',
  /** 症状有無 */
  PANDE_SHOJO_UMU: 'label.pande.shojo_umu',
  /** 発症日 */
  PANDE_HASSHO_DT: 'label.pande.hassho_dt',
  /** 発症２日前以降の出社 */
  PANDE_SHUSSHA: 'label.pande.shussha',
  /** 発症２日前以降の顧客との接触 */
  PANDE_CUSTOMER_CONTACT: 'label.pande.customer_contact',
  /** 最終出社日 */
  PANDE_LAST_WORK_DT: 'label.pande.last_work_dt',
  /** 住所（都道府県～市区町村まで） */
  PANDE_ADDRESS: 'label.pande.address',
  /** 年齢、性別 */
  PANDE_AGE_SEX: 'label.pande.age_sex',
  /** 同居家族有無 */
  PANDE_DOKYO_KAZOKU: 'label.pande.dokyo_kazoku',
  /** 本人との連絡可否（職場上司経由／協力会社経由） */
  PANDE_CONTACT_ENTRY: 'label.pande.contact_entry',
  /** 症状 */
  PANDE_SHOJO: 'label.pande.shojo',
  /** 症状歴、今後の予定 */
  PANDE_SHOJO_HISTORY: 'label.pande.shojo_history',
  /** 検査結果 */
  PANDE_KENSA_RST: 'label.pande.kensa_rst',
  /** 検査日 */
  PANDE_KENSA_DT: 'label.pande.kensa_dt',
  /** （予定含む） */
  PANDE_INCLUDING_APPOINTMENT: 'label.pande.including_appointment',
  /** 診断した医療機関 */
  PANDE_IRYOKIKAN: 'label.pande.iryokikan',
  /** 検査結果判明日 */
  PANDE_KENSA_RST_DT: 'label.pande.kensa_rst_dt',
  /** 対応保健所（市区町村まで） */
  PANDE_HEALTH_CENTER: 'label.pande.health_center',
  /** 治療方針 */
  PANDE_TREATMENTS_POLICY: 'label.pande.treatments_policy',
  /** 重症 */
  PANDE_SERIOUS: 'label.pande.serious',
  /** 療養終了日 */
  PANDE_TREATMENTS_END_DT: 'label.pande.treatments_end_dt',
  /** 死亡日 */
  PANDE_DEATH_DT: 'label.pande.death_dt',
  /** 他 */
  PANDE_OTHER: 'label.pande.other',
  /** 職場内での発熱者有無 */
  PANDE_HATSUNETSUSHA: 'label.pande.hatsunetsusha',
  /** （フロア対応／同居家族検査実施状況など） */
  PANDE_OTHER_NOTES: 'label.pande.other_notes',
  /** 勤務状況・立ち入り場所 */
  PANDE_WORKSTATUS_ENTRYPLACE: 'label.pande.workstatus_entryplace',
  /** 有無 */
  PANDE_UMU: 'label.pande.umu',
  /** 勤務の有無 */
  PANDE_WORKSTATUS: 'label.pande.workstatus',
  /** NECg内外 */
  PANDE_NECG_NAIGAI: 'label.pande.necg_naigai',
  /** 立ち入り場所 */
  PANDE_ENTRYPLACE: 'label.pande.entryplace',
  /** ビル名 */
  PANDE_BUILDING_NAME: 'label.pande.building_name',
  /** 風邪症状 */
  PANDE_COLD_SYMPTOMS: 'label.pande.cold_symptoms',
  /** 濃厚接触可能性者情報の報告登録 */
  PANDE_REPORT_REGISTRATION_FULL: 'label.pande.report_registration_full',
  /** 報告登録 */
  PANDE_REPORT_REGISTRATION: 'label.pande.report_registration',
  /** NECg内の担当窓口 */
  PANDE_CONTACTPERSON: 'label.pande.contactperson',
  /** 関係会社内 */
  PANDE_CHILD: 'label.pande.child',
  /** NEC（営業等） */
  PANDE_NEC: 'label.pande.nec',
  /** 接触 */
  PANDE_CONTACT: 'label.pande.contact',
  /** 最終接触日 */
  PANDE_LAST_CONTACT_DT: 'label.pande.last_contact_dt',
  /** 座席間隔 */
  PANDE_SEAT_SPACING: 'label.pande.seat_spacing',
  /** 会話 */
  PANDE_TALK: 'label.pande.talk',
  /** 接触時間 */
  PANDE_CONTACT_TIME: 'label.pande.contact_time',
  /** 接触時のマスク着用 */
  PANDE_MASK_CHAKUYO: 'label.pande.mask_chakuyo',
  /** 報告対象者 */
  PANDE_REPORT_TARGET_USER: 'label.pande.report_target_user',
  /** 接触者 */
  PANDE_CLOSE_CONTACT: 'label.pande.close_contact',
  /** 濃厚接触可能性者情報（NECg社員） */
  PANDE_CLOSECONTACT_NECG: 'label.pande.closecontact_necg',
  /** 濃厚接触可能性者情報（派遣・請負） */
  PANDE_CLOSECONTACT_OTHER: 'label.pande.closecontact_other',
  /** 濃厚接触可能性者情報（顧客） */
  PANDE_CLOSECONTACT_CUSTOMER: 'label.pande.closecontact_customer',
  /** 濃厚接触可能性者（NECg社員） */
  PANDE_CLOSECONTACT_NECG_ITEM: 'label.pande.closecontact_necg_item',
  /** 濃厚接触可能性者（派遣・請負） */
  PANDE_CLOSECONTACT_OTHER_ITEM: 'label.pande.closecontact_other_item',
  /** 濃厚接触可能性者（顧客） */
  PANDE_CLOSECONTACT_CUSTOMER_ITEM: 'label.pande.closecontact_customer_item',
  /** 事務所・店舗等 */
  PANDE_BRANCH_NM: 'label.pande.branch_nm',
  /** 所属 */
  PANDE_AFFILIATION: 'label.pande.affiliation',
  /** 顧客窓口（営業等） */
  PANDE_CONTACTPERSON_EIGYO: 'label.pande.contactperson_eigyo',
  /** 報告者・同報先情報 */
  PANDE_REPORTER_BCC: 'label.pande.reporter_bcc',
  /** メール送信 */
  PANDE_MAIL_SEND: 'label.pande.mail_send',
  /** 有り */
  PANDE_MAIL_SEND_ARI: 'label.pande.mail_send_ari',
  /** 座席表 */
  PANDE_SHEET_MAP: 'label.pande.sheet_map',
  /** （感染疑い者から半径1m以内を明示） */
  PANDE_SHEAT_MAP_1M: 'label.pande.sheat_map_1m',
  /** 確認したい情報 */
  PANDE_WANTTO_CHECK: 'label.pande.wantto_check',
  /** 管理番号（necg） */
  PANDE_REPORT_NO_NECG: 'label.pande.report_no_necg',
  /** 報告状況 */
  PANDE_SITUATION: 'label.pande.situation',
  /** 初回報告日 */
  PANDE_FIRST_REPORT_DT: 'label.pande.first_report_dt',
  /** 最終報告日 */
  PANDE_END_REPORT_DT: 'label.pande.end_report_dt',
  /** 最終報告日（遅延アラート） */
  PANDE_END_REPORT_DT_PROGRESS: 'label.pande.end_report_dt_progress',
  /** 確認中項目 */
  PANDE_CONFIRMING_ITEMS: 'label.pande.confirming_items',
  /** 以降 */
  PANDE_LATOR: 'label.pande.lator',
  /** 濃厚接触者指定 */
  PANDE_TOT_CLOSECONTACT: 'label.pande.tot_closecontact',
  /** 感染（疑い）者 */
  PANDE_TOT_KANSEN: 'label.pande.tot_kansen',
  /** 新しい報告を登録する */
  PANDE_REPORT_TARGET_TYPE_NEW: 'label.pande.report_target_type_new',
  /** 登録済みの報告を修正する（続報の登録もこちら） */
  PANDE_REPORT_TARGET_TYPE_FOLLOWUP: 'label.pande.report_target_type_followup',
  /** 選択する */
  PANDE_REPORT_TARGET_PERSON_SELECT: 'label.pande.report_target_person_select',
  /** 入力する */
  PANDE_REPORT_TARGET_PERSON_INPUT: 'label.pande.report_target_person_input',
  /** 感染症報告入力についての補足事項 */
  PANDE_REPORT_SUPPLEMENT_MATTER: 'label.pande.report_supplement_matter',
  /** ※必ずお読みください。 */
  PANDE_INVARIABLY_READ: 'label.pande.invariably_read',
  /** 歳 */
  PANDE_AGE_SUFFIX: 'label.pande.age_suffix',
  /** 年月日 */
  PANDE_PLACE_ENTRY_DT: 'label.pande.place_entry_dt',
  /** 済み */
  PANDE_REPORT_REGISTERED: 'label.pande.report_registered',
  /** 現時点での発熱などの風邪症状 */
  PANDE_CLOSECONTACT_COLD_SYMPTOMS: 'label.pande.closecontact_cold_symptoms',
  /** 濃厚接触可能性者情報 */
  PANDE_CLOSECONTACT_POTENTIAL_INFO: 'label.pande.closecontact_potential_info',
  /** 濃厚接触可能性者（保健所からの指定なし、または調査中はこちらへ） */
  PANDE_CLOSECONTACT_KANOUSEI: 'label.pande.closecontact_kanousei',
  /** 濃厚接触者（保健所から指定を受けた場合はこちらへ） */
  PANDE_CLOSECONTACT_SHITEI: 'label.pande.closecontact_shitei',
  /** マスク着用 */
  PANDE_PUT_ON_MASK: 'label.pande.put_on_mask',
  /** 人数 */
  PANDE_NINZU: 'label.pande.ninzu',
  /** 濃厚接触可能性者 */
  PANDE_CLOSECONTACT_POTENTIAL_PERSON: 'label.pande.closecontact_potential_person',
  /** 濃厚接触者 */
  PANDE_CLOSECONTACT_PERSON: 'label.pande.closecontact_person',
  /** 顧客名 */
  PANDE_CUSTOMER_NM: 'label.pande.customer_nm',
  /** 報告者 */
  PANDE_REPORTER: 'label.pande.reporter',
  /** 初回報告者姓名 */
  PANDE_FIRST_REPORTER_NM: 'label.pande.first_reporter_nm',
  /** 初回報告者会社名 */
  PANDE_FIRST_REPORTER_KAISHA_NM: 'label.pande.first_reporter_kaisha_nm',
  /** 初回報告者組織名 */
  PANDE_FIRST_REPORTER_SOSHIKI_NM: 'label.pande.first_reporter_soshiki_nm',
  /** 最終報告日時 */
  PANDE_LAST_REPORT_DATE_TIME: 'label.pande.last_report_date_time',
  /** 前回登録内容を引用 */
  PANDE_QUOTE_PREVIOUSLY: 'label.pande.quote_previously',
  /** 変更した内容が破棄されます。よろしいですか？<br/>キャンセルを押すと元の画面に戻ります。 */
  PANDE_CONFIRM_BEFORE_MOVE: 'label.pande.confirm_before_move',
  /** 管理番号が間違っているか、管理番号の報告内容を検索できる権限がありません。 */
  PANDE_REPORT_DOES_NOT_EXIST: 'label.pande.report_does_not_exist',
  /** 宛先 */
  PANDE_MAIL_SEND_SECTION: 'label.pande.mail_send_section',
  /** {0}を追加してください。 */
  PANDE_REQUIRED_LIST_MESSAGE: 'label.pande.required_list_message',
  /** 会社／組織 */
  PANDE_KAISHA_SOSHIKI: 'label.pande.kaisha_soshiki',
  /** 全て */
  PANDE_ALL: 'label.pande.all',
  /** 管理表 */
  PANDE_REPORT_LIST: 'label.pande.report_list',
  /** 報告遅延アラート */
  PANDE_PROGRESS: 'label.pande.progress',
  /** 勤務場所 */
  PANDE_WORK_PLACE: 'label.pande.work_place',
  /** 勤務場所－拠点 */
  PANDE_WORK_PLACE_SITE: 'label.pande.work_place_site',
  /** 勤務場所－号棟 */
  PANDE_WORK_PLACE_GOUTOU: 'label.pande.work_place_goutou',
  /** 勤務場所－階 */
  PANDE_WORK_PLACE_FLOOR: 'label.pande.work_place_floor',
  /** 勤務場所－フロア */
  PANDE_WORK_PLACE_WORKSPACE: 'label.pande.work_place_workspace',
  /** 勤務場所選択 */
  PANDE_WORK_PLACE_SELECT: 'label.pande.work_place_select',
  /** リストから選択する */
  PANDE_LIST_SELECTION: 'label.pande.list_selection',
  /** リストにない拠点を入力する */
  PANDE_ENTER_SITE: 'label.pande.enter_site',
  /** 会社 */
  PANDE_COMPANY: 'label.pande.company',
  /** 会社名 */
  PANDE_COMPANY_NAME: 'label.pande.company_name',
  /** 都道府県 */
  PANDE_TDFK: 'label.pande.tdfk',
  /** 拠点 */
  PANDE_SITE: 'label.pande.site',
  /** 顧客への検査結果未報告 */
  PANDE_REPORT_TO_CUSTOMER: 'label.pande.report_to_customer',
  /** 消毒 */
  PANDE_SHODOKU: 'label.pande.shodoku',
  /** ファイルの削除が失敗しました。 */
  PANDE_FILE_DELETE_FAILED: 'label.pande.file_delete_failed',
  /** 関連する管理番号を含む */
  PANDE_INCLUDE_REL_REPORTNO: 'label.pande.include_rel_reportNo',
  /** 管理番号で検索 */
  PANDE_REPORT_SEARCH_BY_NO: 'label.pande.report_search_by_no',
  /** 一覧から検索 */
  PANDE_REPORT_SEARCH_LIST: 'label.pande.report_search_list',
  /** 報告対象者選択 */
  PANDE_REPORT_TARGET_SELECT: 'label.pande.report_target_select',
  /** ・詳細に入力する */
  PANDE_INPUT_DETAIL: 'label.pande.input_detail',
  /** ・人数のみ入力する */
  PANDE_INPUT_SIMPLE: 'label.pande.input_simple',
  /** 濃厚接触者数 */
  PANDE_REL_COUNT: 'label.pande.rel_count',
  /** 「詳細に入力する」「人数のみ入力する」のいずれかを入力してください。 */
  PANDE_REQUIRED_CLOSECONTACT_MESSAGE: 'label.pande.required_closecontact_message',
  /** TOは必ず一つ以上設定してください。 */
  PANDE_MAIL_TO_SECTION_MESSAGE: 'label.pande.mail_to_section_message',
  /** 感染症報告情報の登録に失敗しました。 */
  PANDE_REPORT_REGISTER_FAIL_MESSAGE: 'label.pande.report_register_fail_message',
  /** 報告対象者姓名 */
  PANDE_REPORT_TARGET_SEIMEI: 'label.pande.report_target_seimei',
  /** 報告対象者会社／組織 */
  PANDE_REPORT_TARGET_KAISHA_SOSHIKI: 'label.pande.report_target_kaisha_soshiki',
  /** （派遣／請負の場合は発注元のNECグループの会社／組織） */
  PANDE_REPORT_TARGET_KAISHA_SOSHIKI_DETAIL: 'label.pande.report_target_kaisha_soshiki_detail',
  /** 報告対象者会社名 */
  PANDE_REPORT_TARGET_KAISHA: 'label.pande.report_target_kaisha',
  /** 報告対象者組織名 */
  PANDE_REPORT_TARGET_SOSHIKI: 'label.pande.report_target_soshiki',
  /** （派遣／請負の場合は発注元のNECグループの会社） */
  PANDE_REPORT_TARGET_KAISHA_DETAIL: 'label.pande.report_target_kaisha_detail',
  /** （派遣／請負の場合は発注元のNECグループの組織） */
  PANDE_REPORT_TARGET_SOSHIKI_DETAIL: 'label.pande.report_target_soshiki_detail',
  /** リストにある拠点全て */
  PANDE_ALL_SITE_ON_THE_LIST: 'label.pande.all_site_on_the_list',
  /** リストにない拠点全て */
  PANDE_ALL_SITE_NOT_ON_THE_LIST: 'label.pande.all_site_not_on_the_list',
  /** この内容で報告します。よろしいですか？<br/>\n    メールが送信されますので、宛先に誤りがないか確認してください。\n    <div>\n    {0}\n    </div>\n    {1} */
  PANDE_REPORT_REGISTER_CONFIRM_MESSAGE: 'label.pande.report_register_confirm_message',
  /** 管理番号：{2}をこの内容で上書き更新します。<br/>よろしいですか？<br/>\n    メールが送信されますので、宛先に誤りがないか確認してください。\n    <div>\n    {0}\n    </div>\n    {1} */
  PANDE_REPORT_UPDATE_CONFIRM_MESSAGE: 'label.pande.report_update_confirm_message',
  /** {0}のため、当報告をクローズします。後続の報告は不要です。 */
  PANDE_REPORT_CLOSE_MESSAGE: 'label.pande.report_close_message',
  /** 当報告をクローズします。<br/>個別にヒアリングさせて頂きたく、これから届くメールをご確認ください。 */
  PANDE_REPORT_CLOSE_MESSAGE_SERIOUS: 'label.pande.report_close_message_serious',
  /** 療養終了 */
  PANDE_REPORT_CLOSE_REASON_TREATMENTS_END: 'label.pande.report_close_reason_treatments_end',
  /** 健康観察終了 */
  PANDE_REPORT_CLOSE_REASON_HEALTH_OBSERVATION_END: 'label.pande.report_close_reason_health_observation_end',
  /** 検査結果陰性 */
  PANDE_REPORT_CLOSE_REASON_TEST_NEGATIVE: 'label.pande.report_close_reason_test_negative',
  /** 感染症詳細 */
  PANDE_REPORT_DETAIL: 'label.pande.report_detail',
  /** 死亡 */
  PANDE_REPORT_CLOSE_REASON_SERIOUS_END: 'label.pande.report_close_reason_serious_end',
  /** 発症日（発熱などの風邪の諸症状が出た初日） */
  PANDE_HASSHO_DT_ENTRY: 'label.pande.hassho_dt_entry',
  /** 必ずいずれかの人数を設定してください。 */
  PANDE_CLOSECONTACT_REQUIRED_NINZU_MESSAGE: 'label.pande.closecontact_required_ninzu_message',
  /** お客様への検査結果報告 */
  PANDE_KENSA_RST_REPORT_CD: 'label.pande.kensa_rst_report_cd',
  /** 検査結果報告 */
  PANDE_KENSA_RST_REPORT_CD_RK: 'label.pande.kensa_rst_report_cd_rk',
  /** 済み */
  PANDE_KENSA_RST_REPORTED: 'label.pande.kensa_rst_reported',
  /** 本人 */
  PANDE_REPORT_TARGET_USER_RK: 'label.pande.report_target_user_rk',
  /** 感染症更新 */
  PANDE_REPORT_UPDATE: 'label.pande.report_update',
  /** 選択された都道府県・会社に一致する拠点情報はありません。 */
  PANDE_NO_SITE_LIST: 'label.pande.no_site_list',
  /** 選択された会社に一致する地域情報はありません。 */
  PANDE_NO_AREA_LIST: 'label.pande.no_area_list',
  /** 選択された地域に一致する拠点情報はありません。 */
  PANDE_NO_AREA_SITE_LIST: 'label.pande.no_area_site_list',
  /** 保健所からの濃厚接触者指定有無が「確認中」を含む */
  PANDE_INCLUDE_SUSPICIOUS: 'label.pande.include_suspicious',
  /** スイッチがON（右）の場合、保健所からの濃厚接触者指定有無が「確認中」で登録された報告を「濃厚接触者」の集計結果に含みます。<br/>集計結果から除外する場合、スイッチをOFF（左）にしてください。 */
  PANDE_INCLUDE_SUSPICIOUS_HINT: 'label.pande.include_suspicious_hint',
  /** 設定されていません */
  PANDE_NOT_SET_MAILADDRESS: 'label.pande.not_set_mailaddress',
  /** 確認したい情報を選択して検索条件を入力し、検索ボタンを押してください。<br/>感染症情報は機微な情報となるため閲覧に制限をかけております。<br/>感染症検索・集計機能の利用権限を特別に付与されている方のみ利用可能です。 */
  PANDE_SEARCH_HELP: 'label.pande.search_help',
  /** 指定した管理番号の報告に加えて、該当の管理番号を関連管理番号として登録している方の報告も検索します。<br/>\n    ※関連管理番号とは、保健所から濃厚接触者に指定される起因となった感染症報告の管理番号を示します。 */
  PANDE_SEARCH_INCLUDE_REL_REPORT_NO_HINT: 'label.pande.search_include_rel_report_no_hint',
  /** <b>濃厚接触者数</b>：保健所から濃厚接触者指定された方が、該当の管理番号の報告との関連付けをして登録した数 */
  PANDE_SEARCH_REPORT_RESULT_HELP: 'label.pande.search_report_result_help',
  /**  <b>確認中項目 </b>：内容調査中などで必須項目を未入力のままの項目が存在する場合に背景色を赤色で表示します。<br/>\n    <b>顧客への検査結果未報告</b>：顧客が濃厚接触可能性者に該当する際に、検査結果を顧客に未報告のままである場合に背景色を赤色で表示します。<br/>\n    <b>最終報告日</b>：最後の報告日から一定以上経過し、情報の更新を行っていない場合に背景色を赤色で表示します。<br/> */
  PANDE_SEARCH_PROGRESS_RESULT_HELP: 'label.pande.search_progress_result_help',
  /** 報告対象者からヒアリングした情報を入力し、「報告」ボタンを押してください。 */
  PANDE_REPORT_TITLE_HELP: 'label.pande.report_title_help',
  /** 風邪などの諸症状があり、感染症の疑いのため検査実施が決定した場合は報告登録を行ってください。<br/>また、保健所などにより、濃厚接触者と指定された場合も報告登録を行ってください。 */
  PANDE_REPORT_SUPPLEMENT_MATTER_HINT: 'label.pande.report_supplement_matter_hint',
  /** 感染者、濃厚接触者の方の姓名を入力してください。 */
  PANDE_REPORT_TARGET_SEIMEI_HINT: 'label.pande.report_target_seimei_hint',
  /** 以下の会社／組織を選択または入力してください。<br/>　NECグループ社員の場合：所属する会社／組織<br/>　派遣／請負の場合：発注元のNECグループの会社／組織<br/><br/><span style="font-weight:bold">選択する</span><br/>リストボックスに報告対象者の所属するNECg内の会社／組織が存在する場合に選択してください。<br/><span style="font-weight:bold">入力する</span><br/>リストボックスに会社／組織が存在しない場合に選択し、手入力で会社名や組織名を入力してください。 */
  PANDE_REPORT_TARGET_KAISHA_SOSHIKI_HINT: 'label.pande.report_target_kaisha_soshiki_hint',
  /** <span style="font-weight:bold">入力例</span><br/>営業部／第一営業課／第二営業グループ */
  PANDE_REPORT_TARGET_SOSHIKI_HINT: 'label.pande.report_target_soshiki_hint',
  /** 初回報告登録時に採番されたnecgの後に続く数字を入力してください。<br/>（自動応答メールの件名にも設定されています） */
  PANDE_REPORT_NO_NECG_HINT: 'label.pande.report_no_necg_hint',
  /** リストにない拠点を選択した場合、拠点名を入力してください。 */
  PANDE_ENTER_SITE_HINT: 'label.pande.enter_site_hint',
  /** 報告対象者が保健所から濃厚接触者として指定を受けた場合、「有り」を選択してください。<br/>\n    ※同居家族陽性時に保健所による濃厚接触者調査が遅延する際は、報告対象者を濃厚接触者とみなして「有り」を選択してください。 */
  PANDE_CLOSECONTACT_HINT: 'label.pande.closecontact_hint',
  /** ２日前に会議を行っていた方の中から陽性者が出た、<br/>同居家族が陽性と診断された、など<br/>保健所から指定される起因として提示された事象を入力してください。 */
  PANDE_CLOSECONTACT_REASON_HINT: 'label.pande.closecontact_reason_hint',
  /** すでに報告登録済みのNECg社員または派遣・請負の方の<br/>濃厚接触者に指定された場合は、管理番号を入力してください。 */
  PANDE_RELATION_REPORT_NO_HINT: 'label.pande.relation_report_no_hint',
  /** くしゃみや咳などの軽い症状を含め、症状が出た初日を入力してください。<br/>また、保健所から発症日が指定された場合は、指定された日に変更してください。 */
  PANDE_HASSHO_DT_HINT: 'label.pande.hassho_dt_hint',
  /** 風邪の諸症状が出てからの症状歴や、医療機関受診時に<br/>指示された今後の予定などを入力してください。<br/>\n    <span style="font-weight:bold">入力例</span><br/>\n    9/2　　　症状は無し　通常通り出社<br/>\n    9/3早朝　頭痛があり薬を飲む　休暇<br/>\n    9/3夕方　受診　37.5度発熱、倦怠感あり<br/>\n    　　　　&nbsp;&nbsp;抗原検査実施（結果陰性）<br/>\n    9/4　　　PCR検査実施<br/>\n    9/6　　　検査結果判明予定　倦怠感は継続<br/> */
  PANDE_SHOJO_HISTORY_HINT: 'label.pande.shojo_history_hint',
  /** 初期値はOFF（重症ではない）となっています。<br/> 重症（ICUに入室もしくは人工呼吸器が必要な状態）の場合はスイッチをONにしてください。 */
  PANDE_SHOJO_SERIOUS_HINT: 'label.pande.shojo_serious_hint',
  /** 発症２日前以降の行動履歴を入力してください。 */
  PANDE_WORKSTATUS_ENTRYPLACE_HELP: 'label.pande.workstatus_entryplace_help',
  /** 濃厚接触可能性者が保健所から濃厚接触者として指定を受けた場合、「有り」を選択してください。 */
  PANDE_DIALOG_CLOSECONTACT_HINT: 'label.pande.dialog_closecontact_hint',
  /** 濃厚接触者として指定された方、検査を受け陽性だった方は別途感染症報告の登録を行ってください。<br/>報告の登録が完了後、スイッチをON（右）にしてください。 */
  PANDE_REPORT_REGISTRATION_HINT: 'label.pande.report_registration_hint',
  /** <span style="font-weight:bold">入力例</span><br/>10時間の場合、10:00（HH:mm） */
  PANDE_CONTACT_TIME_HINT: 'label.pande.contact_time_hint',
  /** 報告対象者の検査結果は必ず顧客へ報告してください。<br/>報告が完了しましたら、スイッチをON（右）にしてください。 */
  PANDE_KENSA_RST_REPORT_CD_HINT: 'label.pande.kensa_rst_report_cd_hint',
  /** ・感染症情報は機微な情報となるため閲覧の範囲に制限をかけております。<br/>　報告内容が記載された自動応答メールを受信しても問題のない方や、<br/>　今後の続報登録を行えて問題のない方をこちらから設定してください。<br/>　一覧の報告者・同報先名欄に名前がある方は続報登録を行えます。<br/><br/>・同報先保存ボタンで一覧に表示されている報告者・同報先情報に<br/>　任意の名称をつけて保存できます。<br/><br/>・同報先引用ボタンは保存した報告者・同報先情報の選択、削除ができます。<br/>　選択した場合、一覧に報告者・同報先情報を追加します。<br/>　情報が重複している場合は、先に設定されている情報が優先されます。<br/>　（メール送信、宛先）<br/><br/>・同報先引用、同報先保存は初回報告時のみ利用可能です。 */
  PANDE_REPORTER_BCC_HELP: 'label.pande.reporter_bcc_help',
  /** 今後の続報登録を行う可能性があるが、自動応答メールの受信が不要な場合はスイッチをOFF（左）にしてください。 */
  PANDE_MAIL_SEND_HINT: 'label.pande.mail_send_hint',
  /** MLアドレス追加で以下のいずれかのメールアドレスを入力できます。<br/>・NECグループの国内ドメインのメールアドレス<br/>・社有携帯のキャリアメールアドレス<br/>　※規定されているキャリアメールのアドレスルールに<br/>　　即しているもの */
  PANDE_MAIL_ADDRESS_HINT: 'label.pande.mail_address_hint',
  /** 自動応答メールの宛先の種別を選択してください。<br/>TOは必ず一人以上設定してください。 */
  PANDE_MAIL_SEND_SECTION_HINT: 'label.pande.mail_send_section_hint',
  /** 報告対象者の座席から半径１ｍ以内の座席表を添付してください。<br/>報告対象者の座席がわかるようにしてください。 */
  PANDE_SHEAT_MAP_1M_HINT: 'label.pande.sheat_map_1m_hint',
  /** 消毒業者に提出する際に個人情報が表示されていない座席表を提示するため、個人情報を削除した座席表を添付してください。<br/>報告対象者の座席がわかるようにしてください。 */
  PANDE_SHEAT_MAP_MASK_HINT: 'label.pande.sheat_map_mask_hint',
  /** 感染症情報は機微な情報となるため閲覧に制限をかけております。<br/>感染症検索・集計機能の利用権限を特別に付与されている方のみ利用可能です。 */
  PANDE_PANDE_TOTALIZE_HELP: 'label.pande.pande_totalize_help',
  /** （登録後に採番されます） */
  PANDE_REPORT_NEW_REPORT_NO: 'label.pande.report_new_report_no',
  /** 感染症報告登録結果 */
  PANDE_REPORT_REGISTER_RESULT: 'label.pande.report_register_result',
  /** 管理番号{0}を登録しました。 */
  PANDE_REPORT_REGISTERED_MESSAGE: 'label.pande.report_registered_message',
  /** 管理番号{0}を更新しました。 */
  PANDE_REPORT_UPDATED_MESSAGE: 'label.pande.report_updated_message',
  /** 管理番号{0}を削除しました。 */
  PANDE_REPORT_DELETED_MESSAGE: 'label.pande.report_deleted_message',
  /** 数字で入力してください。 */
  PANDE_NUMERICALITY_MESSAGE: 'label.pande.numericality_message',
  /** 半角数字で入力してください。 */
  PANDE_NUMERICALITY_SINGLE_BYTE_MESSAGE: 'label.pande.numericality_single_byte_message',
  /** 情報取得中... */
  PANDE_LOADING_REPORT_MESSAGE: 'label.pande.loading_report_message',
  /** 報告情報が削除されたため表示できませんでした。 */
  PANDE_PANDE_DATA_NOT_FOUND_MESSAGE: 'label.pande.pande.data_not_found_message',
  /** 最終報告者姓名 */
  PANDE_LAST_INFORMATION_REGISTRANT: 'label.pande.last_information_registrant',
  /** 検査実施決定：検査を受けることが決まった、または受けた<br/>\n    濃厚接触者指定：保健所から濃厚接触者に指定された<br/>\n    検査結果判明：検査結果の通知を受けた<br/>\n    療養内容報告：検査結果陽性で、治療方針が決定した<br/>\n    療養終了：医師の判断で療養終了し、出社可能となった（陽性者）<br/>\n    健康観察終了：健康観察終了し、出社可能となった（濃厚接触者）<br/>\n    死亡：新型コロナウイルスを原因として亡くなった */
  PANDE_REPORT_STATUS_HINT: 'label.pande.report_status_hint',
  /** 報告者・同報先 */
  PANDE_BROADCAST: 'label.pande.broadcast',
  /** 報告者・同報先名 */
  PANDE_BROADCAST_NM: 'label.pande.broadcast_nm',
  /** 同報先情報保存の登録に失敗しました。 */
  PANDE_BROADCAST_SAVE_REGISTER_FAIL_MESSAGE: 'label.pande.broadcast_save_register_fail_message',
  /** 引用 */
  PANDE_BROADCAST_QUOTE_BTN: 'label.pande.broadcast_quote_btn',
  /** 保存しました。 */
  PANDE_BROADCAST_SAVE_REGISTER_RESULT: 'label.pande.broadcast_save_register_result',
  /** 削除します。よろしいですか？ */
  PANDE_BROADCAST_SAVE_DELETE_CONFIRM: 'label.pande.broadcast_save_delete_confirm',
  /** 削除しました。 */
  PANDE_BROADCAST_SAVE_DELETE_RESULT: 'label.pande.broadcast_save_delete_result',
  /** MLアドレス追加 */
  PANDE_ML_ADDRESS_ADD: 'label.pande.ml_address_add',
  /** 重複しています。 */
  PANDE_DUPLICATE_MAIL_ADDRESS_MESSAGE: 'label.pande.duplicate_mail_address_message',
  /** 許可されているアドレスを入力してください。 */
  PANDE_INVALID_MAIL_ADDRESS_MESSAGE: 'label.pande.invalid_mail_address_message',
  /** アドレスに空白が含まれています。 */
  PANDE_INCLUDE_BLANK_MAIL_ADDRESS_MESSAGE: 'label.pande.include_blank_mail_address_message',
  /** 同報先 */
  PANDE_BROADCAST_ADD: 'label.pande.broadcast_add',
  /** （症状がある場合は、発症２日前以降の症状歴、立ち寄り場所等を記入） */
  PANDE_SHOJO_HISTORY_SUPPLEMENT: 'label.pande.shojo_history_supplement',
  /** メールテンプレート設定 */
  PANDE_MAIL_TEMPLATE: 'label.pande.mail_template',
  /** メールテンプレート更新 */
  PANDE_MAIL_TEMPLATE_UPDATE: 'label.pande.mail_template_update',
  /** メールテンプレート更新結果 */
  PANDE_MAIL_TEMPLATE_UPDATE_RESULT: 'label.pande.mail_template_update_result',
  /** メール本文 */
  PANDE_MAIL_TEXT: 'label.pande.mail_text',
  /** メールテンプレートの更新を行う場合は、テンプレート一覧の <svg class="MuiSvgIcon-root-701" focusable="false" viewBox="0 0 24 24" width="24" height = "24" aria-hidden="true" role="presentation"><path d="M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"></path></svg> を押してください。<br/>\n    一覧にて「－(ハイフン)」の項目はテンプレート判定条件に含まれません。 */
  PANDE_MAIL_TEMPLATE_HELP: 'label.pande.mail_template_help',
  /** テンプレート番号 */
  PANDE_TEMPLATE_NO: 'label.pande.template_no',
  /** 発症2日目以降の出社有無 */
  PANDE_SHUSSHA_CD: 'label.pande.shussha_cd',
  /** 濃厚接触可能性者有無 */
  PANDE_CLOSECONTACT_UMU_CD: 'label.pande.closecontact_umu_cd',
  /** 最終更新日時 */
  PANDE_DISP_UPD_DT: 'label.pande.disp_upd_dt',
  /** 検査結果が「陽性」以外、かつ感染症情報の続報登録・更新時にテンプレート判定条件となる項目の設定値が変更されていない場合 */
  PANDE_MAIL_TEMPLATE_TEMPLATE_NO_98_HELP: 'label.pande.mail_template_template_no_98_help',
  /** 検査結果が「陽性」、かつ感染症情報の続報登録・更新時にテンプレート判定条件となる項目の設定値が変更されていない場合 */
  PANDE_MAIL_TEMPLATE_TEMPLATE_NO_99_HELP: 'label.pande.mail_template_template_no_99_help',
  /** <span style="font-weight:bold">確認中／無し</span><br/>\n    　保健所からの濃厚接触者指定有無が「無し」<br/>\n    　または「確認中」の場合<br/>\n    <span style="font-weight:bold">有り</span><br/>\n    　保健所からの濃厚接触者指定有無が「有り」の場合 */
  PANDE_MAIL_TEMPLATE_CLOSECONTACT_HELP: 'label.pande.mail_template_closecontact_help',
  /** <span style="font-weight:bold">無しのみ</span><br/>\n    　対象項目全てが「無し」の場合<br/>\n    <span style="font-weight:bold">確認中／有りが一つ以上</span><br/>\n    　対象項目のいずれか一つでも「確認中」<br/>\n    　または「有り」の場合<br/>\n    【濃厚接触可能性有無　対象項目】<br/>\n    　・濃厚接触可能性者（NECg社員）有無<br/>\n    　・濃厚接触可能性者（派遣・請負）有無<br/>\n    　・濃厚接触可能性者（顧客）有無 */
  PANDE_MAIL_TEMPLATE_CLOSECONTACT_UMU_HELP: 'label.pande.mail_template_closecontact_umu_help',
  /** 一覧へ戻る */
  PANDE_RETURN_TO_MAIL_TEMPLATE: 'label.pande.return_to_mail_template',
  /** メールテンプレート情報 */
  PANDE_MAIL_TEMPLATE_SEND_CONDITION: 'label.pande.mail_template_send_condition',
  /** 本機能では以下に記載した内容を除く、メール本文中でテンプレートごとに異なる箇所の編集を可能とします。<br/>\n    　・宛先（TO）、メール冒頭の定型文<br/>\n    　・URLなどの定型文<br/>\n    　・メール末尾の画面入力された設定値<br/> */
  PANDE_MAIL_TEMPLATE_MAIL_TEXT: 'label.pande.mail_template_mail_text',
  /** 実際に送信されるメール全体イメージです。 */
  PANDE_MAIL_TEMPLATE_RESULT_MAIL_IMAGE: 'label.pande.mail_template_result_mail_image',
  /** 更新可能箇所は背景色青色、それ以外の箇所は固定文言（変更不可）です。 */
  PANDE_MAIL_TEMPLATE_RESULT_VALIABLE: 'label.pande.mail_template_result_valiable',
  /** 同報先引用 */
  PANDE_BROADCAST_QUOTE: 'label.pande.broadcast_quote',
  /** 報告者・同報先引用 */
  PANDE_BROADCAST_QUOTE_TITLE: 'label.pande.broadcast_quote_title',
  /** 同報先保存 */
  PANDE_BROADCAST_SAVE: 'label.pande.broadcast_save',
  /** 報告者・同報先保存 */
  PANDE_BROADCAST_SAVE_TITLE: 'label.pande.broadcast_save_title',
  /** 報告者・同報先保存名 */
  PANDE_BROADCAST_SAVE_NM: 'label.pande.broadcast_save_nm',
  /** 保存します。よろしいですか？ */
  PANDE_BROADCAST_NM_SAVED_CONFIRM_MASSAGE: 'label.pande.broadcast_nm_saved_confirm_massage',
  /** 「{0}」を上書き保存します。よろしいですか？ */
  PANDE_BROADCAST_NM_UPDATE_CONFIRM_MESSAGE: 'label.pande.broadcast_nm_update_confirm_message',
  /** 報告者・同報先が保存されていません。 */
  PANDE_BROADCAST_NO_DATA_MESSAGE: 'label.pande.broadcast_no_data_message',
  /** {0}の情報が存在しないため引用できませんでした。 */
  PANDE_NO_SHAIN_MESSAGE: 'label.pande.no_shain_message',
  /** 個人情報取扱い方針兼同意書 */
  PANDE_PRIVACY_POLICY: 'label.pande.privacy_policy',
  /** 報告者・同報先情報が設定されていません。 */
  PANDE_NO_SAVE_LIST_MESSAGE: 'label.pande.no_save_list_message',
  /** 感染症利用権限設定 */
  PANDE_AUTHORIZE_SETTING: 'label.pande.authorize_setting',
  /** 設定を更新する場合は検索結果一覧の\n    <svg class="MuiSvgIcon-root-701" focusable="false" viewBox="0 0 24 24" width="24" height = "24" aria-hidden="true" role="presentation">\n    <path d="M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z" />\n    </svg> を押してください。 */
  PANDE_AUTHORIZE_SETTING_HELP: 'label.pande.authorize_setting_help',
  /** 感染症利用権限 */
  PANDE_AUTHORIZE: 'label.pande.authorize',
  /** 指定した感染症利用権限が設定されている方を検索します。 */
  PANDE_AUTHORIZE_HINT: 'label.pande.authorize_hint',
  /** 更新・詳細参照要否 */
  PANDE_UPDATE_YOHI: 'label.pande.update_yohi',
  /** 利用権限未設定 */
  PANDE_NO_AUTHORIZE: 'label.pande.no_authorize',
  /** 一括で設定を解除できます。<br/>\n    複数の会社の権限が設定されている方については更新画面で個別に削除してください。 */
  PANDE_AUTHORIZE_CLEAR_HINT: 'label.pande.authorize_clear_hint',
  /** 感染症利用権限をクリアし、未設定の状態にします。よろしいですか？ */
  PANDE_AUTHORIZE_CLEAR_CONFIRM_MESSAGE: 'label.pande.authorize_clear_confirm_message',
  /** 感染症利用権限更新 */
  PANDE_AUTHORIZE_UPDATE: 'label.pande.authorize_update',
  /** 感染症利用権限更新結果 */
  PANDE_AUTHORIZE_UPDATE_RESULT: 'label.pande.authorize_update_result',
  /** メール受信要否 */
  PANDE_AUTHORIZE_MAIL_YOHI: 'label.pande.authorize_mail_yohi',
  /** 感染症情報の検索・集計、および報告時の同報メール受信の権限を付与します。<br/>\n    付与する権限、権限に応じた会社・組織・拠点・都道府県、メール受信要否などの指定を行ってください。 */
  PANDE_AUTHORIZE_UPDATE_HELP: 'label.pande.authorize_update_help',
  /** 機微情報を含む個人情報が表示される画面を参照・更新可能とするかどうかを指定してください。<br/>\n    （個人情報を取り扱うことになりますので、設定は慎重にお願いいたします） */
  PANDE_AUTHORIZE_UPDATE_YOHI_HINT: 'label.pande.authorize_update_yohi_hint',
  /** <span style="font-weight:bold">全社</span><br/>\n    全社の全ての報告内容を検索可能となります。<br/>\n    <span style="font-weight:bold">会社指定</span><br/>\n    複数指定可能です。<br/>\n    <span style="font-weight:bold">会社／組織指定</span><br/>\n    複数指定可能です。<br/>\n    指定した組織配下を含む組織が対象となります。<br/>\n    <span style="font-weight:bold">拠点指定</span><br/>\n    複数指定可能です。<br/>\n    <span style="font-weight:bold">都道府県指定</span><br/>\n    複数指定可能です。 */
  PANDE_AUTHORIZE_SELECT_HINT: 'label.pande.authorize_select_hint',
  /** 権限区分の条件に一致する感染症報告の登録時にメールを同報する場合、スイッチをON（右）にしてください */
  PANDE_MAIL_YOHI_HINT: 'label.pande.mail_yohi_hint',
  /** 権限によっては、ご自身が所属する会社（及び所属する組織、所属する拠点）のみ設定・変更・削除可能です。 */
  PANDE_AUTHORIZE_CHANGEABLE_HINT: 'label.pande.authorize_changeable_hint',
  /** 全て削除 */
  PANDE_ALL_DELETE: 'label.pande.all_delete',
  /** 重複しています。 */
  PANDE_DUPLICATE_AUTHORIZE_MESSAGE: 'label.pande.duplicate_authorize_message',
  /** 立ち入り場所１－ビル名 */
  PANDE_ENTRYPLACE_BUILDING_NM_1: 'label.pande.entryplace_building_nm_1',
  /** 立ち入り場所１－号棟 */
  PANDE_ENTRYPLACE_GOUTOU_1: 'label.pande.entryplace_goutou_1',
  /** 立ち入り場所１－階 */
  PANDE_ENTRYPLACE_FLOOR_1: 'label.pande.entryplace_floor_1',
  /** 立ち入り場所１－フロア */
  PANDE_ENTRYPLACE_WORKSPACE_1: 'label.pande.entryplace_workspace_1',
  /** 立ち入り場所２－ビル名 */
  PANDE_ENTRYPLACE_BUILDING_NM_2: 'label.pande.entryplace_building_nm_2',
  /** 立ち入り場所２－号棟 */
  PANDE_ENTRYPLACE_GOUTOU_2: 'label.pande.entryplace_goutou_2',
  /** 立ち入り場所２－階 */
  PANDE_ENTRYPLACE_FLOOR_2: 'label.pande.entryplace_floor_2',
  /** 立ち入り場所２－フロア */
  PANDE_ENTRYPLACE_WORKSPACE_2: 'label.pande.entryplace_workspace_2',
  /** 年齢 */
  PANDE_AGE: 'label.pande.age',
  /** 性別 */
  PANDE_SEX: 'label.pande.sex',
  /** 明細 */
  PANDE_DETAIL: 'label.pande.detail',
  /** NECグループ被災情報登録 */
  GROUPHISAI_GROUPHISAI_REGISTRATION: 'label.grouphisai.grouphisai_registration',
  /** NECグループ被災情報検索 */
  GROUPHISAI_GROUPHISAI_SEARCH: 'label.grouphisai.grouphisai_search',
  /** NECグループ被災情報振り分け */
  GROUPHISAI_GROUPHISAI_SORT: 'label.grouphisai.grouphisai_sort',
  /** NECグループ被災情報詳細 */
  GROUPHISAI_GROUPHISAI_DETAIL: 'label.grouphisai.grouphisai_detail',
  /** NECグループ被災情報履歴 */
  GROUPHISAI_GROUPHISAI_HISTORY: 'label.grouphisai.grouphisai_history',
  /** NECグループ被災情報更新 */
  GROUPHISAI_GROUPHISAI_UPDATE: 'label.grouphisai.grouphisai_update',
  /** NECグループ被災情報更新結果 */
  GROUPHISAI_GROUPHISAI_UPDATE_RESULT: 'label.grouphisai.grouphisai_update_result',
  /** NECグループ被災情報削除 */
  GROUPHISAI_GROUPHISAI_DELETE: 'label.grouphisai.grouphisai_delete',
  /** NECグループ被災情報削除結果 */
  GROUPHISAI_GROUPHISAI_DELETE_RESULT: 'label.grouphisai.grouphisai_delete_result',
  /** NECグループ被災情報振り分け詳細 */
  GROUPHISAI_GROUPHISAI_SORT_DETAIL: 'label.grouphisai.grouphisai_sort_detail',
  /** NECグループ被災情報振り分け削除 */
  GROUPHISAI_GROUPHISAI_SORT_DELETE: 'label.grouphisai.grouphisai_sort_delete',
  /** NECグループ被災情報振り分け削除結果 */
  GROUPHISAI_GROUPHISAI_SORT_DELETE_RESULT: 'label.grouphisai.grouphisai_sort_delete_result',
  /** NECグループ被災情報振り分け掲載先設定 */
  GROUPHISAI_GROUPHISAI_SORT_SET_SOURCE: 'label.grouphisai.grouphisai_sort_set_source',
  /** NECグループ被災情報振り分け掲載先設定結果 */
  GROUPHISAI_GROUPHISAI_SORT_SET_SOURCE_RESULT: 'label.grouphisai.grouphisai_sort_set_source_result',
  /** 件名 */
  GROUPHISAI_SUBJECT: 'label.grouphisai.subject',
  /** 最終更新者 */
  GROUPHISAI_LAST_UPDATED_NAME: 'label.grouphisai.last_updated_name',
  /** メール取込(システム自動) */
  GROUPHISAI_MAIL_CAPTURE: 'label.grouphisai.mail_capture',
  /** 最終更新日時 */
  GROUPHISAI_LAST_UPDATED_DATE: 'label.grouphisai.last_updated_date',
  /** 添付ファイル */
  GROUPHISAI_ATTACHED_FILE: 'label.grouphisai.attached_file',
  /** 添付ファイルはありません。 */
  GROUPHISAI_NO_ATTACHED_FILE: 'label.grouphisai.no_attached_file',
  /** 検索条件に該当するNECグループ被災情報はありません。 */
  GROUPHISAI_NO_INFO_MESSAGE: 'label.grouphisai.no_info_message',
  /** 登録対象選択 */
  GROUPHISAI_SELECT_TARGET: 'label.grouphisai.select_target',
  /** メール作成 */
  GROUPHISAI_MAKE_MAIL: 'label.grouphisai.make_mail',
  /** 登録対象を選択し、メール作成ボタンを押すとメーラーが起動します。<br/>\n    ※起動するメーラーは端末の設定に依存します。<br/>\n    使用したいメーラーが起動しなかった場合は、以下の手順でメールに対する既定のアプリの設定を行ってください。<br/><br/>\n    ①「スタートメニュー」から「設定アイコン」をクリックし、Windowsの設定画面を開きます。<br/>\n    ②Windowsの設定画面で「アプリ」をクリックし、左ペインで「規定のアプリ」をクリックします。<br/>\n    ③既定のアプリの選択画面で、「メール」のアイコンをクリックし、使用したいメーラー（Outlook推奨）を選択します。<br/>\n    メーラー起動後は宛先と内容を入力し、メールを送信してください。<br/>\n    <br/>\n    <b>システムでメーラーに自動設定する内容</b><br/>\n    ・CC：システムのメールアドレスを設定します。追加の送信先がある場合は追加してください。<br/>\n    　（※システムで自動設定したメールアドレスを削除しないようにしてください）<br/>\n    ・件名：本画面で選択した情報に応じて、件名を設定します。<br/>\n    　件名に追加で記載したい内容がある場合は、システムで自動設定した内容の後ろに記載をしてください。<br/>\n    　（※システムで自動設定した件名を変更しないようにしてください）<br/>\n    ・本文：入力項目のテンプレートを設定します。登録したい内容を記載してください。<br/>\n    　（※テンプレートの構成を変更しても問題ありません）<br/>\n    <br/>\n    <b>入力項目説明</b><br/>\n    ・概況：発生した災害の概要や被害状況などに関する情報<br/>\n    ・従業員被災状況：負傷者／行方不明者／死者に関する情報<br/>\n    ・会社インフラ被災状況：建物／電気・ガス・水道／システム／通信に関する情報<br/>\n    ・開発・生産被災状況：開発・生産ライン／顧客／サプライヤーに関する情報 */
  GROUPHISAI_GROUPHISAI_REGISTRATION_HELP: 'label.grouphisai.grouphisai_registration_help',
  /** この掲載先は設定できません。 */
  GROUPHISAI_POST_CANNOT_SET_MESSAGE: 'label.grouphisai.post_cannot_set_message',
  /** ＜概況＞%0D%0A%0D%0A＜被災状況＞%0D%0A〇従業員%0D%0A　死者：%0D%0A　負傷者：%0D%0A　行方不明者：%0D%0A%0D%0A〇会社インフラ%0D%0A　建屋：%0D%0A　電気：%0D%0A　ガス：%0D%0A　水道：%0D%0A　システム：%0D%0A%0D%0A〇開発・生産%0D%0A　開発・生産ライン：%0D%0A　顧客への影響：%0D%0A　協力会社・サプライヤー：%0D%0A%0D%0A〇その他%0D%0A%0D%0A */
  GROUPHISAI_MAIL_TEMPLATE: 'label.grouphisai.mail_template',
  /** 以下の内容で設定しました。 */
  GROUPHISAI_SET_ACTION_MESSAGE: 'label.grouphisai.set_action_message',
  /** メンテナンス情報 */
  NOTICE_NOTICE_TITLE: 'label.notice.notice_title',
  /** メンテナンス情報登録 */
  NOTICE_NOTIFICATION_REGISTER: 'label.notice.notification_register',
  /** メンテナンス情報登録結果 */
  NOTICE_RESULT: 'label.notice.result',
  /** メンテナンス情報詳細 */
  NOTICE_DETAIL: 'label.notice.detail',
  /** Biz安否確認／一斉通報に関するメンテナンス情報は、Biz安否確認／一斉通報＞メンテナンスを参照してください。 */
  NOTICE_DETAIL_HELP: 'label.notice.detail_help',
  /** メンテナンス情報更新 */
  NOTICE_NOTICE_UPDATE: 'label.notice.notice_update',
  /** メンテナンス情報更新結果 */
  NOTICE_NOTICE_UPDATE_RESULT: 'label.notice.notice_update_result',
  /** 前回のメンテナンス情報引用 */
  NOTICE_LAST_NOTICE_QUOTE: 'label.notice.last_notice_quote',
  /** 前回登録したお知らせを引用しますか？<br/>（今の表示内容は上書きされます。） */
  NOTICE_CITATION_CONFIRM_MESSAGE: 'label.notice.citation.confirm_message',
  /** メンテナンス情報履歴 */
  NOTICE_NOTIFICATION_HISTORY: 'label.notice.notification_history',
  /** 前回登録したお知らせがありません。 */
  NOTICE_NO_NOTIFICATION_REGISTERED: 'label.notice.no_notification_registered',
  /** 利用できる監査対象事業がありません。 */
  KANSA_KANSA_UNAVAILABILITY: 'label.kansa.kansa_unavailability',
  /** 監査回答登録 */
  KANSA_KANSA_ANSWER_REGISTER: 'label.kansa.kansa_answer_register',
  /** 監査回答表示 */
  KANSA_KANSA_ANSWER_SHOW: 'label.kansa.kansa_answer_show',
  /** 監査回答結果 */
  KANSA_KANSA_ANSWER_RESULT: 'label.kansa.kansa_answer_result',
  /** 監査回答 */
  KANSA_KANSA_ANSWER: 'label.kansa.kansa_answer',
  /** BCP策定証跡追加 */
  KANSA_BCP_DEVELOPMENT_TRAIL_ADDED: 'label.kansa.bcp_development_trail_added',
  /** 証跡登録 */
  KANSA_TRAIL_REGISTER: 'label.kansa.trail_register',
  /** 証跡変更 */
  KANSA_TRAIL_UPDATE: 'label.kansa.trail_update',
  /** 監査部門 */
  KANSA_KANSA_BUMON: 'label.kansa.kansa_bumon',
  /** 監査部門選択 */
  KANSA_KANSA_BUMON_SELECT: 'label.kansa.kansa_bumon_select',
  /** 被監査部門 */
  KANSA_HI_KANSA_BUMON: 'label.kansa.hi_kansa_bumon',
  /** 被監査部門選択 */
  KANSA_HI_KANSA_BUMON_SELECT: 'label.kansa.hi_kansa_bumon_select',
  /** 年度 */
  KANSA_NENDO: 'label.kansa.nendo',
  /** 証跡 */
  KANSA_TRAIL: 'label.kansa.trail',
  /** 証跡名 */
  KANSA_TRAIL_NAME: 'label.kansa.trail_name',
  /** 証跡追加 */
  KANSA_TRAIL_ADDED: 'label.kansa.trail_added',
  /** ファイル */
  KANSA_FILE: 'label.kansa.file',
  /** ファイル選択 */
  KANSA_FILE_SELECT: 'label.kansa.file_select',
  /** 未回答 */
  KANSA_UNANSWERED: 'label.kansa.unanswered',
  /** 回答中 */
  KANSA_ANSWERING: 'label.kansa.answering',
  /** 回答済 */
  KANSA_ANSWERED: 'label.kansa.answered',
  /** 登録済 */
  KANSA_INSERTED: 'label.kansa.inserted',
  /** 業務内容 */
  KANSA_GYOMU_CONTENT: 'label.kansa.gyomu_content',
  /** 監査対象年度 */
  KANSA_AUDIT_YEAR: 'label.kansa.audit_year',
  /** 参考値： */
  KANSA_REFERENCE_VALUE: 'label.kansa.reference_value',
  /** 結果： */
  KANSA_RESULT_VALUE: 'label.kansa.result_value',
  /** 監査テーマ */
  KANSA_AUDIT_THEME: 'label.kansa.audit_theme',
  /** 監査対象事業 */
  KANSA_AUDIT_BUSINESS: 'label.kansa.audit_business',
  /** 監査回答状況 */
  KANSA_AUDIT_ANSWER_STATUS: 'label.kansa.audit_answer_status',
  /** 担当の監査対象事業のみ表示 */
  KANSA_AUDIT_ONLY_BUSINESS_SHOW: 'label.kansa.audit_only_business_show',
  /** 監査部門責任者 */
  KANSA_KANSA_SEKININSHA: 'label.kansa.kansa_sekininsha',
  /** 被監査部門責任者 */
  KANSA_HIKANSA_SEKININSHA: 'label.kansa.hikansa_sekininsha',
  /** 指摘事項改善 */
  KANSA_SHITEKI_KAIZEN: 'label.kansa.shiteki_kaizen',
  /** 指摘事項 */
  KANSA_SHITEKI_JIKO: 'label.kansa.shiteki_jiko',
  /** 作成状況 */
  KANSA_MAKING_STATUS: 'label.kansa.making_status',
  /** 計画状況 */
  KANSA_IMPROVEMENT_PLAN_STATUS: 'label.kansa.improvement_plan_status',
  /** 進捗状況 */
  KANSA_PROGRESS_STATUS: 'label.kansa.progress_status',
  /** 評価状況 */
  KANSA_EVALUATION_STATUS: 'label.kansa.evaluation_status',
  /** 被監査部門責任者評価 */
  KANSA_CHIEF_HYOKA: 'label.kansa.chief_hyoka',
  /** 指摘事項改善計画・実績登録 */
  KANSA_SHITEKI_KAIZENPLAN_ZISSEKI_REGISTER: 'label.kansa.shiteki_kaizenplan_zisseki_register',
  /** 指摘事項改善計画・実績登録結果 */
  KANSA_SHITEKI_KAIZENPLAN_ZISSEKI_RESULT: 'label.kansa.shiteki_kaizenplan_zisseki_result',
  /** 指摘事項改善計画・実績表示 */
  KANSA_SHITEKI_KAIZENPLAN_ZISSEKI_DISPLAY: 'label.kansa.shiteki_kaizenplan_zisseki_display',
  /** 該当する指摘事項改善計画・実績がありません。 */
  KANSA_NO_SHITEKI_KAIZENPLAN_ZISSEKI: 'label.kansa.no_shiteki_kaizenplan_zisseki',
  /** 指摘事項区分 */
  KANSA_SHITEKI_JIKO_KBN: 'label.kansa.shiteki_jiko_kbn',
  /** ISO22301章タイトル */
  KANSA_SHITEKI_SHO_TITLE: 'label.kansa.shiteki_sho_title',
  /** ISO22301要求事項 */
  KANSA_SHITEKI_YOKYU_JIKO: 'label.kansa.shiteki_yokyu_jiko',
  /** 発見事項分類 */
  KANSA_SHITEKI_HAKKEN_JIKO_BUNRUI: 'label.kansa.shiteki_hakken_jiko_bunrui',
  /** 発見事項 */
  KANSA_SHITEKI_HAKKEN_JIKO: 'label.kansa.shiteki_hakken_jiko',
  /** 確認事項 */
  KANSA_SHITEKI_KAKUNIN_JIKO: 'label.kansa.shiteki_kakunin_jiko',
  /** 確認結果 */
  KANSA_SHITEKI_KAKUNIN_KEKKA: 'label.kansa.shiteki_kakunin_kekka',
  /** 確認補足 */
  KANSA_SHITEKI_KAKUNIN_HOSOKU: 'label.kansa.shiteki_kakunin_hosoku',
  /** 対策 */
  KANSA_SHITEKI_TAISAKU: 'label.kansa.shiteki_taisaku',
  /** 担当者 */
  KANSA_SHITEKI_TANTOSHA: 'label.kansa.shiteki_tantosha',
  /** 計画策定時 */
  KANSA_SHITEKI_PLAN_SAKUTEIJI: 'label.kansa.shiteki_plan_sakuteiji',
  /** 完了予定日 */
  KANSA_SHITEKI_COMP_YOTEI_DATE: 'label.kansa.shiteki_comp_yotei_date',
  /** 承認日 */
  KANSA_SHITEKI_SHONIN_DATE: 'label.kansa.shiteki_shonin_date',
  /** 承認者 */
  KANSA_SHITEKI_SHONINSHA: 'label.kansa.shiteki_shoninsha',
  /** 対応完了時 */
  KANSA_SHITEKI_TAIO_COMP: 'label.kansa.shiteki_taio_comp',
  /** 完了日 */
  KANSA_SHITEKI_COMP_DATE: 'label.kansa.shiteki_comp_date',
  /** 【確証例】 */
  KANSA_SHITEKI_KAKUSHO_EXM: 'label.kansa.shiteki_kakusho_exm',
  /** {0}の{1}に未来日は入力できません。 */
  KANSA_NO_FUTURE: 'label.kansa.no_future',
  /** 前年度の監査回答を表示 */
  KANSA_LASTYEAR_KANSA_ANSWER_SHOW: 'label.kansa.lastyear_kansa_answer_show',
  /** BCP策定の証跡を追加 */
  KANSA_BCP_DEVELOPMENT_OF_TRAIL_ADDED: 'label.kansa.bcp_development_of_trail_added',
  /** BCP対象事業 */
  KANSA_BCP_TARGET_BUSINESS: 'label.kansa.bcp_target_business',
  /** ドキュメント名 */
  KANSA_DOCUMENT_NM: 'label.kansa.document_nm',
  /** 追加対象選択 */
  KANSA_BCP_TERGET_SELECT: 'label.kansa.bcp_terget_select',
  /** 回答一時保存 */
  KANSA_ANSWERED_TEMPORARILY_STORE: 'label.kansa.answered_temporarily_store',
  /** 被監査部門回答登録 */
  KANSA_HI_KANSA_BUMON_STORE: 'label.kansa.hi_kansa_bumon_store',
  /** 回答登録 */
  KANSA_ANSWER_STORE: 'label.kansa.answer_store',
  /** 確認事項 */
  KANSA_KAKUNIN_JIKO: 'label.kansa.kakunin_jiko',
  /** 確認結果 */
  KANSA_KAKUNIN_KEKKA: 'label.kansa.kakunin_kekka',
  /** 確認補足 */
  KANSA_KAKUNIN_HOSOKU: 'label.kansa.kakunin_hosoku',
  /** 発見事項分類 */
  KANSA_HAKKEN_JIKO_BUNRUI: 'label.kansa.hakken_jiko_bunrui',
  /** 発見事項 */
  KANSA_HAKKEN_JIKO: 'label.kansa.hakken_jiko',
  /** 成熟度評価 */
  KANSA_SEJUKUDO_HYOKA: 'label.kansa.sejukudo_hyoka',
  /** 該当する調査項目グループの確認結果 */
  KANSA_KAKUNIN_KEKKA_MISSING: 'label.kansa.kakunin_kekka_missing',
  /** 証跡の登録に失敗しました。 */
  KANSA_TRAIL_REGISTER_MISSING: 'label.kansa.trail_register_missing',
  /** 証跡の更新に失敗しました。 */
  KANSA_TRAIL_UPDATE_MISSING: 'label.kansa.trail_update_missing',
  /** 対象の証跡管理情報は削除されている可能性があります。 */
  KANSA_TRAIL_DOWNLOAD_DATA_MISSING: 'label.kansa.trail_download_data_missing',
  /** 対象の証跡ファイルは削除されている可能性があります。 */
  KANSA_TRAIL_DOWNLOAD_FILE_MISSING: 'label.kansa.trail_download_file_missing',
  /** 既に他のユーザが作成完了としているため、登録を行えません。\n・他のユーザの更新内容を確認する場合は一覧から再選択してください。 */
  KANSA_REGISTER_STATUS_MISSING: 'label.kansa.register_status_missing',
  /** ・監査部門は全ての項目を入力可能です。<br/>・被監査部門は確認結果、確認補足、証跡のみ入力可能です。<br/>・被監査部門で監査回答を登録すると、監査回答状況が「回答中」になります。<br/>　監査部門で監査回答の成熟度評価を登録すると、監査回答状況が「回答済」になります。 */
  KANSA_KANSA_ANSWER_REGISTER_HELP: 'label.kansa.kansa_answer_register_help',
  /** 確認事項に対する確認結果を選択します。補足があれば確認補足に入力します。 */
  KANSA_ANSWER_KEKKA_HINT: 'label.kansa.answer_kekka_hint',
  /** 発見事項分類で「特記事項無し」以外を選択した場合は、発見事項を入力してください。 */
  KANSA_ANSWER_HAKKENJIKO_HINT: 'label.kansa.answer_hakkenjiko_hint',
  /** <span style="font-weight:bold">成熟度レベル：</span><br/>\n        １：大規模災害時に継続する事業がない。<br/>\n        ２：場当たり的、俗人的な対処がされている状態。<br/>\n        ３：職場に暗黙的ルールしかない状態。<br/>\n        ４：ルールが制定、明文化されており関係者間で周知がされている。<br/>\n        ５：行動手順、復旧手順が作成され、継続的改善が行われている。<br/>\n        ６：組織の文化として定着化し、関係者外の組織内の担当にも周知がされている。 */
  KANSA_ANSWER_SEIJUKUDO_HINT: 'label.kansa.answer_seijukudo_hint',
  /** 進捗一覧へ戻る */
  KANSA_RETURN_TO_PROGRESS: 'label.kansa.return_to_progress',
  /** 監査回答を一時保存しました。 */
  KANSA_ANSWER_TEMP_SAVE: 'label.kansa.answer_temp_save',
  /** 被監査部門責任者評価 */
  KANSA_PROGRESS_AUDITED_EVALUATION_STATUS: 'label.kansa.progress_audited_evaluation_status',
  /** 記入日 */
  KANSA_KINYU_DATE: 'label.kansa.kinyu_date',
  /** 記入者 */
  KANSA_KINYUSHA_NM: 'label.kansa.kinyusha_nm',
  /** コメント */
  KANSA_COMMENT: 'label.kansa.comment',
  /** 監査結果表示 */
  KANSA_RESULT_DETAIL: 'label.kansa.result_detail',
  /** 改善計画表示 */
  KANSA_KAIZEN_PREVIEW: 'label.kansa.kaizen_preview',
  /** 一時保存 */
  KANSA_TEMPORARILY_STORE: 'label.kansa.temporarily_store',
  /** 被監査部門責任者評価 */
  KANSA_HIKANSA_HYOKA: 'label.kansa.hikansa_hyoka',
  /** 被監査部門責任者評価登録 */
  KANSA_HIKANSA_HYOKA_REGISTER: 'label.kansa.hikansa_hyoka_register',
  /** 被監査部門責任者評価登録結果 */
  KANSA_HIKANSA_HYOKA_REGISTER_RESULT: 'label.kansa.hikansa_hyoka_register_result',
  /** 被監査部門責任者評価表示 */
  KANSA_HIKANSA_HYOKA_DETAIL: 'label.kansa.hikansa_hyoka_detail',
  /** 一時保存します。よろしいですか？ */
  KANSA_TEMPORARILY_SAVE_CONFIRM_MESSAGE: 'label.kansa.temporarily_save_confirm_message',
  /** 他のユーザが評価完了としているため、一時保存を行えません。\n    ・変更した内容で保存する場合は登録ボタンを押下してください。\n    ・他のユーザの更新内容を確認する場合は一覧から再選択してください。 */
  KANSA_KANSA_TEMPORARILY_SAVE_ERROR_MESSAGE: 'label.kansa.kansa_temporarily_save_error_message',
  /** 証跡を削除します。よろしいですか？ */
  KANSA_DELETE_CONFIRM_TRAIL_MESSAGE: 'label.kansa.delete_confirm_trail_message',
  /** 非公開設定 */
  KANSA_HIKOKAI_SETTING: 'label.kansa.hikokai_setting',
  /** 非公開情報とする */
  KANSA_KEEP_HIKOKAI: 'label.kansa.keep_hikokai',
  /** 非公開情報としない */
  KANSA_NOT_KEEP_HIKOKAI: 'label.kansa.not_keep_hikokai',
  /** 監査対象事業登録 */
  KANSA_TARGET_REGISTER_TITLE: 'label.kansa.target_register_title',
  /** 監査対象事業登録結果 */
  KANSA_TARGET_REGISTER_RESULT: 'label.kansa.target_register_result',
  /** 被監査部門は複数選択可能です。 */
  KANSA_SELECT_TANTOSOSHIKI_HINT: 'label.kansa.select_tantososhiki_hint',
  /** 選定した理由、対象外とした理由、対象業務などを記入できます。 */
  KANSA_TANTOSOSHIKI_NOTE_HINT: 'label.kansa.tantososhiki_note_hint',
  /** 同じ被監査部門が含まれている同名の監査対象事業が既に存在するため、登録できません。 */
  KANSA_TGT_JIGYO_NM_ALREADY_EXISTS: 'label.kansa.tgt_jigyo_nm_already_exists',
  /** 監査対象事業は既に監査回答登録されているため、更新できません。 */
  KANSA_ANS_ALREADY_CREATE: 'label.kansa.ans_already_create',
  /** 該当する監査対象事業がありません。既に削除された可能性があります。 */
  KANSA_NO_KANSA_TGT_JIGYO: 'label.kansa.no_kansa_tgt_jigyo',
  /** 監査対象年度 */
  KANSA_TGT_NENDO: 'label.kansa.tgt_nendo',
  /** 監査テーマ */
  KANSA_THEME_NM: 'label.kansa.theme_nm',
  /** 監査対象事業 */
  KANSA_TGT_JIGYO_NM: 'label.kansa.tgt_jigyo_nm',
  /** 監査部門 */
  KANSA_BUMON: 'label.kansa.bumon',
  /** 被監査部門 */
  KANSA_HIKANSA_BUMON: 'label.kansa.hikansa_bumon',
  /** 被監査部門追加 */
  KANSA_HIKANSABUMON_PUSH: 'label.kansa.hikansabumon_push',
  /** 検索条件を入力し、検索ボタンを押してください。 */
  KANSA_PROGRESS_HELP: 'label.kansa.progress_help',
  /** 業務内容 */
  KANSA_PROGRESS_DUTIES: 'label.kansa.progress_duties',
  /** 監査部門 */
  KANSA_PROGRESS_AUDITOR: 'label.kansa.progress_auditor',
  /** 被監査部門 */
  KANSA_PROGRESS_AUDITEE: 'label.kansa.progress_auditee',
  /** 監査対象年度 */
  KANSA_PROGRESS_AUDIT_TARGET_YEAR: 'label.kansa.progress_audit_target_year',
  /** 監査テーマ */
  KANSA_PROGRESS_AUDIT_THEMA: 'label.kansa.progress_audit_thema',
  /** 証跡が登録されていません。 */
  KANSA_INSERT_CONFIRM_TRAIL_MESSAGE: 'label.kansa.insert_confirm_trail_message',
  /** 該当する証跡がありません。 */
  KANSA_NOTFOUND_CONFIRM_TRAIL_MESSAGE: 'label.kansa.notfound_confirm_trail_message',
  /** <div style='margin: 0 0 8px 0'>監査の進捗状況を表示します。</div>\n    <br/>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>未対応は</div><div style='margin-left: 2px; text-align: center; height: auto; width:60px; background-color: #fadbda; '><span style='color: black; font-weight: bold'>　</span></div><div style='font-weight: bold;'>、対応中は</div><div style='margin-left: 2px; text-align: center; height: auto; width:60px; background-color: #ffffb3; '><span style='color: black; font-weight: bold'>　</span></div><div style='font-weight: bold;'>で表示されます。</div></div>\n    <br/>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>監査状況</div></div>\n    <div style='margin: 0 0 8px 8px'>・全ての監査業務が完了している場合または指摘事項改善計画の指摘事項がなくその他の監査業務が完了している場合、「完了」と表示されます。</div>\n    <div style='margin: 0 0 8px 8px'>・全ての監査業務が完了していない場合「未完了」と表示されます。</div>\n    <br/>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>進捗状況のリンク</div></div>\n    <div style='margin: 0 0 8px 8px'>登録/作成/表示が可能な進捗状況の場合は各登録/作成/表示画面を表示するリンクが表示されます。</div> */
  KANSA_KANSA_PROGRESS_HELP: 'label.kansa.kansa_progress_help',
  /** 監査進捗状況 */
  KANSA_PROGRESS: 'label.kansa.progress',
  /** 監査状況 */
  KANSA_KANSA_STS: 'label.kansa.kansa_sts',
  /** 監査結果作成状況 */
  KANSA_AUDIT_RESULTS_CREATION_STS: 'label.kansa.audit_results_creation_sts',
  /** 指摘事項改善計画状況 */
  KANSA_IMPROVEMENT_POINTED_OUT_PLAN_STS: 'label.kansa.improvement_pointed_out_plan_sts',
  /** 指摘事項改善進捗状況 */
  KANSA_IMPROVEMENT_POINTED_OUT_PLAN_PROGRESS: 'label.kansa.improvement_pointed_out_plan_progress',
  /** 被監査部門責任者評価評価状況 */
  KANSA_AUDITED_EVALUATION_STS: 'label.kansa.audited_evaluation_sts',
  /** 全て表示する */
  KANSA_PROGRESS_SHOW_ALL: 'label.kansa.progress_show_all',
  /** <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>監査部門</div></div>\n    <div style='margin: 0 0 8px 8px'>・監査結果を登録する。</div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績の作成状況、及び被監査部門責任者評価の登録状況を確認し、未完了の場合はフォローする。</div>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>被監査部門</div></div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績の作成および実績登録を行う。</div>\n    <div style='margin: 0 0 8px 8px'>・監査結果を確認し、被監査部門責任者評価を登録する。</div>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>監査結果 作成状況</div></div>\n    <div style='margin: 0 0 8px 8px'>・監査結果登録画面で、一時保存を行った場合は作成中となります。</div>\n    <div style='margin: 0 0 8px 8px'>・監査結果登録画面で、登録を行った場合は作成完了となります。</div>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>指摘事項改善 計画状況</div></div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績登録画面で、一部の指摘の計画策定時項目が入力された場合は作成中となります。</div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績登録画面で、全ての指摘の計画策定時項目が入力された場合は作成完了となります。</div>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>指摘事項改善 進捗状況</div></div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績登録画面で、一部の指摘の対応完了時項目が入力された場合は対応中となります。</div>\n    <div style='margin: 0 0 8px 8px'>・指摘事項改善計画・実績登録画面で、全ての指摘の対応完了時項目が入力された場合は対応完了となります。</div>\n    <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>被監査部門責任者評価 評価状況</div></div>\n    <div style='margin: 0 0 8px 8px'>・被監査部門責任者評価登録画面で、一時保存を行った場合は評価中となります。</div>\n    <div style='margin: 0 0 8px 8px'>・被監査部門責任者評価登録画面で、登録を行った場合は評価完了となります。</div> */
  KANSA_KANSA_RESULT_HELP: 'label.kansa.kansa_result_help',
  /** 監査結果 */
  KANSA_RESULT_TITLE: 'label.kansa.result_title',
  /** 監査結果登録 */
  KANSA_RESULT_REGISTER_TITLE: 'label.kansa.result_register_title',
  /** <div style='padding-Top: 8px; width: 100%; display: flex; flex-wrap: wrap;'><div style='font-weight: bold;'>一時保存／登録</div></div>\n    <div style='margin: 0 0 8px 8px'>・担当者の方は、一時保存ボタンを押下してください。</div>\n    <div style='margin: 0 0 8px 8px'>・登録ボタンは、押下すると作成完了となるため、責任者の方が押下してください。</div> */
  KANSA_RESULT_REGISTER_HELP: 'label.kansa.result_register_help',
  /** 監査結果表示 */
  KANSA_RESULT_REFER_TITLE: 'label.kansa.result_refer_title',
  /** 前年度 監査結果表示 */
  KANSA_RESULT_REFER_ZENNENDO_TITLE: 'label.kansa.result_refer_zennendo_title',
  /** 監査結果登録結果 */
  KANSA_RESULT_RESULT_TITLE: 'label.kansa.result_result_title',
  /** 確認結果 */
  KANSA_RESULT_VERIFICATION_RESULT: 'label.kansa.result_Verification_result',
  /** 前年度発見事項分類 */
  KANSA_RESULT_ZENNENDO_HAKKEN_JIKO_BUNRUI: 'label.kansa.result_zennendo_hakken_jiko_bunrui',
  /** 前年度発見事項 */
  KANSA_RESULT_ZENNENDO_HAKKEN_JIKO: 'label.kansa.result_zennendo_hakken_jiko',
  /** 報告日 */
  KANSA_RESULT_REPORT_DATE: 'label.kansa.result_report_date',
  /** 報告先 */
  KANSA_RESULT_REPORT_NAME: 'label.kansa.result_report_name',
  /** 承認日 */
  KANSA_RESULT_SHONIN_DATE: 'label.kansa.result_shonin_date',
  /** 承認者 */
  KANSA_RESULT_SHONINSHA: 'label.kansa.result_shoninsha',
  /** 監査結果総括 */
  KANSA_RESULT_KEKKA_SOKATSU: 'label.kansa.result_kekka_sokatsu',
  /** 総合評価 */
  KANSA_RESULT_SOGO_HYOKA: 'label.kansa.result_sogo_hyoka',
  /** 内部監査実施日時 */
  KANSA_RESULT_KANSA_JISSI_DATE: 'label.kansa.result_kansa_jissi_date',
  /** 内部監査実施場所 */
  KANSA_RESULT_KANSA_JISSI_PLACE: 'label.kansa.result_kansa_jissi_place',
  /** 総括 */
  KANSA_RESULT_SOKATSU: 'label.kansa.result_sokatsu',
  /** 前年度 改善の機会・不適合（是正）事項フォローアップ */
  KANSA_RESULT_ZENNENDO_FOLLOWUP: 'label.kansa.result_zennendo_followup',
  /** 本年度のグッドポイント */
  KANSA_RESULT_HONNENDO_GOODPOINT: 'label.kansa.result_honnendo_goodpoint',
  /** 本年度の改善の機会 */
  KANSA_RESULT_HONNENDO_KAIZEN: 'label.kansa.result_honnendo_kaizen',
  /** 本年度の不具合 */
  KANSA_RESULT_HONNENDO_FUGUAI: 'label.kansa.result_honnendo_fuguai',
  /** 前年度 改善の機会・不適合（是正）事項フォローアップ */
  KANSA_RESULT_HONNENDO_HUTEKIGO: 'label.kansa.result_honnendo_hutekigo',
  /** 監査部門コメント */
  KANSA_RESULT_KANSABUMON_COMMENT: 'label.kansa.result_kansabumon_comment',
  /** 一時保存 */
  KANSA_RESULT_TEMPORARILY_STORE: 'label.kansa.result_temporarily_store',
  /** 監査概要 */
  KANSA_RESULT_GAIYO: 'label.kansa.result_gaiyo',
  /** グッドポイント */
  KANSA_RESULT_GOODPOINT: 'label.kansa.result_goodpoint',
  /** 本年度の不適合 */
  KANSA_RESULT_HONNENDO_FUTEKIGO: 'label.kansa.result_honnendo_futekigo',
  /** 判断の根拠 */
  KANSA_RESULT_HANDAN_KONKYO: 'label.kansa.result_handan_konkyo',
  /** 判断結果 */
  KANSA_RESULT_HANDAN_KEKKA: 'label.kansa.result_handan_kekka',
  /** 対策例 */
  KANSA_RESULT_TAISAKUREI: 'label.kansa.result_taisakurei',
  /** リスク */
  KANSA_RESULT_RISK: 'label.kansa.result_risk',
  /** 「前年度 改善の機会・不適合（是正）事項フォローアップ」はありません。 */
  KANSA_RESULT_FOLLOWUP_NODATA: 'label.kansa.result_followup_nodata',
  /** 「{0}」に該当する事項はありません。 */
  KANSA_RESULT_HONNENDO_NODATA: 'label.kansa.result_honnendo_nodata',
  /** 該当する成熟度評価がありません。 */
  KANSA_RESULT_SEIJUKUDO_NODATA: 'label.kansa.result_seijukudo_nodata',
  /** 前回から成熟度の評価が変わっているため、一時保存または登録を行ってください。<br/><br/>新しいコメントに変更しますか？(OKを押すとコメントが変わります) */
  KANSA_RESULT_SEIJUKUDO_CHECK: 'label.kansa.result_seijukudo_check',
  /** 他のユーザが成熟度の評価を変更したため、登録を行えません。\n一覧から再選択してください。 */
  KANSA_RESULT_SEIJUKUDO_CHECK_REGIST: 'label.kansa.result_seijukudo_check_regist',
  /** 監査回答時の情報を取得できなかったため、一時保存・登録を行えません。\n一覧から再選択して情報を取得し直してください。 */
  KANSA_RESULT_ANSDATA_NULL_CHECK: 'label.kansa.result_ansdata_null_check',
  /** 他のユーザが作成完了としているため、一時保存を行えません。\n・変更した内容で保存する場合は登録ボタンを押下してください。\n・他のユーザの更新内容を確認する場合は一覧から再選択してください。 */
  KANSA_RESULT_TEMP_SAVE_CHECK: 'label.kansa.result_temp_save_check',
  /** 他のユーザが監査回答を変更したため、{0}を行えません。\n一覧から再選択してください。 */
  KANSA_RESULT_REGISTER_CHECK: 'label.kansa.result_register_check',
  /** 登録内容に誤りがある場合は、再度、登録を行ってください。 */
  KANSA_RESULT_REGISTERED_MESSAGE_SUPPLEMENT: 'label.kansa.result_registered_message_supplement',
  /** 監査結果を一時保存しました。 */
  KANSA_RESULT_TEMP_SAVE: 'label.kansa.result_temp_save',
  /** 000 */
  KANSA_RESULT_CHOSA_COLUMN_CD: 'label.kansa.result_chosa_column_cd',
  /** 総合評価コメント */
  KANSA_RESULT_COMMENT_HEDER_SOGOHYOKA: 'label.kansa.result_comment_heder_sogohyoka',
  /** カテゴリ別評価コメント */
  KANSA_RESULT_COMMENT_HEDER_CATEGORY: 'label.kansa.result_comment_heder_category',
  /** ［%s］について、 */
  KANSA_RESULT_CHOSA_COLUMN_NM: 'label.kansa.result_chosa_column_nm',
  /** {0}年度の内部監査は、現在準備中です。 */
  KANSA_PREPARATION_MESSAGE: 'label.kansa.preparation_message',
  /** [内部監査]被監査部門回答登録 （{0}） */
  KANSA_SEND_MAIL_SUBJECT_ANS: 'label.kansa.send_mail_subject_ans',
  /** [内部監査]指摘事項改善計画、被監査部門責任者評価登録依頼 （{0}） */
  KANSA_SEND_MAIL_SUBJECT_RESULTS: 'label.kansa.send_mail_subject_results',
  /** [内部監査]指摘事項改善計画、被監査部門責任者評価登録 （{0}） */
  KANSA_SEND_MAIL_SUBJECT_EVALUATION: 'label.kansa.send_mail_subject_evaluation',
  /** [内部監査]メール送信失敗 （{0}） */
  KANSA_SEND_MAIL_SUBJECT_FAILURE: 'label.kansa.send_mail_subject_failure',
  /** TO:{0} 様\nFM:OneNEC事業継続支援システム\n\n以下の監査対象事業について、被監査部門の監査回答が登録されました。\nOneNEC事業継続支援システムより被監査部門の監査回答を確認してください。\n監査対象事業名：{1}\n更新者：{2}({3})\nURL：{4}\n\n本メールは自動配信です。返信できませんのでご注意ください。\nお問い合わせ先：ITサービスポータル(https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91) */
  KANSA_SEND_MAIL_BODY_ANS: 'label.kansa.send_mail_body_ans',
  /** TO:{0} 様\nFM:OneNEC事業継続支援システム\n\n以下の監査対象事業について、監査結果が登録されました。\n被監査部門担当者はOneNEC事業継続支援システムより\n指摘事項改善計画および被監査部門責任者評価を登録してください。\n監査対象事業名：{1}\n更新者：{2}({3})\nURL：{4}\n\n本メールは自動配信です。返信できませんのでご注意ください。\nお問い合わせ先：ITサービスポータル(https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91) */
  KANSA_SEND_MAIL_BODY_RESULTS: 'label.kansa.send_mail_body_results',
  /** TO:{0} 様\nFM:OneNEC事業継続支援システム\n\n以下の監査対象事業について、指摘事項改善計画と被監査部門責任者評価が登録されました。\nOneNEC事業継続支援システムより確認してください。\n監査対象事業名：{1}\n更新者：{2}({3})\nURL：{4}\n\n本メールは自動配信です。返信できませんのでご注意ください。\nお問い合わせ先：ITサービスポータル(https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91) */
  KANSA_SEND_MAIL_BODY_EVALUATION: 'label.kansa.send_mail_body_evaluation',
  /** TO:{0} 様\nFM:OneNEC事業継続支援システム\n\n以下の責任者／担当者へのメール送信が失敗しました。\n連絡が必要な場合は、お手数ですが個別で連絡を行ってください。\n　・{1}\n監査対象事業名：{2}\nURL：{3}\n\n本メールは自動配信です。返信できませんのでご注意ください。\nお問い合わせ先：ITサービスポータル(https://neccorp2.service-now.com/esc?id=sc_cat_item&sys_id=5f80d9c51b1fbd9072e1628b234bcb91) */
  KANSA_SEND_MAIL_BODY_FAILURE: 'label.kansa.send_mail_body_failure',
  /** 　・{0}\n */
  KANSA_SEND_MAIL_ADD_ERR_SHAIN_FORMAT: 'label.kansa.send_mail_add_err_shain_format',
  /** 以下の担当者／責任者は、メールアドレスが設定されていないため、通知メールを送信できませんでした。\n連絡が必要な場合は、お手数ですが個別で連絡を行ってください。\n{0} */
  KANSA_SEND_MAIL_ADD_ERR_ADDRESS_FORMAT: 'label.kansa.send_mail_add_err_address_format',
  /** 以下の担当者／責任者は、メール送信エラーにより、通知メールを送信できませんでした。\n連絡が必要な場合は、お手数ですが個別で連絡を行ってください。\n{0} */
  KANSA_SEND_MAIL_ADD_ERR_SEND_FORMAT: 'label.kansa.send_mail_add_err_send_format',
  /** メールアドレスが設定されている担当者／責任者がいないため、通知メールを送信しませんでした。 */
  KANSA_SEND_MAIL_ERR_MSG_SEND_LIST: 'label.kansa.send_mail_err_msg_send_list',
  /** 通知メールの送信に失敗しました。お手数ですが、システムの管理者へご連絡ください。 */
  KANSA_SEND_MAIL_ERR_MSG_EXCEPTION: 'label.kansa.send_mail_err_msg_exception',
  /** 監査対象事業一覧 */
  KANSA_TARGET_LIST: 'label.kansa.target_list',
  /** 監査対象事業 */
  KANSA_AUDIT_TARGET_BUSINESS: 'label.kansa.audit_target_business',
  /** 監査部門が未設定の監査対象事業のみ表示 */
  KANSA_NOT_SET_AUDIT_DEPARTMENT: 'label.kansa.not_set_audit_department',
  /** 被監査部門が未設定の監査対象事業のみ表示 */
  KANSA_NOT_SET_AUDITED_DEPARTMENT: 'label.kansa.not_set_audited_department',
  /** 監査部門責任者（姓名） */
  KANSA_FULL_NAME_AUDIT_RESPONSIBLE_PERSON: 'label.kansa.full_name_audit_responsible_person',
  /** 監査部門担当者（姓名） */
  KANSA_FULL_NAME_AUDIT_PERSON_IN_CHARGE: 'label.kansa.full_name_audit_person_in_charge',
  /** 被監査部門責任者（姓名） */
  KANSA_FULL_NAME_AUDITED_RESPONSIBLE_PERSON: 'label.kansa.full_name_audited_responsible_person',
  /** 被監査部門担当者（姓名） */
  KANSA_FULL_NAME_AUDITED_PERSON_IN_CHARGE: 'label.kansa.full_name_audited_person_in_charge',
  /** 監査部門 */
  KANSA_AUDIT_DEPARTMENT: 'label.kansa.audit_department',
  /** 被監査部門 */
  KANSA_AUDITED_DEPARTMENT: 'label.kansa.audited_department',
  /** 責任者 */
  KANSA_RESPONSIBLE_PERSON: 'label.kansa.responsible_person',
  /** 担当者 */
  KANSA_PERSON_IN_CHARGE: 'label.kansa.person_in_charge',
  /** 選択対象 */
  KANSA_SELECT: 'label.kansa.select',
  /** 監査実施状況 */
  KANSA_AUDIT_STATUS: 'label.kansa.audit_status',
  /** 責任者／担当者選択 */
  KANSA_SELECT_MEMBER: 'label.kansa.select_member',
  /** 更新・決定 */
  KANSA_REGISTER_MEMBER: 'label.kansa.register_member',
  /** 選択した監査対象事業を削除します。よろしいですか？ */
  KANSA_DELETE_CONFIRM: 'label.kansa.delete_confirm',
  /** 責任者／担当者を登録しました。 */
  KANSA_REGISTER_COMPLATE: 'label.kansa.register_complate',
  /** 監査対象事業を削除しました。 */
  KANSA_DELETE_COMPLATE: 'label.kansa.delete_complate',
  /** 責任者／担当者の選択対象が選択されていません。 */
  KANSA_NON_SELECTED: 'label.kansa.non_selected',
  /** 着手済 */
  KANSA_STARTED: 'label.kansa.started',
  /** 未着手 */
  KANSA_NOT_STARTED: 'label.kansa.not_started',
  /** 監査対象事業の一覧を表示し、監査部門責任者、監査部門担当者、被監査部門責任者、<br/>被監査部門担当者の登録・削除を行うことができます。<br/>\n    <br/>\n    <b>背景色が以下の場合</b><br/>\n    <table>\n      <tr><td rowspan=4 style="background-color:pink;" width="40" height="68"></td></tr>\n      <td>監査部門、または被監査部門が未設定です。変更欄の　\n      <svg class="MuiSvgIcon-root-701" focusable="false" viewBox="0 0 24 24" width="24" height = "24" aria-hidden="true" role="presentation"><path d="M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"></path></svg>    \n  　をクリックして、</td>\n  <tr><td>監査対象事業登録画面から監査対象事業の更新を行ってください。</td></tr>\n  <tr><td>※監査業務が開始されている場合は、変更できなくなります。</td></tr>\n    </table>\n    <br/>\n    <b>監査部門／被監査部門の責任者／担当者の設定を変更する場合</b><br/>\n    ①設定したい欄の選択対象欄をチェックし、責任者／担当者選択ボタンをクリックします。<br/>\n    ※責任者は１人のみ設定可能であるため、既に設定されている場合は削除してから設定する必要があります。<br/>\n    ②表示された利用者選択画面で利用者を選択すると一覧に設定されます。<br/>\n    ※画面に設定した時点ではまだ登録されていません。<br/>\n    ③画面の設定内容を確認し、右下の責任者／担当者登録ボタンをクリックして登録を行います。<br/>\n    <br/>   \n    <b>監査対象事業を削除する場合</b><br/>\n    削除したい監査対象事業の削除欄をチェックし、右下の削除ボタンをクリックします。<br/>\n    ※監査業務が開始されている場合は、削除できなくなります。 */
  KANSA_TARGETLIST_HELP: 'label.kansa_targetlist_help',
  /** 監査部門選択 */
  KANSA_AUDIT_DEPARTMENT_SELECT: 'label.kansa.audit_department_select',
  /** 被監査部門選択 */
  KANSA_AUDITED_DEPARTMENT_SELECT: 'label.kansa.audited_department_select',
  /** ※{0}年度監査部門 */
  KANSA_AUDIT_PREV_YEAR_INFO: 'label.kansa.audit_prev_year_info',
  /** ※{0}年度被監査部門 */
  KANSA_AUDITED_PREV_YEAR_INFO: 'label.kansa.audited_prev_year_info',
  /** 以下の監査対象事業は既に監査回答されているため、削除できません。{0} */
  KANSA_ANSWERD_DATA: 'label.kansa.answerd_data',
  /** 監査報告サマリ */
  KANSA_REPORT_SUMMARY: 'label.kansa.report_summary',
  /** 監査報告書 */
  KANSA_REPORT_SEARCH: 'label.kansa.report_search',
  /** 監査完了件数 */
  KANSA_COMPLETE_COUNTS: 'label.kansa.complete_counts',
  /** 作成状況 */
  KANSA_REPORT_CREATION_STATUS: 'label.kansa.report_creation_status',
  /** 評価状況 */
  KANSA_REPORT_EVALUATION_STATUS: 'label.kansa.report_evaluation_status',
  /** 監査報告書登録 */
  KANSA_REPORT_REGISTER: 'label.kansa.report_register',
  /** 監査報告書登録結果 */
  KANSA_REPORT_REGISTER_RESULT: 'label.kansa.report_register_result',
  /** 監査報告書表示 */
  KANSA_REPORT_REFER: 'label.kansa.report_refer',
  /** 監査報告詳細 */
  KANSA_REPORT_DETAIL: 'label.kansa.report_detail',
  /** 監査報告書評価登録 */
  KANSA_REPORT_EVALUATION_REGISTER: 'label.kansa.report_evaluation_register',
  /** 監査報告書評価登録結果 */
  KANSA_REPORT_EVALUATION_REGISTER_RESULT: 'label.kansa.report_evaluation_register_result',
  /** 監査報告書評価表示 */
  KANSA_REPORT_EVALUATION_REFER: 'label.kansa.report_evaluation_refer',
  /** 最終更新者 */
  KANSA_REPORT_LAST_UPD_USER: 'label.kansa.report_last_upd_user',
  /** 最終更新日 */
  KANSA_REPORT_LAST_UPD_DATE: 'label.kansa.report_last_upd_date',
  /** 成熟度評価サマリ */
  KANSA_SEJUKUDO_HYOKA_SUMMARY: 'label.kansa.sejukudo_hyoka_summary',
  /** 監査部門コメント */
  KANSA_KANSABUMON_COMMENT: 'label.kansa.kansabumon_comment',
  /** 一時保存 */
  KANSA_TEMPORARILY_SAVE: 'label.kansa.temporarily_save',
  /** 監査報告書を一時保存しました。 */
  KANSA_REPORT_TEMPORARILY_SAVED: 'label.kansa.report_temporarily_saved',
  /** 監査報告書評価を一時保存しました。 */
  KANSA_REPORT_EVALUATION_TEMPORARILY_SAVED: 'label.kansa.report_evaluation_temporarily_saved',
  /** 記入者 */
  KANSA_KINYUSHA: 'label.kansa.kinyusha',
  /** NEC関係部門長・関係会社社長コメント */
  KANSA_REPORT_EV_COMMENT: 'label.kansa.report_ev_comment',
  /** 報告書を表示 */
  KANSA_SHOW_REPORT: 'label.kansa.show_report',
  /** 不適合 */
  KANSA_HKN_BNR_GRP_FUTEKIGO: 'label.kansa.hkn_bnr_grp_futekigo',
  /** 改善の機会 */
  KANSA_HKN_BNR_GRP_KAIZEN: 'label.kansa.hkn_bnr_grp_kaizen',
  /** 重大 */
  KANSA_HKN_BNR_JUDAI: 'label.kansa.hkn_bnr_judai',
  /** 軽微 */
  KANSA_HKN_BNR_KEIBI: 'label.kansa.hkn_bnr_keibi',
  /** 観察 */
  KANSA_HKN_BNR_KANSATSU: 'label.kansa.hkn_bnr_kansatsu',
  /** 推奨 */
  KANSA_HKN_BNR_SUISHO: 'label.kansa.hkn_bnr_suisho',
  /** 該当データが存在しません。 */
  KANSA_TARGET_JIGYO_NOT_FOUND_MESSAGE: 'label.kansa.target_jigyo_not_found_message',
  /** 該当する監査対象事業がありません。 */
  KANSA_REPORT_TARGET_JIGYO_NOT_FOUND: 'label.kansa.report_target_jigyo_not_found',
  /** 該当する成熟度評価がありません。 */
  KANSA_REPORT_SEIJUKUDO_HYOKA_NOT_FOUND: 'label.kansa.report_seijukudo_hyoka_not_found',
  /** 未来日は入力できません。 */
  KANSA_UNABLE_ENTER_FUTURE_DATE: 'label.kansa.unable_enter_future_date',
  /** 登録完了通知 */
  KANSA_PUSH_COMPLETE_REGISTER: 'label.kansa.push_complete_register',
  /** {0}にメールで通知する */
  KANSA_PUSH_MAIL: 'label.kansa.push_mail',
  /** （{0}に登録完了通知メールが自動送信されます） */
  KANSA_SEND_MAIL_CONFIRM: 'label.kansa.send_mail_confirm',
  /** （計画状況が未完了です。監査部門に登録完了通知メールは送信されません。） */
  KANSA_SEND_MAIL_CONFIRM_SHITEKI_NO_PLAN: 'label.kansa.send_mail_confirm_shiteki_no_plan',
  /** BCP策定 */
  BCM_BCP_FORMULATION_TITLE: 'label.bcm.bcp_formulation_title',
  /** ドキュメント管理（自然災害） */
  BCM_DOCUMENT_MNG_NATURAL_DISASTERS: 'label.bcm.document_mng_natural_disasters',
  /** ドキュメント管理 */
  BCM_DOCUMENT_MNG: 'label.bcm.document_mng',
  /** 対象事業利用ユーザ追加 */
  BCM_BCM_PERMISSION_SETTING: 'label.bcm.bcm_permission_setting',
  /** 対策本部権限のユーザに対して、利用可能なBCP対象事業を追加することができます。<br/>\n設定した会社／組織の全てのBCP対象事業が利用可能となります。 */
  BCM_BCM_PERMISSION_SETTING_HELP: 'label.bcm.bcm_permission_setting_help',
  /** 会社／組織追加 */
  BCM_ADD_KAISHA_SOSHIKI: 'label.bcm.add_kaisha_soshiki',
  /** 会社／組織削除 */
  BCM_DELETE_KAISHA_SOSHIKI: 'label.bcm.delete_kaisha_soshiki',
  /** BCP対象事業変更 */
  BCM_CHANGE_BCP_TGT_JIGYO: 'label.bcm.change_bcp_tgt_jigyo',
  /** 利用可能会社／組織名 */
  BCM_AVAILABLE_KAISHA_SOSHIKI: 'label.bcm.available_kaisha_soshiki',
  /** 利用可能BCP対象事業名 */
  BCM_AVAILABLE_BCP_TGT_JIGYO: 'label.bcm.available_bcp_tgt_jigyo',
  /** 利用許可設定が変更されていません。 */
  BCM_PERMISSION_SETTING_NOT_CHANGED: 'label.bcm.permission_setting_not_changed',
  /** 選択した会社／組織は既に追加されています。 */
  BCM_ALREADY_ADD_KAISHA_SOSHIKI_MESSAGE: 'label.bcm.already_add_kaisha_soshiki_message',
  /** 選択した会社／組織は利用可能なため、追加できません。 */
  BCM_REFFER_ADD_KAISHA_SOSHIKI_MESSAGE: 'label.bcm.reffer_add_kaisha_soshiki_message',
  /** 実施方針 */
  BCM_BCP_JISSHI_POLICY: 'label.bcm.bcp_jisshi_policy',
  /** 訓練実施要領・訓練シナリオ登録 */
  BCM_BCP_KUNREN_GUIDANCE: 'label.bcm.bcp_kunren_guidance',
  /** 訓練実施要領・訓練シナリオ登録結果 */
  BCM_BCP_KUNREN_GUIDANCE_REGISTER_RESULT: 'label.bcm.bcp_kunren_guidance_register_result',
  /** 訓練実施要領・訓練シナリオ削除結果 */
  BCM_BCP_KUNREN_GUIDANCE_DELETE_RESULT: 'label.bcm.bcp_kunren_guidance_delete_result',
  /** シナリオ方針 */
  BCM_BCP_SCENARIO_POLICY: 'label.bcm.bcp_scenario_policy',
  /** 実施予定日時 */
  BCM_BCP_IMPLEMENTATION_YOTEI_ATE: 'label.bcm.bcp_implementation_yotei_ate',
  /** シナリオ登録 */
  BCM_BCP_SCENARIO_REGISTER: 'label.bcm.bcp_scenario_register',
  /** ＮＥＣ中央のシナリオとして登録する */
  BCM_BCP_NEC_SCENARIO_CHECK: 'label.bcm.bcp_nec_scenario_check',
  /** 各社／各NEC関係部門共通のシナリオとして登録する */
  BCM_BCP_BU_SCENARIO_CHECK: 'label.bcm.bcp_bu_scenario_check',
  /** 登録する */
  BCM_SCENARIO_REGIST: 'label.bcm.scenario_regist',
  /** 登録しない */
  BCM_SCENARIO_NOT_REGIST: 'label.bcm.scenario_not_regist',
  /** 詳細表示 */
  BCM_DETAIL_VIEW: 'label.bcm.detail_view',
  /** ドキュメント管理（発動後レビュー） */
  BCM_DOCUMENT_MNG_AFTER_ACTIVATION_REVIEW: 'label.bcm.document_mng_after_activation_review',
  /** BCP対象事業登録 */
  BCM_BCP_TGT_JIGYO_REGISTER: 'label.bcm.bcp_tgt_jigyo_register',
  /** BCP対象事業登録結果 */
  BCM_BCP_TGT_JIGYO_REGISTER_RESULT: 'label.bcm.bcp_tgt_jigyo_register_result',
  /** BCP対象事業更新 */
  BCM_BCP_TGT_JIGYO_UPDATE: 'label.bcm.bcp_tgt_jigyo_update',
  /** BCP対象事業更新結果 */
  BCM_BCP_TGT_JIGYO_UPDATE_RESULT: 'label.bcm.bcp_tgt_jigyo_update_result',
  /** 対象組織 */
  BCM_BCP_TGT_ORGANIZATION: 'label.bcm.bcp_tgt_organization',
  /** 組織がなくなっています。再選択してください。 */
  BCM_BCP_TGT_ORGANIZATION_MSG: 'label.bcm.bcp_tgt_organization_msg',
  /** 組織変更等により現在存在しない組織は「{0}」と表示されています。対象組織を変更してください。 */
  BCM_BCP_TGT_ORGANIZATION_HINT: 'label.bcm.bcp_tgt_organization_hint',
  /** 対象組織選択 */
  BCM_BCP_TGT_ORGANIZATION_SELECT: 'label.bcm.bcp_tgt_organization_select',
  /** BCP対象事業コードは既に登録済みです。 */
  BCM_BCP_THIS_TGT_BCP_CODE_ALREADY_REGISTERED: 'label.bcm.bcp_this_tgt_bcp_code_already_registered',
  /** 訓練 */
  BCM_KUNREN: 'label.bcm.kunren',
  /** ドキュメント管理（訓練） */
  BCM_DOCUMENT_MNG_KUNREN: 'label.bcm.document_mng_kunren',
  /** 発動後レビュー */
  BCM_REVIEW: 'label.bcm.review',
  /** 内部監査実施要領 */
  BCM_KANSA_GUIDELINE: 'label.bcm.kansa_guideline',
  /** 関連情報 */
  BCM_RELATED_INFORMATION: 'label.bcm.related_information',
  /** 訓練中期計画登録 */
  BCM_KUNREN_MEDPLAN_TITLE: 'label.bcm.kunren.medplan_title',
  /** 訓練中期計画登録結果 */
  BCM_KUNREN_MEDPLAN_RESULT_TITLE: 'label.bcm.kunren.medplan_result_title',
  /** 訓練中期計画 */
  BCM_KUNREN_MEDPLAN: 'label.bcm.kunren.medplan',
  /** 年度 */
  BCM_KUNREN_MEDPLAN_KUNREN_NENDO: 'label.bcm.kunren.medplan_kunren_nendo',
  /** 参加者に被災・行動の前提イメージを持たせるため、訓練で対象とするリスクを設定する。<br/>参加者に対応策が思いつかないようなリスクは設定しない方が望ましい。<br/><br/>■地震<br/>　震度6強の地震とそれが発生した際の地域情勢・インフラ被災を想定した対象リスク。<br/>■洪水<br/>　洪水による被災を想定した対象リスク。台風、局地豪雨、大雪もこのカテゴリーに含める。<br/>■感染症<br/>　季節性インフルエンザ（A型、B型等）ではなく、新型インフルエンザ等強毒性感染症の発生を想定した対象リスク。<br/>■その他<br/>　地震、洪水、感染症以外の災害を想定した対象リスク。津波、テロ、火災、噴火、原子力事故など。 */
  BCM_KUNREN_MEDPLAN_TARGETRISK_HINT: 'label.bcm.kunren.medplan_targetrisk_hint',
  /** リスク発生時から平常の業務体制に戻るまでの時期により、行動すべき内容が変わるため、今回の訓練で想定する時期を設定する。<br/>感染症は時間軸で区切らずに、その広まり具合で時期を分ける。<br/><br/>■初動<br/>　感染症以外の自然災害のリスク発生後から初期対応を行うまで時期を想定。<br/>　主に発生から3日間。<br/>■復旧<br/>　感染症以外の自然災害のリスク発生後、初動が一段落し本格的に復旧業務を行う時期を想定。<br/>　主にリスク発生後3～10日目。<br/>　（早期対応業務では6H～5日目をさす場合もある）<br/>■国内感染症早期<br/>　海外で発生した強毒性の感染症が国内でも発生し始めた時期を想定。<br/>　感染者は公的機関から強制隔離措置を取られる。また、必要に応じ職場閉鎖が行われる時期。<br/>■国内感染期（蔓延期）<br/>　感染が拡大し国が蔓延期を宣言した時期を想定。<br/>　少ない人数での業務の維持・管理が求められる。 */
  BCM_KUNREN_MEDPLAN_KUNRENSEASON_HINT: 'label.bcm.kunren.medplan_kunrenseason_hint',
  /** 当該訓練年度の対象リスクを選択してください。 */
  BCM_KUNREN_MEDPLAN_TGTRISK_ERR: 'label.bcm.kunren_medplan_tgtrisk_err',
  /** 訓練中期計画未登録 */
  BCM_KUNREN_NO_REGISTERED: 'label.bcm.kunren_no_registered',
  /** 訓練実施報告登録 */
  BCM_KUNREN_REPORT_REGISTER: 'label.bcm.kunren_report_register',
  /** 訓練実施報告登録結果 */
  BCM_KUNREN_REPORT_REGISTER_RESULT: 'label.bcm.kunren_report_register_result',
  /** 訓練実施報告削除結果 */
  BCM_KUNREN_REPORT_DELETE_RESULT: 'label.bcm.kunren_report_delete_result',
  /** 実施詳細 */
  BCM_KUNREN_REPORT_JISSHI_DETAIL: 'label.bcm.kunren_report_jisshi_detail',
  /** 参加者名等ファイル名が重複しています。 */
  BCM_KUNREN_REPORT_FILE_DUPLICATE_MESSAGE: 'label.bcm.kunren_report_file_duplicate_message',
  /** シナリオ方針が「NEC中央のシナリオで訓練する」の場合、NEC中央のシナリオが更新されたら実施詳細に反映されます。<br/>\n    シナリオ方針が「各社／各NEC関係部門共通のシナリオで訓練する」の場合、各社／各NEC関係部門共通のシナリオが更新されたら実施詳細に反映されます。 */
  BCM_KUNREN_REPORT_JISSHI_DETAIL_HELP: 'label.bcm.kunren_report_jisshi_detail_help',
  /** 訓練の進める上でのシナリオを選択する。<br/>\n    <br/>\n    ■NEC中央のシナリオで訓練する<br/>　NEC中央事業継続対策本部が作成するシナリオで訓練を行う場合、これを選択する。<br/>\n    ■各社／各NEC関係部門共通のシナリオで訓練する<br/>　各社／各NEC関係部門の共通訓練方針に基づいて訓練をする場合、これを選択する。<br/>\n    ■部門独自のシナリオで訓練する<br/>　各部門が独自の検証項目、検証事項を訓練する場合、これを選択する。 */
  BCM_KUNREN_SCENARIO_POLICY_HELP: 'label.bcm.kunren_scenario_policy_help',
  /** 課題の抽出 */
  BCM_KUNREN_REPORT_TASK_TITLE: 'label.bcm.kunren_report_task_title',
  /** 訓練で検証し判明した課題について入力する。<br/>\n    （入力した内容は今後「課題管理表」に反映予定）<br/>\n    複数の課題を入力する場合は、「課題入力欄追加」ボタンを押下する。 */
  BCM_KUNREN_REPORT_TASK_TITLE_HELP: 'label.bcm.kunren_report_task_title_help',
  /** BCP訓練チェックシート集計結果 */
  BCM_KUNREN_REPORT_CHECKSHEET_RESULT: 'label.bcm.kunren_report_checksheet_result',
  /** 別途訓練チェックシートで訓練後のヒアリングを行い、訓練の理解度、有効性を記載する。<br/>\n    ・「理解度」「有効性」欄は3点満点評価（1：不十分である、2：一応、十分であるが改善すべき課題がある、3：十分である）<br/>\n    ・チーム複数参加者の平均点2.7以上は青字表記、2.3以下は赤字表記とする */
  BCM_KUNREN_REPORT_CHECKSHEET_RESULT_HELP: 'label.bcm.kunren_report_checksheet_result_help',
  /** 訓練目的達成度評価、対策本部長コメント */
  BCM_KUNREN_REPORT_COMMENT_TITLE: 'label.bcm.kunren_report_comment_title',
  /** 実施日時 */
  BCM_KUNREN_JISSHI_DT: 'label.bcm.kunren_jisshi_dt',
  /** 対象リスク */
  BCM_KUNREN_TGT_RISK: 'label.bcm.kunren_tgt_risk',
  /** 参加者に被災・行動の前提イメージを持たせるため、訓練で対象とするリスクを設定する。<br/>\n    参加者に対応策が思いつかないようなリスクは設定しない方が望ましい。<br/>\n    <br/>\n    ■地震<br/>\n    　震度6強の地震とそれが発生した際の地域情勢・インフラ被災を想定した対象リスク。<br/>\n    ■洪水<br/>\n    　洪水による被災を想定した対象リスク。台風、局地豪雨、大雪もこのカテゴリーに含める。<br/>\n    ■感染症<br/>\n    　季節性インフルエンザ（A型、B型等）ではなく、新型インフルエンザ等強毒性感染症の発生を想定した対象リスク。<br/>\n    ■その他<br/>\n    　地震、洪水、感染症以外の災害を想定した対象リスク。津波、テロ、火災、噴火、原子力事故など。<br/> */
  BCM_KUNREN_REPORT_TGT_RISK_HINT: 'label.bcm.kunren_report_tgt_risk_hint',
  /** 対象リスク詳細 */
  BCM_KUNREN_TGT_RISK_DETAIL: 'label.bcm.kunren_tgt_risk_detail',
  /** 訓練の対象となるリスク（地震、洪水、感染症、その他）を具体的に入力する。<br/>\n    例：地震　○○地域直下地震、東海地震、首都直下地震など<br/>\n    　　洪水　○○川の氾濫、　反乱地域・・・・<br/>\n    　　感染症　○○病、致死率△％・・・<br/> */
  BCM_KUNREN_REPORT_TGT_RISK_DETAIL_HINT: 'label.bcm.kunren_report_tgt_risk_detail_hint',
  /** 訓練時期 */
  BCM_KUNREN_PERIOD: 'label.bcm.kunren_period',
  /** リスク発生時から平常の業務体制に戻るまでの時期により、行動すべき内容が変わるため、今回の訓練で想定する時期を設定する。<br/>\n    感染症は時間軸で区切らずに、その広まり具合で時期を分ける。<br/>\n    <br/>\n    ■初動<br/>\n    　感染症以外の自然災害のリスク発生後から初期対応を行うまで時期を想定。<br/>\n    　主に発生から3日間。<br/>\n    ■復旧<br/>\n    　感染症以外の自然災害のリスク発生後、初動が一段落し本格的に復旧業務を行う時期を想定。<br/>\n    　主にリスク発生後3～10日目。<br/>\n    　（早期対応業務では6H～5日目をさす場合もある）<br/>\n    ■国内感染症早期<br/>\n    　海外で発生した強毒性の感染症が国内でも発生し始めた時期を想定。<br/>\n    　感染者は公的機関から強制隔離措置を取られる。また、必要に応じ職場閉鎖が行われる時期。<br/>\n    ■国内感染期（蔓延期）<br/>\n    　感染が拡大し国が蔓延期を宣言した時期を想定。<br/>\n    　少ない人数での業務の維持・管理が求められる。 */
  BCM_KUNREN_REPORT_PERIOD_HINT: 'label.bcm.kunren_report_period_hint',
  /** 訓練目的 */
  BCM_KUNREN_PURPOSE: 'label.bcm.kunren_purpose',
  /** 訓練内容 */
  BCM_KUNREN_CONTENT: 'label.bcm.kunren_content',
  /** 補足事項 */
  BCM_KUNREN_SUPPLEMENT: 'label.bcm.kunren_supplement',
  /** 当該訓練年度の対象リスク */
  BCM_KUNREN_YEAR_TGT_RISK: 'label.bcm.kunren_year_tgt_risk',
  /** 参加人数 */
  BCM_KUNREN_PARTICIPANT: 'label.bcm.kunren_participant',
  /** 参加者名等 */
  BCM_KUNREN_PARTICIPANT_LIST: 'label.bcm.kunren_participant_list',
  /** 訓練に参加した人の名簿。EXCEL等で一覧が望ましい。<br/>\n    部門全員であれば「部門全員　○名」という記述でも良いが、対策本部員などであれば、対策本部員全員の名前に、参加者は○をするなどの工夫をすること。 */
  BCM_KUNREN_REPORT_PARTICIPANT_LIST_HINT: 'label.bcm.kunren_report_participant_list_hint',
  /** 訓練成果（グッドポイント） */
  BCM_KUNREN_RESULT: 'label.bcm.kunren_result',
  /** 対応部門 */
  BCM_KUNREN_TASK_BUMON: 'label.bcm.kunren_task_bumon',
  /** 種別 */
  BCM_KUNREN_TASK_KIND: 'label.bcm.kunren_task_kind',
  /** 対応の方向性 */
  BCM_KUNREN_TASK_TAIO: 'label.bcm.kunren_task_taio',
  /** 完了予定時期 */
  BCM_KUNREN_TASK_SCHEDULE: 'label.bcm.kunren_task_schedule',
  /** 課題 */
  BCM_KUNREN_TASK: 'label.bcm.kunren_task',
  /** 課題入力欄を追加 */
  BCM_KUNREN_TASK_ADD: 'label.bcm.kunren_task_add',
  /** チーム名 */
  BCM_KUNREN_CHECKSHEET_TEAM_NM: 'label.bcm.kunren_checksheet_team_nm',
  /** 回答数 */
  BCM_KUNREN_CHECKSHEET_REPLY: 'label.bcm.kunren_checksheet_reply',
  /** 理解度 */
  BCM_KUNREN_CHECKSHEET_UNDERSTAND: 'label.bcm.kunren_checksheet_understand',
  /** 有効性 */
  BCM_KUNREN_CHECKSHEET_EFFECT: 'label.bcm.kunren_checksheet_effect',
  /** コメント */
  BCM_KUNREN_CHECKSHEET_COMMENT: 'label.bcm.kunren_checksheet_comment',
  /** チーム追加 */
  BCM_KUNREN_CHECKSHEET_TEAM_ADD: 'label.bcm.kunren_checksheet_team_add',
  /** 全体の平均 */
  BCM_KUNREN_CHECKSHEET_AVERAGE: 'label.bcm.kunren_checksheet_average',
  /** （参考）前回評価 */
  BCM_KUNREN_CHECKSHEET_PREVIOUS: 'label.bcm.kunren_checksheet_previous',
  /** 訓練目的達成度評価 */
  BCM_KUNREN_EVALUATION: 'label.bcm.kunren_evaluation',
  /** 対策本部長コメント */
  BCM_KUNREN_EVALUATION_COMMENT: 'label.bcm.kunren_evaluation_comment',
  /** 参加者名等 */
  BCM_KUNREN_PARTICIPANT_ETC: 'label.bcm.kunren_participant_etc',
  /** 訓練中期計画（進捗状況） */
  BCM_KUNREN_MEDPLAN_STS: 'label.bcm.kunren_medplan_sts',
  /** 訓練中期計画（登録日） */
  BCM_KUNREN_MEDPLAN_REG_DT: 'label.bcm.kunren_medplan_reg_dt',
  /** 訓練実施要領/訓練シナリオ（進捗状況） */
  BCM_KUNREN_GUIDELINES_STS: 'label.bcm.kunren_guidelines_sts',
  /** 訓練実施要領/訓練シナリオ（登録日） */
  BCM_KUNREN_GUIDELINES_REG_DT: 'label.bcm.kunren_guidelines_reg_dt',
  /** 訓練実施報告（進捗状況） */
  BCM_KUNREN_REPORT_STS: 'label.bcm.kunren_report_sts',
  /** 訓練実施報告（登録日） */
  BCM_KUNREN_REPORT_REG_DT: 'label.bcm.kunren_report_reg_dt',
  /** 訓練補足資料（ファイル名） */
  BCM_KUNREN_HOSOKU_DOC_NM: 'label.bcm.kunren_hosoku_doc_nm',
  /** 訓練補足資料（説明書き） */
  BCM_KUNREN_HOSOKU_DOC_NOTE: 'label.bcm.kunren_hosoku_doc_note',
  /** 訓練補足資料（進捗状況） */
  BCM_KUNREN_HOSOKU_DOC_STS: 'label.bcm.kunren_hosoku_doc_sts',
  /** 訓練補足資料（アップロード日時） */
  BCM_KUNREN_HOSOKU_DOC_UP_DT: 'label.bcm.kunren_hosoku_doc_up_dt',
  /** 訓練課題をCSVファイル形式で出力 */
  BCM_KUNREN_TASK_CSV_DOWNLOAD_LABEL: 'label.bcm.kunren_task_csv_download_label',
  /** 訓練シナリオ */
  BCM_KUNREN_SCENARIO: 'label.bcm.kunren_scenario',
  /** BCP対象事業検索 */
  BCM_BCP_TGT_JIGYO_SEARCH: 'label.bcm.bcp_tgt_jigyo_search',
  /** BCP対象事業削除 */
  BCM_BCP_TGT_JIGYO_DELETE: 'label.bcm.bcp_tgt_jigyo_delete',
  /** BCP対象事業削除結果 */
  BCM_BCP_TGT_JIGYO_DELETE_RESULT: 'label.bcm.bcp_tgt_jigyo_delete_result',
  /** 他のユーザが登録済としているため、一時保存を行えません。\n・変更した内容で保存する場合は登録ボタンを押下してください。\n・他のユーザの更新内容を確認する場合は一覧から再選択してください。 */
  BCM_TEMP_SAVE_CHECK: 'label.bcm.temp_save_check',
  /** 英数3桁で「BCP対象事業参照」より、既存の番号以外を設定してください。 */
  BCM_BCP_TGT_JIGYO_CD_HINT: 'label.bcm.bcp_tgt_jigyo_cd_hint',
  /** 対策本部員参集支援マップ作成 */
  BCM_BCP_MAP_CREATE: 'label.bcm.bcp_map_create',
  /** 対策本部員参集支援マップ */
  BCM_BCM_MAP: 'label.bcm.bcm_map',
  /** 対策本部員参集支援マップ（マップ作成） */
  BCM_BCM_MAP_MAP_CREATE: 'label.bcm.bcm_map_map_create',
  /** BCP検索 */
  BCM_BCP_SEARCH: 'label.bcm.bcp_search',
  /** 対策本部員参集支援マップ（BCP検索） */
  BCM_BCM_MAP_SEARCH: 'label.bcm.bcm_map_search',
  /** マップ情報の詳細を閲覧する場合は、ＢＣＰを検索後に詳細アイコンを押してください。<br/>\n    ※対策本部員参集支援マップ機能を利用している間の操作はログに記録されます。 */
  BCM_BCP_SEARCH_HELP: 'label.bcm.bcp_search_help',
  /** マップ情報編集 */
  BCM_BCM_MAP_EDIT: 'label.bcm.bcm_map_edit',
  /** マップ情報を変更した場合は、「確定」ボタンを押してください。 */
  BCM_BCM_MAP_EDIT_HELP: 'label.bcm.bcm_map_edit_help',
  /** BCP番号 */
  BCM_BCP_NO: 'label.bcm.bcp_no',
  /** 登録人数 */
  BCM_ENROLLMENT: 'label.bcm.enrollment',
  /** 許可人数 */
  BCM_ADMITTEE: 'label.bcm.admittee',
  /** 対策本部設置場所 */
  BCM_HQ_LOCATION: 'label.bcm.hq_location',
  /** 第一候補 */
  BCM_HQ_FIRST_CHOICE_LOCATION: 'label.bcm.hq_first_choice_location',
  /** 第二候補 */
  BCM_HQ_SECOND_CHOICE_LOCATION: 'label.bcm.hq_second_choice_location',
  /** 第三候補 */
  BCM_HQ_THIRD_CHOICE_LOCATION: 'label.bcm.hq_third_choice_location',
  /** 対策本部員役割 */
  BCM_HQ_ROLL: 'label.bcm.hq_roll',
  /** 表示許可 */
  BCM_MAP_DISP_ALLOW: 'label.bcm.map_disp_allow',
  /** 対策本部員が追加されていません。 */
  BCM_HQ_MEMBER_NO_ADDED_MESSAGE: 'label.bcm.hq_member_no_added_message',
  /** 対策本部員追加 */
  BCM_HQ_MEMBER_ADD: 'label.bcm.hq_member_add',
  /** 対策本部設置場所設定 */
  BCM_HQ_LOCATION_SETTING: 'label.bcm.hq_location_setting',
  /** 地図上から任意の位置を指定し、名称を入力して「確定」ボタンを押してください。<br/>\n    拠点の位置や名称を引用する場合は、「拠点選択」ボタンを押してください。 */
  BCM_HQ_LOCATION_SETTING_HELP: 'label.bcm.hq_location_setting_help',
  /** 名称 */
  BCM_HQ_LOCATION_NAME: 'label.bcm.hq_location_name',
  /** ●対策本部員情報 */
  BCM_HQ_MEMBER: 'label.bcm.hq_member',
  /** ●対策本部情報 */
  BCM_BCM_INFORMATION: 'label.bcm.bcm_information',
  /** マップ情報を確定します。よろしいですか？ */
  BCM_BCM_MAP_DETERMINE_MESSAGE: 'label.bcm.bcm_map_determine_message',
  /** 変更された内容は確定されません。よろしいですか？ */
  BCM_BCM_MAP_DETAIL_MESSAGE: 'label.bcm.bcm_map_detail_message',
  /** 追加した対策本部員は、既に登録されています。 */
  BCM_HQ_DUPLICATE_REGISTER: 'label.bcm.hq_duplicate_register',
  /** 未設定 */
  BCM_MAP_DISP_ALLOW_NULL: 'label.bcm.map_disp_allow_null',
  /** マップ印刷 */
  BCM_BCM_MAP_PRINT: 'label.bcm.bcm_map_print',
  /** リスト印刷 */
  BCM_BCM_LIST_PRINT: 'label.bcm.bcm_list_print',
  /** 対策本部員参集支援リスト */
  BCM_BCM_LIST_PRINT_TITLE: 'label.bcm.bcm_list_print_title',
  /** 印刷 */
  BCM_BCM_PRINT: 'label.bcm.bcm_print',
  /** 印刷物には個人情報が含まれるため、取り扱いには特に注意してください。<br/>この操作はログに記録されます。 */
  BCM_BCM_PRINT_CONFIRM: 'label.bcm.bcm_print_confirm',
  /** 対策本部員の姓名を表示する */
  BCM_BCM_MAP_NAME_SWITCH: 'label.bcm.bcm_map_name_switch',
  /** 拠点ごとに同心円の種類を変える */
  BCM_BCM_MAP_TYPE_SWITCH: 'label.bcm.bcm_map_type_switch',
  /** 表示 */
  BCM_BCM_MAP_DISP: 'label.bcm.bcm_map_disp',
  /** BCP番号： */
  BCM_BCM_MAP_BCPNO: 'label.bcm.bcm_map_bcpno',
  /** 備考： */
  BCM_BCM_MAP_NOTE: 'label.bcm.bcm_map_note',
  /** 作成日： */
  BCM_BCM_MAP_CREATE_DAY: 'label.bcm.bcm_map_create_day',
  /** ■ */
  BCM_BCM_MAP_SQUARE: 'label.bcm.bcm_map_square',
  /** 10.0km未満 */
  BCM_BCM_MAP_UNDER10: 'label.bcm.bcm_map_under10',
  /** 10.0 - 14.9km */
  BCM_BCM_MAP_UNDER15: 'label.bcm.bcm_map_under15',
  /** 15.0 - 19.9km */
  BCM_BCM_MAP_UNDER20: 'label.bcm.bcm_map_under20',
  /** 20.0km以上 */
  BCM_BCM_MAP_OVER20: 'label.bcm.bcm_map_over20',
  /** その他 */
  BCM_BCM_MAP_DIS_ETC: 'label.bcm.bcm_map_dis_etc',
  /** 合計 */
  BCM_BCM_MAP_DIS_SUM: 'label.bcm.bcm_map_dis_sum',
  /** 人 */
  BCM_BCM_MAP_HITO: 'label.bcm.bcm_map_hito',
  /** 対策本部長・副本部長 */
  BCM_BCM_MAP_MEMBER_L: 'label.bcm.bcm_map_member_l',
  /** 事務局 */
  BCM_BCM_MAP_MEMBER_M: 'label.bcm.bcm_map_member_m',
  /** その他 */
  BCM_BCM_MAP_MEMBER_S: 'label.bcm.bcm_map_member_s',
  /** 拠点が未選択です。 */
  BCM_BCM_MAP_SITE_NOSELLECT: 'label.bcm.bcm_map_site_nosellect',
  /** 距離別社員情報 */
  BCM_BCM_MAP_DIS_INFO: 'label.bcm.bcm_map_dis_info',
  /** 未選択 */
  BCM_BCM_LIST_PRINT_NODATA: 'label.bcm.bcm_list_print_nodata',
  /** 第一候補拠点との距離 */
  BCM_BCM_LIST_FIRST: 'label.bcm.bcm_list_first',
  /** 第二候補拠点との距離 */
  BCM_BCM_LIST_SECOND: 'label.bcm.bcm_list_second',
  /** 第三候補拠点との距離 */
  BCM_BCM_LIST_THIRD: 'label.bcm.bcm_list_third',
  /** km */
  BCM_BCM_LIST_KM: 'label.bcm.bcm_list_km',
  /** 【関係者外秘】 */
  BCM_BCM_PRINT_GAIHI: 'label.bcm.bcm_print_gaihi',
  /** マップ情報詳細 */
  BCM_BCM_MAP_DETAIL: 'label.bcm.bcm_map_detail',
  /** マップ作成 */
  BCM_BCM_MAP_CREATE: 'label.bcm.bcm_map_create',
  /** 対策本部員を追加する場合は、「対策本部員追加」ボタンを押してください。<br/>\n    また、削除する場合は、削除するユーザにチェックを入れてください。 */
  BCM_HQ_MEMBER_HINT: 'label.bcm.hq_member_hint',
  /** マップ情報を更新しました。 */
  BCM_BCM_MAP_UPDATE_MESSAGE: 'label.bcm.bcm_map_update_message'
};